import imageCompression from 'browser-image-compression';
import { executeSmartDelete, executeSaveContract } from './systemLogic';
import { Toaster, toast } from 'react-hot-toast';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { exportToExcel, importFromExcel, handlePrint } from './excelService';
import { 
  Building, Home, Users, DollarSign, FileText, Settings, LogOut, Plus, Edit, Trash2, Bell,
  MapPin, Menu, X, Star, TrendingUp, CheckCircle, Briefcase, Clock, 
  MessageCircle, ArrowRight, LogIn, User, Phone, Image as ImageIcon, Search, Grid,
  Archive, Palette, Layout, PieChart, Wallet, Activity, Camera, UserPlus, UserCog, 
  Landmark, List as ListIcon, FileCheck, CheckSquare, Download, Upload,
  ClipboardList, Banknote, ShieldCheck, AlertCircle, Mail,
  ChevronLeft, ChevronRight, Scale, Calculator, Percent,
  
  // 💡 أيقونات السوشيال ميديا
  Facebook, Instagram, 
  
  // 💡 أيقونة المشاركة المطلوبة للواتساب
  Share2 ,Zap , Play , Video
} from 'lucide-react';

import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  signInWithPopup, 
  GoogleAuthProvider, 
  onAuthStateChanged, 
  signOut 
} from "firebase/auth";

import { getAnalytics } from "firebase/analytics";
import { 
  getFirestore, collection, getDocs, addDoc, updateDoc, deleteDoc, setDoc, doc, 
  runTransaction, getDoc, onSnapshot, query, where, arrayUnion, arrayRemove , deleteField
} from "firebase/firestore";

import { 
  getStorage, ref, uploadBytes, getDownloadURL, deleteObject 
} from "firebase/storage";

import { Bar, Doughnut } from 'react-chartjs-2';
import { 
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, 
  Tooltip, Legend, ArcElement, LineElement, PointElement 
} from 'chart.js';

ChartJS.register(
  CategoryScale, LinearScale, BarElement, Title, Tooltip, 
  Legend, ArcElement, LineElement, PointElement
);// --- Firebase Configuration ---
// --- Firebase Configuration ---
// --- Firebase Configuration ---
const firebaseConfig = {
  apiKey: "AIzaSyDNnYjtIH9IQWvSggWGQoLAQsRYXp40KQo",
  authDomain: "homix-a185a.firebaseapp.com",
  databaseURL: "https://homix-a185a-default-rtdb.firebaseio.com",
  projectId: "homix-a185a",
  storageBucket: "homix-a185a.firebasestorage.app",
  messagingSenderId: "845593540124",
  appId: "1:845593540124:web:b091d3aeaecb1914eb11d9",
  measurementId: "G-2RRE3QM0YW"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);     // ضروري جداً لقاعدة البيانات
const storage = getStorage(app);    // ضروري لرفع الصور
const auth = getAuth(app);
const GlobalStyles = () => (
  <style>{`
    .hide-scrollbar {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
    .hide-scrollbar::-webkit-scrollbar {
        display: none; /* Chrome, Safari and Opera */
    }
  `}</style>
);
const parseWhatsAppMessage = (text) => {
    const lines = text.split('\n').filter(line => line.trim() !== '');
    const data = {};

    // 1. استخراج الاسم والموقع (أول سطرين)
    data.name = lines[0] || '';
    data.location = lines[1] || '';

    // 2. استخراج السعر (يبحث عن رقم بجانب "مطلوب" أو رقم كبير)
    const priceMatch = text.match(/(?:مطلوب|سعر)\s*([\d,]+)/) || text.match(/([\d,]{6,10})/);
    if (priceMatch) {
        data.price = priceMatch[1].replace(/,/g, '');
    }

    // 3. استخراج المساحة (يبحث عن رقم بجانب "م" أو "متر")
    const areaMatch = text.match(/(\d+)\s*(?:م|متر)/);
    if (areaMatch) {
        data.area = areaMatch[1];
    }

    // 4. استخراج الغرف (يبحث عن رقم بجانب "غرفة" أو "غرف")
    const roomsMatch = text.match(/(\d+)\s*(?:غرفة|غرف)/);
    if (roomsMatch) {
        data.bedrooms = roomsMatch[1];
    }

    // 5. استخراج كود العقار (تحديث: يبحث عن كلمة Code أو كود)
    // سيقوم بالبحث عن كلمة Code متبوعة بمسافة اختيارية ثم أرقام أو حروف
    const smartCodeMatch = text.match(/(?:Code|كود|code)\s*[:\s]*(\w+)/);
    if (smartCodeMatch) {
        data.code = smartCodeMatch[1];
    } else {
        // البحث الاحتياطي عن الهاشتاج إذا لم يجد كلمة Code
        const hashtagMatch = text.match(/#(\w+)/);
        if (hashtagMatch) {
            data.code = hashtagMatch[1];
        }
    }

    // 6. ملء الوصف بكل النص لضمان عدم ضياع التفاصيل
    data.description = text;

    return data;
};
const MORTGAGE_STEPS = [
  { id: 'home_survey', label: 'استعلام بيت' },
  { id: 'work_survey', label: 'استعلام شغل' },
  { id: 'valuation', label: 'تقييم' },
  { id: 'revaluation', label: 'إعادة تقييم' },
  { id: 'power_of_attorney', label: 'توكيلات' },
  { id: 'tripartite_contracts', label: 'عقود ثلاثية' },
  { id: 'check_received', label: 'استلام شيك' },
  { id: 'final_closing', label: 'إنهاء المعاملة' }
];
// --- (0) تعريف الصلاحيات (Permissions Constants) ---
const PERMISSIONS = {
  VIEW_DASHBOARD: 'view_dashboard',
  MANAGE_PROJECTS: 'manage_projects',
  MANAGE_CUSTOMERS: 'manage_customers',
  MANAGE_SALES: 'manage_sales',
  MANAGE_TEAM: 'manage_team',
  MANAGE_FINANCE: 'manage_finance',
  MANAGE_REQUESTS: 'manage_requests',
  MANAGE_SETTINGS: 'manage_settings',
  DELETE_DATA: 'delete_data',
  PUBLISH_FACEBOOK: 'publish_facebook',
  VIEW_LOGS: 'view_logs' // 👈 إضافة صلاحية عرض السجل
};
const hasPermission = (user, permission) => {
  if (!user) return false;
  if (user.role === 'admin') return true; 
  return user.permissions && user.permissions.includes(permission);
};

// --- (1) البيانات الأولية (Mock Data) ---
// استبدل INITIAL_SETTINGS القديم بهذا:
const INITIAL_SETTINGS = {
  storeName: 'HOMIX REAL ESTATE',
  primaryColor: '#c0a062',
  secondaryColor: '#222222',
  fontType: 'sans',
  layoutMode: 'grid',
  animationType: 'fade',
  heroTitle: 'هنساعدك تلاقي البيت المناسب ليك',
  heroSubtitle: 'مع HOMIX REAL ESTATE.. استثمارك في أمان، نقدم لك أفضل الوحدات السكنية والتجارية.',
  heroImage: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=1600&q=80',
  // --- إضافة رابط الفيديو الافتراضي (فيديو درون) ---
  heroVideo: 'https://videos.pexels.com/video-files/3773487/3773487-hd_1920_1080_30fps.mp4',
  heroOverlayOpacity: 0.6,
  ctaButtonText: 'تصفح الوحدات',
  contactPhone: '01012085105',
  contactEmail: 'HOMIX REALSTART@GMAIL.COM',
  contactAddress: 'القاهرة، التجمع الخامس',
  socialFacebook: 'https://facebook.com',
  socialInstagram: 'https://instagram.com',
  socialWhatsapp: 'https://whatsapp.com/channel/0029VadxLuD7IUYamTJobM3V',
socialLinkedIn: 'https://linkedin.com/in/HOMIX -real-estate', // رابط لينكد إن الافتراضي
  socialTwitter: 'https://twitter.com',                    // رابط تويتر/X الافتراضي
  socialTikTok: 'https://tiktok.com',                       // رابط تيك توك الافتراضي
mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d319.1285907374735!2d31.191228776812444!3d30.057339771799022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14584147ad8bb4ef%3A0x7d983b3bbbac1f98!2s10%20Ghazah%2C%20Mit%20Akaba%2C%20Agouza%2C%20Giza%20Governorate!5e1!3m2!1sen!2seg!4v1765797806008!5m2!1sen!2seg',
  footerText: 'جميع الحقوق محفوظة لشركة HOMIX Real Estate للاستثمار العقاري © 2025',
  adminSidebarColor: 'dark',
  
  // 💡 الجزء المطلوب إضافته للتحكم في روابط الفوتر من الإعدادات:
  footerLinks: [
    { id: 'l1', label: 'الرئيسية', tab: 'home' },
    { id: 'l2', label: 'المطورين العقاريين', tab: 'developers' },
    { id: 'l3', label: 'العقارات', tab: 'all-properties' },
    { id: 'l4', label: 'تمويل عقاري', tab: 'add-unit' },
    { id: 'l5', label: 'اتصل بنا', tab: 'contact-us' },
    { id: 'l6', label: 'سياسة الخصوصية', tab: 'privacy' },
  ],
};
// --- (1) البيانات الأولية (Mock Data) ---

// ... (تأكد من وضع هذا الكود بدلاً من INITIAL_USERS القديم)

// --- (1) البيانات الأولية (Mock Data) ---

// 1. حافظ على المستخدمين كما هم عشان تعرف تدخل (لا تمسح هذا الجزء)
const INITIAL_USERS = [
  { 
    id: 'user_1', 
    name: 'Khaled (المدير العام)', 
    email: 'khaled', 
    phone: '01099099127', 
    password: '123', 
    role: 'admin', 
    status: 'active', 
    permissions: [] 
  },
  { 
    id: 'user_2', 
    name: 'مدير المبيعات', 
    email: 'sales_manager', 
    phone: '01100000000', 
    password: '123',
    role: 'employee', 
    status: 'active', 
    permissions: ['view_dashboard', 'manage_customers', 'manage_sales', 'manage_projects']
  },
];

// 2. اجعل باقي البيانات فارغة تماماً (عشان متظهرش تاني)
const INITIAL_REPS = [];
const INITIAL_PROJECTS = [];
const INITIAL_PENDING_UNITS = [];
const INITIAL_MORTGAGE_REQUESTS = [];
const INITIAL_CUSTOMERS = [];
const INITIAL_TRANSACTIONS = [];
const INITIAL_TASKS = [];
const INITIAL_SALES = []; 
const INITIAL_PAYROLL_ARCHIVE = [];// --- (2) المكونات المساعدة (Helpers) ---
const FloatingContactButtons = ({ settings }) => {
  const openWhatsapp = () => {
    window.open(settings.socialWhatsapp, '_blank');
  };

  return (
    // قمنا بتغيير z-50 إلى z-[100] ليظهر فوق كل العناصر
    <div className="fixed bottom-6 left-6 z-[100] flex flex-col gap-4 animate-fade-in-up">
      
      {/* زر الإيميل */}
      <a 
        href={`mailto:${settings.contactEmail}`}
        className="w-14 h-14 bg-sky-500 text-white rounded-full shadow-lg flex items-center justify-center hover:scale-110 transition-transform duration-300 hover:bg-sky-600"
        title="إرسال بريد إلكتروني"
      >
        <Mail className="w-7 h-7" />
      </a>

      {/* زر الهاتف */}
      <a 
        href={`tel:${settings.contactPhone}`}
        className="w-14 h-14 bg-blue-600 text-white rounded-full shadow-lg flex items-center justify-center hover:scale-110 transition-transform duration-300 hover:bg-blue-700"
        title="اتصال هاتفي"
      >
        <Phone className="w-7 h-7" />
      </a>

      {/* زر الواتساب */}
      <button 
        onClick={openWhatsapp}
        className="w-14 h-14 bg-green-500 text-white rounded-full shadow-lg flex items-center justify-center hover:scale-110 transition-transform duration-300 hover:bg-green-600"
        title="تواصل عبر واتساب"
      >
        <MessageCircle className="w-8 h-8" />
      </button>
      
    </div>
  );
};
// --- 1. مكون كارت الإحصائيات (StatCard) بتعديل التباين اللوني ---
const StatCard = ({ title, value, subtitle, icon: Icon, color, darkMode }) => (
  <div className={`p-6 rounded-2xl shadow-sm flex justify-between items-center border transition-colors duration-300 
    ${darkMode ? 'bg-gray-800 border-gray-700 text-white' : 'bg-white border-gray-100 text-gray-900'}`}>
    <div>
      <p className={`text-sm font-medium mb-1 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>{title}</p>
      <p className="text-3xl font-bold mb-1">{value}</p>
      {subtitle && (
        <p className={`text-xs font-medium px-2 py-0.5 rounded-full inline-block 
          ${darkMode ? `bg-${color}-900/30 text-${color}-400` : `bg-${color}-100 text-${color}-700`}`}>
          {subtitle}
        </p>
      )}
    </div>
    <div className={`p-4 rounded-2xl ${darkMode ? 'bg-gray-700 text-blue-400' : `bg-${color}-50 text-${color}-600`}`}>
      <Icon className="w-8 h-8" />
    </div>
  </div>
);

// --- 2. شاشة التحميل (LoadingScreen) ---
const LoadingScreen = () => (
  <div className="min-h-screen bg-gradient-to-br from-blue-600 to-purple-700 flex flex-col items-center justify-center text-white">
    <div className="bg-white/10 p-8 rounded-full mb-6 backdrop-blur-md animate-pulse">
      <Building className="w-24 h-24" />
    </div>
    <h2 className="text-4xl font-bold mb-2">HOMIX REAL ESTATE</h2>
    <p className="text-blue-100 animate-pulse font-medium">جاري تحميل النظام العقاري المتكامل...</p>
  </div>
);

// --- 3. شاشة تسجيل الدخول (LoginScreen) بتنسيق يدعم الوضعين ---
const LoginScreen = ({ onLogin, onRegister, onCancel, users, onGoogleLogin, darkMode }) => {
  const [formData, setFormData] = useState({ identifier: '', password: '' });

  const handleSubmit = () => {
    if (!formData.identifier || !formData.password) {
      return alert('يرجى إدخال اسم المستخدم وكلمة المرور للموظفين.');
    }
    onLogin(formData.identifier, formData.password, 'employee');
  };
    
  const handleRegisterClick = () => {
    onRegister(); 
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 flex items-center justify-center p-4" dir="rtl">
      <div className={`rounded-3xl shadow-2xl w-full max-w-md p-8 relative transition-colors duration-300 
        ${darkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'}`}>
        <button onClick={onCancel} className="absolute top-4 left-4 text-gray-400 hover:text-gray-600 transition-colors">
          <X className="w-6 h-6" />
        </button>
        
        <div className="text-center mb-6">
          <div className="bg-blue-100 dark:bg-blue-900/30 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 text-blue-600 dark:text-blue-400">
            <LogIn className="w-8 h-8" />
          </div>
          <h1 className="text-2xl font-bold">تسجيل الدخول</h1>
        </div>

        <button 
          onClick={onGoogleLogin} 
          className="w-full bg-red-600 text-white py-3 rounded-xl font-bold hover:bg-red-700 transition shadow-lg flex items-center justify-center gap-3 mb-6"
        >
          <img src="https://upload.wikimedia.org/wikipedia/commons/4/4a/Logo-google.png" alt="Google" className="w-5 h-5 bg-white rounded-full" />
          دخول/تسجيل حساب عميل عبر جوجل
        </button>

        <div className="flex items-center my-4">
          <div className="flex-grow border-t border-gray-300 dark:border-gray-600"></div>
          <span className="flex-shrink mx-4 text-gray-500 text-sm font-medium">دخول الموظفين يدوياً</span>
          <div className="flex-grow border-t border-gray-300 dark:border-gray-600"></div>
        </div>

        <div className="space-y-4">
          <input 
            type="text" 
            placeholder="اسم المستخدم (للموظفين فقط)" 
            className={`w-full p-3 rounded-lg border outline-none focus:ring-2 focus:ring-blue-500 transition-colors 
              ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-200 text-gray-900'}`} 
            value={formData.identifier} 
            onChange={e => setFormData({...formData, identifier: e.target.value})} 
          />

          <input 
            type="password" 
            placeholder="كلمة المرور" 
            className={`w-full p-3 rounded-lg border outline-none focus:ring-2 focus:ring-blue-500 transition-colors 
              ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-200 text-gray-900'}`} 
            value={formData.password} 
            onChange={e => setFormData({...formData, password: e.target.value})} 
          />
              
          <button onClick={handleSubmit} className="w-full bg-blue-600 text-white py-3 rounded-xl font-bold hover:bg-blue-700 transition shadow-lg flex items-center justify-center gap-2">
            <LogIn className="w-5 h-5" /> دخول الموظف
          </button>
        </div>
        
        <div className="text-center mt-4 pt-4 border-t border-dashed border-gray-300 dark:border-gray-600">
          <button onClick={handleRegisterClick} className="text-gray-500 dark:text-gray-400 font-bold text-sm hover:underline">
            مشكلة في الدخول اليدوي؟
          </button>
        </div>
      </div>
    </div>
  );
};

// --- 4. مركز الإشعارات (NotificationCenter) المطور للوضع الليلي ---
const NotificationCenter = ({ notifications = [], onMarkAsRead, onClearAll, onDeleteOne, darkMode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const unreadCount = (notifications || []).filter(n => !n.read).length;

  return (
    <div className="relative no-print">
      <button onClick={() => setIsOpen(!isOpen)} className="relative p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
        <Bell className={`w-6 h-6 ${unreadCount > 0 ? 'text-blue-600 animate-swing' : 'text-gray-500 dark:text-gray-400'}`} />
        {unreadCount > 0 && (
          <span className="notification-badge bg-red-500 text-white text-[10px] px-1.5 py-0.5 rounded-full absolute top-1 right-1 border-2 border-white dark:border-gray-900">
            {unreadCount}
          </span>
        )}
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)}></div>
          <div className={`absolute left-0 mt-3 w-80 max-h-[500px] overflow-hidden rounded-2xl shadow-2xl z-20 border animate-fade-in transition-colors duration-300 flex flex-col
            ${darkMode ? 'bg-gray-800 border-gray-700 text-white' : 'bg-white border-gray-100 text-gray-900'}`}>
            
            {/* رأس مركز الإشعارات */}
            <div className="p-4 border-b dark:border-gray-700 flex justify-between items-center sticky top-0 bg-inherit z-10">
              <div>
                <h4 className="font-bold text-sm">الإشعارات اللحظية</h4>
                <span className="text-[10px] text-gray-500 dark:text-gray-400 font-bold">{unreadCount} غير مقروء</span>
              </div>
              {notifications.length > 0 && (
                <button 
                  onClick={onClearAll}
                  className="text-[10px] text-red-500 hover:text-red-700 font-bold flex items-center gap-1 bg-red-50 dark:bg-red-900/20 px-2 py-1 rounded"
                >
                  <Trash2 size={12} /> مسح الكل
                </button>
              )}
            </div>

            {/* قائمة الإشعارات */}
            <div className="divide-y dark:divide-gray-700 overflow-y-auto custom-scrollbar">
              {notifications.length === 0 ? (
                <div className="p-8 text-center text-xs text-gray-500 dark:text-gray-400">لا توجد إشعارات حالياً</div>
              ) : (
                notifications.map(n => (
                  <div key={n.id} className={`p-4 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors cursor-pointer relative group ${!n.read ? (darkMode ? 'bg-blue-900/10' : 'bg-blue-50') : ''}`} 
                    onClick={() => onMarkAsRead(n.id)}>
                    
                    {/* زر حذف إشعار واحد */}
                    <button 
                      onClick={(e) => { e.stopPropagation(); onDeleteOne(n.id); }}
                      className="absolute left-2 top-4 p-1.5 text-gray-400 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity"
                      title="حذف التنبيه"
                    >
                      <X size={14} />
                    </button>

                    <div className="flex gap-3 text-right pl-6">
                      <div className={`p-2 rounded-full h-fit ${n.type === 'unit' ? 'bg-orange-100 text-orange-600' : n.type === 'mortgage' ? 'bg-green-100 text-green-600' : 'bg-blue-100 text-blue-600'}`}>
                        {n.type === 'unit' ? <Building size={14} /> : n.type === 'mortgage' ? <Banknote size={14} /> : <Clock size={14} />}
                      </div>
                      <div className="flex-1">
                        <p className={`text-xs font-bold leading-tight mb-1 ${darkMode ? 'text-gray-100' : 'text-gray-900'}`}>{n.title}</p>
                        <p className="text-[10px] text-gray-500 dark:text-gray-400 line-clamp-2">{n.body}</p>
                        <span className="text-[9px] text-gray-400 mt-2 block font-medium">{n.time}</span>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
const Header = ({ 
  user, onLogout, onLoginClick, onToggleSidebar, darkMode, 
  onToggleDarkMode, appMode, setAppMode, settings, visitCount, 
  notifications, onMarkAsRead, onClearAllNotifications, onDeleteNotification, activeTab 
}) => {
  const goHome = () => window.dispatchEvent(new CustomEvent('changeTab', { detail: 'home' }));

  // 💡 دالة الرجوع الذكية: ترجع للرئيسية في وضع العميل، وللوحة التحكم في وضع الإدارة
  const handleBack = () => {
    if (appMode === 'admin') {
      window.dispatchEvent(new CustomEvent('changeSection', { detail: 'dashboard' }));
    } else {
      window.dispatchEvent(new CustomEvent('changeTab', { detail: 'home' }));
    }
  };

  return (
    <header className={`shadow-sm border-b sticky top-0 z-40 transition-colors duration-300 ${darkMode ? 'bg-gray-900 border-gray-700' : 'bg-white border-gray-200'}`}>
      <div className="px-4 h-20 flex justify-between items-center relative">
        
        {/* القسم الأيمن: أزرار التنقل والرجوع */}
        <div className="flex items-center gap-2">
          
          {/* 🔙 زر الرجوع الذكي */}
          {((appMode === 'client' && activeTab !== 'home') || (appMode === 'admin' && activeTab !== 'dashboard')) && (
            <button 
              onClick={handleBack}
              className={`flex items-center gap-1 px-3 py-1.5 rounded-lg transition font-bold text-sm ml-1 ${
                darkMode 
                ? 'bg-gray-800 text-gray-200 hover:bg-gray-700 border border-gray-600' 
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              <ChevronRight className="w-4 h-4" /> 
              <span>رجوع</span>
            </button>
          )}

          {/* زر القائمة الجانبية للإدارة */}
          {appMode === 'admin' && user && (
            <button onClick={onToggleSidebar} className={`p-2 lg:hidden ${darkMode ? 'text-white' : 'text-gray-600'}`}>
              <Menu className="w-6 h-6" />
            </button>
          )}

          {/* زر الرئيسية للعميل */}
          {appMode === 'client' && (
             <button onClick={goHome} className="lg:hidden p-2 text-blue-600">
               <Home className="w-6 h-6" />
             </button>
          )}
        </div>

        {/* القسم الأوسط: الشعار */}
        <div className="flex items-center gap-2 cursor-pointer lg:absolute lg:left-1/2 lg:transform lg:-translate-x-1/2" onClick={goHome}>
          <img src="/logo.png" alt="HOMIX Logo" className="w-10 h-10 object-contain" />
          <h1 className="text-lg md:text-2xl font-black tracking-tight uppercase transition-colors duration-300" style={{ color: darkMode ? '#fff' : '#1e293b' }}>
            {settings.storeName}
          </h1>
        </div>

        {/* القسم الأيسر: الإشعارات، التبديل، المستخدم */}
        <div className="flex items-center space-x-3 space-x-reverse">
          
          {/* 🔔 مركز الإشعارات المطور */}
          {user && (user.role === 'admin' || user.role === 'employee') && (
            <NotificationCenter 
              notifications={notifications} 
              onMarkAsRead={onMarkAsRead} 
              onClearAll={onClearAllNotifications}
              onDeleteOne={onDeleteNotification}
              darkMode={darkMode} 
            />
          )}

          {/* 🔄 أزرار التبديل (المتجر / الإدارة) */}
          {user && (user.role === 'admin' || user.role === 'employee') && (
            <div className={`flex items-center rounded-lg p-1 transition-colors duration-300 ${darkMode ? 'bg-gray-800' : 'bg-gray-100'}`}>
              <button 
                onClick={() => setAppMode('client')} 
                className={`px-3 py-1.5 rounded-md text-xs md:text-sm font-bold transition ${
                  appMode === 'client' 
                  ? (darkMode ? 'bg-gray-600 text-blue-400 shadow' : 'bg-white shadow text-blue-600') 
                  : 'text-gray-500'
                }`}
              >
                المتجر
              </button>
              <button 
                onClick={() => setAppMode('admin')} 
                className={`px-3 py-1.5 rounded-md text-xs md:text-sm font-bold transition ${
                  appMode === 'admin' 
                  ? (darkMode ? 'bg-gray-600 text-blue-400 shadow' : 'bg-white shadow text-blue-600') 
                  : 'text-gray-500'
                }`}
              >
                الإدارة
              </button>
            </div>
          )}

          {/* 👤 قسم المستخدم */}
          {user ? (
              <div className="flex items-center gap-2">
                {user.role === 'client' && (
                   <button 
                    onClick={() => window.dispatchEvent(new CustomEvent('changeTab', { detail: 'profile' }))} 
                    className={`flex items-center gap-2 font-bold px-3 py-2 rounded-lg transition ${
                      darkMode ? 'bg-blue-900/30 text-blue-400 hover:bg-blue-900/50' : 'bg-blue-50 text-blue-600 hover:bg-blue-100'
                    }`}
                   >
                     <User className="w-4 h-4" /> 
                     <span className="hidden md:inline">{user.name}</span>
                   </button>
                )}
                <button 
                  onClick={onLogout} 
                  className={`p-2 rounded-full transition-colors ${darkMode ? 'text-red-400 hover:bg-red-900/20' : 'text-red-500 hover:bg-red-50'}`}
                >
                  <LogOut className="w-5 h-5" />
                </button>
              </div>
          ) : (
            <button 
              onClick={onLoginClick} 
              className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-bold hover:bg-blue-700 transition shadow-lg"
            >
              <LogIn className="w-4 h-4 ml-2" /> 
              <span className="hidden md:inline">دخول</span>
            </button>
          )}

          {/* 📈 عداد الزيارات */}
          <VisitorCounter count={visitCount} darkMode={darkMode} />

          {/* 🌙 زر الوضع الليلي */}
          <button 
            onClick={onToggleDarkMode} 
            className={`hidden p-2 rounded-full transition-colors ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`}
          >
            {darkMode ? '☀️' : '🌙'}
          </button>
          
        </div>
      </div>
    </header>
  );
};const Sidebar = ({ isOpen, activeSection, onSectionChange, onClose, darkMode, settings, pendingCount, requestCount, user }) => {
  const allMenuItems = [
    { id: 'dashboard', label: 'لوحة التحكم', icon: Grid, permission: PERMISSIONS.VIEW_DASHBOARD },
    { id: 'deal-closing', label: 'إنهاء المعاملات', icon: CheckSquare, permission: PERMISSIONS.MANAGE_SALES },
    { id: 'pending-units', label: 'طلبات الوحدات', icon: ClipboardList, count: pendingCount, permission: PERMISSIONS.MANAGE_REQUESTS },
    { id: 'mortgage-requests', label: 'طلبات التمويل', icon: Banknote, count: requestCount, permission: PERMISSIONS.MANAGE_REQUESTS },
    { id: 'projects', label: 'إدارة العقارات', icon: Building, permission: PERMISSIONS.MANAGE_PROJECTS },
    { id: 'customers', label: 'العملاء', icon: Users, permission: PERMISSIONS.MANAGE_CUSTOMERS },
    { id: 'sales', label: 'المبيعات', icon: DollarSign, permission: PERMISSIONS.MANAGE_SALES },
    { id: 'team', label: 'فريق العمل', icon: Briefcase, permission: PERMISSIONS.MANAGE_TEAM },
    { id: 'reports', label: 'التقارير والتحليلات', icon: PieChart, permission: PERMISSIONS.MANAGE_FINANCE },
    { id: 'accounting', label: 'المالية', icon: Wallet, permission: PERMISSIONS.MANAGE_FINANCE },
{ id: 'logs', label: 'سجل العمليات', icon: ClipboardList, permission: PERMISSIONS.VIEW_LOGS }, // 👈 السطر المطلوب
    { id: 'settings', label: 'الإعدادات', icon: Settings, permission: PERMISSIONS.MANAGE_SETTINGS },
  ];

  const visibleMenuItems = allMenuItems.filter(item => hasPermission(user, item.permission));

  return (
    <>
      {/* الخلفية المظلمة للموبايل فقط */}
      {/* الخلفية المظلمة للموبايل */}
      <div 
        className={`fixed inset-0 bg-black/60 z-[100] lg:hidden transition-opacity duration-300 ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`} 
        onClick={onClose} 
      />

      {/* القائمة الجانبية */}
      <aside 
        className={`fixed inset-y-0 right-0 z-[101] w-72 transform transition-transform duration-300 ease-in-out shadow-2xl lg:translate-x-0 lg:static lg:z-0 lg:shadow-none
          ${darkMode ? 'bg-gray-800 border-l border-gray-700' : 'bg-white'}
          ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className="flex flex-col h-full">
          {/* لوجو صغير للموبايل داخل القائمة */}
          <div className={`p-6 border-b lg:hidden flex justify-between items-center ${darkMode ? 'border-gray-700' : 'border-gray-100'}`}>
            <span className="font-bold text-blue-600">القائمة</span>
            <button onClick={onClose} className={`p-1 transition-colors ${darkMode ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-black'}`}>
              <X className="w-6 h-6" />
            </button>
          </div>

          <div className="p-4 space-y-2 overflow-y-auto flex-1">
            {visibleMenuItems.map((item) => (
              <button 
                key={item.id} 
                onClick={() => { onSectionChange(item.id); onClose(); }} 
                className={`w-full flex items-center justify-between px-4 py-3 rounded-xl transition-all duration-200
                  ${activeSection === item.id 
                    ? 'bg-blue-600 text-white shadow-lg' 
                    : darkMode 
                      ? 'text-gray-300 hover:bg-gray-700/50 hover:text-white' 
                      : 'text-gray-600 hover:bg-gray-100'}`}
              >
                <div className="flex items-center">
                  <item.icon className={`w-5 h-5 ml-3 transition-colors ${activeSection === item.id ? 'text-white' : 'text-current opacity-70'}`} />
                  <span className="font-bold text-sm">{item.label}</span>
                </div>
                
                {item.count > 0 && (
                  <span className={`text-[10px] px-2 py-0.5 rounded-full font-bold shadow-sm transition-colors
                    ${activeSection === item.id 
                      ? 'bg-white text-blue-600' 
                      : 'bg-red-500 text-white'}`}
                  >
                    {item.count}
                  </span>
                )}
              </button>
            ))}
          </div>

          {/* تذييل القائمة لضبط المظهر في الوضع الليلي */}
          <div className={`p-4 border-t text-[10px] text-center ${darkMode ? 'border-gray-700 text-gray-500' : 'border-gray-100 text-gray-400'}`}>
            HOMIX REAL ESTATE — Admin Panel
          </div>
        </div>
      </aside>
    </>
  );
};
// --- (3) النوافذ المنبثقة (Modals) ---

const ProjectModal = ({ project, onClose, onSave, darkMode }) => {
    // --- State Definitions ---
    const isPendingReview = project && project.ownerName; 
    const [quickText, setQuickText] = useState('');
    const [isDragging, setIsDragging] = useState(false);

   const [data, setData] = useState(project ? {
        ...project,
        code: project.code || '', // قراءة الكود الحالي إذا كان موجوداً
        images: project.images ?? [],     
        rawFiles: project.rawFiles ?? [],   
        features: project.features ?? []
    } : { 
        name: '', 
        // توليد كود عشوائي يبدأ بـ HOMIX ورقم من 4 خانات (مثال: HOMIX -1025)
        code: 'HOMIX -' + Math.floor(1000 + Math.random() * 9000), 
        location: '', 
        price: '', 
        category: 'شقة', 
        status: 'كاش', 
        description: '', 
        mobile: '', 
        whatsappLink: '', 
        area: '', 
        videoUrl: '', 
        bedrooms: '', 
        bathrooms: '', 
        images: [], 
        rawFiles: [], 
        features: [] 
    });

    // --- Logic Functions (WhatsApp & Images) ---
    const handleQuickPaste = () => {
        if (!quickText.trim()) return toast.error('يرجى لصق نص الرسالة أولاً');
        const extractedData = parseWhatsAppMessage(quickText);
        setData(prev => ({ ...prev, ...extractedData }));
        toast.success('تم استخراج البيانات وتعبئة النموذج');
    };

    const compressAndUpload = async (file) => {
        const options = { maxSizeMB: 0.8, maxWidthOrHeight: 1280, useWebWorker: true };
        try {
            const compressedFile = await imageCompression(file, options);
            return compressedFile;
        } catch (error) { return file; }
    };

    const processFiles = async (files) => {
        const imageFiles = Array.from(files).filter(file => file.type.startsWith('image/'));
        if (imageFiles.length === 0) return toast.error('يرجى اختيار صور فقط');
        const loadingToast = toast.loading('جاري تجهيز الصور...');
        try {
            const compressedFiles = await Promise.all(imageFiles.map(f => compressAndUpload(f)));
            const newImageUrls = compressedFiles.map(file => URL.createObjectURL(file)); 
            setData(prev => ({ 
                ...prev, 
                images: [...(prev.images || []), ...newImageUrls],
                rawFiles: [...(prev.rawFiles || []), ...compressedFiles] 
            })); 
            toast.success('تمت الإضافة', { id: loadingToast });
        } catch (error) { toast.error('خطأ في المعالجة', { id: loadingToast }); }
    };

    const handleImageUpload = (e) => processFiles(e.target.files);
    const handleDragOver = (e) => { e.preventDefault(); setIsDragging(true); };
    const handleDragLeave = () => setIsDragging(false);
    const handleDrop = (e) => { e.preventDefault(); setIsDragging(false); if (e.dataTransfer.files) processFiles(e.dataTransfer.files); };
    const removeImage = (index) => { setData(prev => ({ ...prev, images: prev.images.filter((_, i) => i !== index), rawFiles: prev.rawFiles.filter((_, i) => i !== index) })); };
    
    // التنسيق الموحد للمدخلات لتقليل الارتفاع
    const inputClass = "w-full p-1.5 border rounded dark:bg-gray-700 dark:border-gray-600 mb-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all text-sm";
    const labelClass = "block text-[11px] font-bold mb-1 opacity-70";

    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-2 md:p-4 backdrop-blur-sm">
            {/* جعل الحاوية الرئيسية ذات ارتفاع أقصى محدد 95% من الشاشة */}
            <div className={`w-full max-w-2xl flex flex-col rounded-xl shadow-2xl overflow-hidden max-h-[95vh] transition-colors duration-300 ${darkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'}`}>
                
                {/* 1. رأس النافذة (ثابت) */}
                <div className="flex justify-between items-center p-4 border-b dark:border-gray-700 bg-inherit z-10">
                    <h3 className="font-bold text-lg flex items-center gap-2">
                        {project ? <Edit size={18} /> : <Plus size={18} />}
                        {isPendingReview ? 'مراجعة ونشر العقار' : (project ? 'تعديل عقار' : 'إضافة عقار جديد')}
                    </h3>
                    <button onClick={onClose} className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors text-gray-500">
                        <X className="w-5 h-5" />
                    </button>
                </div>

                {/* 2. محتوى النافذة (قابل للتمرير) */}
                <div className="flex-1 overflow-y-auto p-4 md:p-6 custom-scrollbar">
                    
                    {/* استيراد واتساب (مضغوط) */}
                    {!project && (
                        <div className="mb-4 p-3 bg-blue-50 dark:bg-blue-900/20 border-2 border-dashed border-blue-300 dark:border-blue-700 rounded-lg animate-fade-in">
                            <label className="block text-[10px] font-bold mb-1 text-blue-700 dark:text-blue-300 uppercase tracking-widest flex items-center gap-1">
                                <Zap size={12} className="fill-current" /> استيراد ذكي من واتساب:
                            </label>
                            <div className="flex gap-2">
                                <textarea 
                                    placeholder="انسخ نص العقار والزقه هنا..."
                                    className="flex-1 p-2 text-xs border rounded dark:bg-gray-700 h-14 outline-none focus:ring-2 focus:ring-blue-500"
                                    value={quickText}
                                    onChange={(e) => setQuickText(e.target.value)}
                                />
                                <button type="button" onClick={handleQuickPaste} className="bg-blue-600 text-white px-3 rounded-lg font-bold hover:bg-blue-700 transition-all flex flex-col items-center justify-center gap-1 text-[10px] min-w-[70px] active:scale-95 shadow-md">
                                    <Zap size={16} /> تعبئة
                                </button>
                            </div>
                        </div>
                    )}

                    {/* تنبيه المراجعة */}
                    {isPendingReview && (
                        <div className="bg-orange-50 dark:bg-orange-900/20 p-3 rounded-lg mb-4 border border-orange-200 dark:border-orange-800 text-xs">
                            <p className="font-bold text-orange-800 dark:text-orange-200">بيانات المالك: {project.ownerName} - {project.ownerPhone}</p>
                        </div>
                    )}

                    {/* شبكة البيانات (تنسيق مكثف) */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4">
    {/* حقل اسم العقار */}
    <div className="col-span-full md:col-span-1">
        <label className={labelClass}>اسم العقار / العنوان</label>
        <input 
            placeholder="مثال: شقة في جاردن سيتي" 
            value={data.name} 
            onChange={e => setData({...data, name: e.target.value})} 
            className={inputClass} 
        />
    </div>

    {/* حقل كود العقار (الجديد تم إضافته هنا) */}
    <div className="col-span-full md:col-span-1">
        <label className={labelClass}>كود العقار (Property Code)</label>
        <input 
            placeholder="مثال: HOMIX -501" 
            value={data.code} 
            onChange={e => setData({...data, code: e.target.value})} 
            className={`${inputClass} font-mono font-bold text-blue-600`} 
        />
    </div>

    {/* حقل المنطقة (تم نقله ليكون في صف مستقل أو بجانب حقل آخر) */}
    <div className="col-span-full">
        <label className={labelClass}>المنطقة</label>
        <input 
            type="text" 
            placeholder="مثال: التجمع الخامس" 
            value={data.location} 
            onChange={e => setData({...data, location: e.target.value})} 
            className={inputClass} 
        />
    </div>

    <div className="grid grid-cols-2 gap-2 col-span-full">
        <div>
            <label className={labelClass}>السعر</label>
            <input type="number" placeholder="ج.م" value={data.price} onChange={e => setData({...data, price: Number(e.target.value)})} className={inputClass} />
        </div>
        <div>
            <label className={labelClass}>المساحة</label>
            <input type="number" placeholder="م²" value={data.area} onChange={e => setData({...data, area: Number(e.target.value)})} className={inputClass} />
        </div>
    </div>

                        <div className="grid grid-cols-2 gap-2">
                            <div>
                                <label className={labelClass}>الغرف</label>
                                <input type="number" value={data.bedrooms} onChange={e => setData({...data, bedrooms: Number(e.target.value)})} className={inputClass} />
                            </div>
                            <div>
                                <label className={labelClass}>الحمامات</label>
                                <input type="number" value={data.bathrooms} onChange={e => setData({...data, bathrooms: Number(e.target.value)})} className={inputClass} />
                            </div>
                        </div>

                        <div>
                            <label className={labelClass}>نوع الوحدة</label>
                            <select value={data.category} onChange={e => setData({...data, category: e.target.value})} className={inputClass}>
                                 <option value="شقة">شقة</option><option value="فيلا">فيلا</option><option value="إداري">إداري</option>
                                 <option value="تجاري">تجاري</option><option value="أرض">أرض</option>
                            </select>
                        </div>
                        <div>
                            <label className={labelClass}>طريقة الدفع</label>
                            <select value={data.status} onChange={e => setData({...data, status: e.target.value})} className={inputClass}>
                                 <option value="كاش">كاش</option><option value="تمويل عقاري">تمويل عقاري</option><option value="تقسيط">تقسيط</option>
                                 {isPendingReview && <option value="تم التنفيذ">مباع</option>} 
                            </select>
                        </div>

                        <div>
                            <label className={labelClass}>رقم الهاتف</label>
                            <input placeholder="للتواصل" value={data.mobile} onChange={e => setData({...data, mobile: e.target.value})} className={inputClass} />
                        </div>
                        <div>
                            <label className={labelClass}>رابط واتساب</label>
                            <input placeholder="wa.me/..." value={data.whatsappLink} onChange={e => setData({...data, whatsappLink: e.target.value})} className={inputClass} />
                        </div>
                    </div>

                  <div className="col-span-full">
    <label className={labelClass}>رابط الفيديو (يوتيوب أو واتساب)</label>
    <input 
        placeholder="ضع رابط الفيديو هنا..." 
        value={data.videoUrl || ''} 
        onChange={e => setData({...data, videoUrl: e.target.value})} // تأكد من وجود هذا السطر
        className={inputClass} 
    />
    <textarea 
        placeholder="المميزات والوصف..." 
        value={data.description} 
        onChange={e => setData({...data, description: e.target.value})} 
        className={`${inputClass} h-16 resize-none`} 
    />
</div>

                    {/* منطقة الرفع بالسحب (مضغوطة) */}
                    <div 
                        className={`mt-2 p-4 rounded-lg border-2 border-dashed transition-all text-center cursor-pointer relative
                            ${isDragging ? 'border-blue-500 bg-blue-50' : 'border-gray-300 bg-gray-50 dark:bg-gray-700/30'}`}
                        onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop}
                    >
                        <label className="cursor-pointer flex flex-col items-center">
                            <Camera size={24} className="text-blue-500 mb-1" />
                            <span className="text-xs font-bold text-blue-600">اسحب الصور من واتساب هنا</span>
                            <input type="file" multiple accept="image/*" onChange={handleImageUpload} className="hidden" />
                        </label>

                        {data.images && data.images.length > 0 && (
                            <div className="flex gap-2 overflow-x-auto mt-4 py-1 scrollbar-hide">
                                {data.images.map((img, i) => (
                                    <div key={i} className="relative flex-shrink-0 w-16 h-16 group">
                                        <img src={img} className="w-full h-full object-cover rounded border" alt="preview" />
                                        <button type="button" onClick={(e) => { e.stopPropagation(); removeImage(i); }} className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full p-0.5 shadow-md">
                                            <X size={10} />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* 3. أزرار التحكم (ثابتة في الأسفل) */}
                <div className="p-4 border-t dark:border-gray-700 bg-inherit flex justify-end gap-3 z-10">
                    <button onClick={onClose} className="px-5 py-2 bg-gray-200 dark:bg-gray-700 rounded-lg text-sm font-bold transition hover:bg-gray-300">إلغاء</button>
                    <button 
                        onClick={() => onSave(data)} 
                        className={`px-8 py-2 text-white rounded-lg text-sm font-bold shadow-lg active:scale-95 transition-all
                            ${isPendingReview ? 'bg-green-600 hover:bg-green-700' : 'bg-blue-600 hover:bg-blue-700'}`}
                    >
                        {isPendingReview ? 'موافقة ونشر' : 'حفظ العقار'}
                    </button>
                </div>
            </div>
        </div>
    );
};
const CustomerModal = ({ customer, reps, onClose, onSave, darkMode }) => {
    // 💡 (1) التأكد من تهيئة الـ State بشكل سليم
    const [data, setData] = useState(customer ? {
        ...customer,
        steps: customer.steps || []
    } : { 
        name: '', 
        phone: '', 
        type: 'عادي', 
        repId: '', 
        status: 'جديد', 
        notes: '', 
        budget: '', 
        bank: '', 
        unitLocation: '', 
        unitFloor: '', 
        unitArea: '',
        steps: [] 
    });

    const toggleStep = (stepId) => {
        const currentSteps = data.steps || [];
        if (currentSteps.includes(stepId)) {
            setData({ ...data, steps: currentSteps.filter(id => id !== stepId) });
        } else {
            setData({ ...data, steps: [...currentSteps, stepId] });
        }
    };
    
    // كلاسات موحدة
    const inputClass = "w-full p-2 border rounded dark:bg-gray-700 dark:border-gray-600 outline-none focus:ring-2 focus:ring-blue-500 text-sm";
    const labelClass = "text-xs font-bold text-gray-500 mb-0.5 block";
    
    // قائمة البنوك المقترحة
    const bankOptions = [
    'البنك الأهلي المصري', 
    'بنك مصر', 
    'بنك التعمير والإسكان', 
    'بنك الـ CIB', 
    'بنك QNB', 
    'بنك فيصل الإسلامي', 
    'بنك القاهرة', 
    'بنك كريدي أجريكول', // 👈 تمت الإضافة
    'بنك saib',          // 👈 تمت الإضافة
    'بنك NBK',           // 👈 تمت الإضافة
    'بنك أبو ظبي الأول', 
    'بنك عودة', 
    'بنك مشرق', 
 'بنك نيكست',
 'فاب',
    'لم يحدد بعد'
];

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            {/* 💡 تم تحسين الـ max-w (max-w-xl) ليتناسب مع توسع النموذج في الصورة */}
            <div className={`w-full max-w-xl p-5 rounded-2xl shadow-2xl my-8 overflow-y-auto max-h-[95vh] ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
                
                {/* 💡 رأس النافذة كما في الصورة */}
                <div className="flex justify-between items-center mb-6 border-b pb-4 dark:border-gray-700">
                    <h3 className="font-bold text-xl">تسجيل عميل جديد</h3>
                    <button onClick={onClose} className="p-1 text-gray-500 hover:text-gray-800"><X className="w-6 h-6" /></button>
                </div>
                
                {/* 💡 محتوى النموذج (التنسيق الرئيسي) - تقليل التباعد إلى space-y-3 */}
                <div className="space-y-3">
                    
                    {/* الصف الأول: الاسم والتصنيف */}
                    <div className="grid grid-cols-2 gap-4"> {/* زيادة الـ gap إلى 4 */}
                        <div>
                            <label className={labelClass}>الاسم</label>
                            <input value={data.name} placeholder="الاسم بالكامل" onChange={e => setData({...data, name: e.target.value})} className={inputClass} />
                        </div>
                        <div>
                            <label className={labelClass}>التصنيف</label>
                            <select value={data.type} onChange={e => setData({...data, type: e.target.value})} className={inputClass}>
                                <option value="عادي">عميل عادي</option>
                                <option value="VIP">عميل VIP</option>
                                <option value="شركة">شركة</option>
                                <option value="بائع">بائع (مالك عقار)</option>
                            </select>
                        </div>
                    </div>
                    
                    {/* الصف الثاني: الهاتف والبنك (المعدل) */}
                    <div className="grid grid-cols-2 gap-4"> {/* زيادة الـ gap إلى 4 */}
                        <div>
                            <label className={labelClass}>رقم الهاتف</label>
                            <input type="tel" placeholder="رقم الهاتف" value={data.phone} onChange={e => setData({...data, phone: e.target.value})} className={inputClass} />
                        </div>
                        <div>
                            <label className={labelClass}>البنك المتعامل معه (اختياري)</label>
                            <select 
                                value={data.bank} 
                                onChange={e => setData({...data, bank: e.target.value})} 
                                className={inputClass}>
                                <option value="">-- لا يوجد / لم يحدد --</option>
                                {bankOptions.map(bank => (
                                    <option key={bank} value={bank}>{bank}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* الصف الثالث: المندوب والحالة */}
                    <div className="grid grid-cols-2 gap-4"> {/* زيادة الـ gap إلى 4 */}
                        <div>
                            <label className={labelClass}>المندوب</label>
                            <select 
                                value={String(data.repId)} 
                                onChange={e => setData({...data, repId: e.target.value})} 
                                className={inputClass}
                            >
                                <option value="">-- اختر --</option>
                                {reps.map(r => <option key={r.id} value={String(r.id)}>{r.name}</option>)}
                            </select>
                        </div>
                        <div>
                            <label className={labelClass}>الحالة</label>
                            <select value={data.status} onChange={e => setData({...data, status: e.target.value})} className={inputClass}>
                                <option value="جديد">جديد</option>
                                <option value="قيد التنفيذ">قيد التنفيذ</option>
                                <option value="تم التنفيذ">تم التنفيذ</option>
                                <option value="ملغى">ملغى</option>
                            </select>
                        </div>
                    </div>

                    {/* حقول تفاصيل الطلب (قسم مضغوط) - كما في الصورة */}
                    <div className="bg-gray-50 dark:bg-gray-700/50 p-4 rounded-xl border dark:border-gray-700 space-y-4"> {/* زيادة الـ padding إلى p-4 وزيادة الـ space-y إلى 4 */}
                        <h4 className="font-bold text-sm text-gray-500">تفاصيل الطلب/العقار المطلوب (اختياري)</h4>
                        
                        {/* الصف الأول من التفاصيل */}
                        <div className="grid grid-cols-2 gap-4"> {/* زيادة الـ gap إلى 4 */}
                            <div>
                                <label className={labelClass}>الميزانية (ج.م)</label>
                                <input type="number" placeholder="الميزانية (ج.م)" value={data.budget} onChange={e => setData({...data, budget: Number(e.target.value)})} className={inputClass} />
                            </div>
                            <div>
                                <label className={labelClass}>المنطقة المطلوبة</label>
                                <input placeholder="المنطقة المطلوبة" value={data.unitLocation} onChange={e => setData({...data, unitLocation: e.target.value})} className={inputClass} />
                            </div>
                        </div>

                        {/* الصف الثاني من التفاصيل */}
                        <div className="grid grid-cols-2 gap-4"> {/* زيادة الـ gap إلى 4 */}
                            <div>
                                <label className={labelClass}>المساحة (م²)</label>
                                <input type="number" placeholder="المساحة (م²)" value={data.unitArea} onChange={e => setData({...data, unitArea: Number(e.target.value)})} className={inputClass} />
                            </div>
                            <div>
                                <label className={labelClass}>الدور</label>
                                <input placeholder="الدور (أرضي/متكرر...)" value={data.unitFloor} onChange={e => setData({...data, unitFloor: e.target.value})} className={inputClass} />
                            </div>
                        </div>
                    </div>
{/* قسم تتبع الإجراءات البنكية */}
                    <div className="bg-blue-50/50 dark:bg-gray-700/30 p-4 rounded-xl border border-blue-100 dark:border-gray-600">
                        <h4 className="font-bold text-xs text-blue-600 mb-3 flex items-center gap-2">
                            <CheckSquare size={14} /> تتبع إجراءات البنك والتمويل
                        </h4>
                        <div className="grid grid-cols-2 gap-2">
                            {MORTGAGE_STEPS.map(step => (
                                <label key={step.id} className={`flex items-center gap-2 p-2 rounded-lg border cursor-pointer transition-all ${
                                    data.steps?.includes(step.id) 
                                    ? 'bg-green-100 border-green-500 text-green-700' 
                                    : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-600 text-gray-400'
                                }`}>
                                    <input 
                                        type="checkbox" 
                                        checked={data.steps?.includes(step.id)} 
                                        onChange={() => toggleStep(step.id)}
                                        className="w-4 h-4 accent-green-600"
                                    />
                                    <span className="text-[10px] font-bold">{step.label}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                    {/* ملاحظات العميل */}
                    <textarea placeholder="ملاحظات العميل..." value={data.notes} onChange={e => setData({...data, notes: e.target.value})} className={`${inputClass} h-16`} />
                    
                    {/* أزرار الإجراءات */}
                    <div className="flex justify-end gap-2 pt-4 border-t dark:border-gray-700">
                        <button 
                            onClick={onClose} 
                            className="px-6 py-2 bg-gray-200 dark:bg-gray-700 rounded text-black dark:text-white font-bold hover:bg-gray-300 dark:hover:bg-gray-600"
                        >
                            إلغاء
                        </button>
                        <button 
                            onClick={() => onSave(data)} 
                            className="px-8 py-2 bg-blue-600 text-white rounded font-bold hover:bg-blue-700 shadow-lg shadow-blue-500/30"
                        >
                            حفظ
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
const RepModal = ({ rep, onClose, onSave, darkMode }) => {
    // 1. تعريف الحالة مع إضافة حقل branch وحقل showInPortfolio للتحكم في الظهور
    const [data, setData] = useState(rep || { 
        name: '', 
        whatsappLink: '', 
        role: 'مبيعات', 
        branch: 'المعادي', // ✨ إضافة الحقل الجديد (الفرع الافتراضي)
        callName: '',      
        isMonthHero: false, 
        showInPortfolio: true, // القيمة الافتراضية (يظهر في الموقع)
        rating: 5,          
        baseSalary: '', 
        commissionRate: '1.0', 
        status: 'نشط', 
        hireDate: new Date().toISOString().split('T')[0],
        workStart: '10:00',
        workEnd: '18:00',
        vacationBalance: '21',
        phone: '',
        img: '' 
    });

    const [previewUrl, setPreviewUrl] = useState(data.img || null);

    const inputClass = "w-full p-3 border rounded-lg dark:bg-gray-700 dark:border-gray-600 outline-none focus:ring-2 focus:ring-blue-500 text-sm transition-all";
    const labelClass = "text-sm font-bold mb-1 block text-gray-700 dark:text-gray-300";

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const options = { maxSizeMB: 0.2, maxWidthOrHeight: 500, useWebWorker: true };
            try {
                const compressedFile = await imageCompression(file, options);
                setData({ ...data, imageFile: compressedFile });
                setPreviewUrl(URL.createObjectURL(compressedFile));
            } catch (error) {
                setData({ ...data, imageFile: file });
                setPreviewUrl(URL.createObjectURL(file));
            }
        }
    };

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[110] p-4 text-right" dir="rtl">
            <div className={`w-full max-w-lg p-6 rounded-2xl shadow-2xl ${darkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'} transform animate-in fade-in zoom-in duration-300`}>
                
                <div className="flex justify-between items-center mb-6 border-b pb-4 dark:border-gray-700">
                    <h3 className="font-bold text-2xl text-blue-600 flex items-center gap-2">
                        <UserCog className="w-6 h-6" /> {rep ? 'تعديل ملف الموظف' : 'إضافة موظف جديد'}
                    </h3>
                    <button onClick={onClose} className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors">
                        <X className="w-6 h-6 text-gray-400" />
                    </button>
                </div>

                <div className="space-y-4 max-h-[75vh] overflow-y-auto px-1 custom-scrollbar">
                    
                    {/* قسم الصورة الشخصية */}
                    <div className="flex flex-col items-center justify-center p-4 bg-gray-50 dark:bg-gray-900/30 rounded-2xl border-2 border-dashed border-gray-200 dark:border-gray-700">
                        <div className="relative w-24 h-24 mb-3">
                            {previewUrl ? (
                                <img src={previewUrl} className="w-full h-full object-cover rounded-full ring-4 ring-blue-500 shadow-xl" alt="Preview" />
                            ) : (
                                <div className="w-full h-full bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center">
                                    <Camera className="w-8 h-8 text-gray-400" />
                                </div>
                            )}
                            <label className="absolute bottom-0 right-0 bg-blue-600 p-2 rounded-full text-white cursor-pointer shadow-lg hover:scale-110 transition-transform">
                                <Plus size={16} />
                                <input type="file" accept="image/*" onChange={handleImageChange} className="hidden" />
                            </label>
                        </div>
                        <span className="text-xs font-bold text-gray-500">رفع صورة الموظف</span>
                    </div>

                    {/* البيانات الأساسية */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4"> 
                        <div>
                            <label className={labelClass}>الاسم الكامل <span className="text-red-500">*</span></label>
                            <input type="text" value={data.name} onChange={e => setData({...data, name: e.target.value})} className={inputClass} required />
                        </div>
                        <div>
                            <label className={labelClass}>الوظيفة</label>
                            <select value={data.role} onChange={e => setData({...data, role: e.target.value})} className={inputClass}>
                                <option value="مبيعات">مبيعات</option>
                                <option value="مدير فريق">مدير فريق</option>
                                <option value="إداري">إداري</option>
                                <option value="خدمة عملاء">خدمة عملاء</option>
                            </select>
                        </div>
                    </div>

                    {/* ✨ إضافة حقل اختيار الفرع ✨ */}
                    <div className="p-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-900/20">
                        <label className={labelClass}>الفرع التابع له</label>
                        <select 
                            value={data.branch} 
                            onChange={e => setData({...data, branch: e.target.value})} 
                            className={inputClass}
                        >
                            <option value="المعادي">فرع المعادي</option>
                            <option value="المهندسين">فرع المهندسين</option>
                            <option value="التجمع">فرع التجمع</option>
                        </select>
                    </div>

                    {/* ✨ التميز والظهور في الموقع ✨ */}
                    <div className="p-4 rounded-xl border border-blue-100 bg-blue-50/20 dark:bg-blue-900/10 dark:border-blue-900/30">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                            <div>
                                <label className={labelClass}>اللقب الوظيفي (Call Name)</label>
                                <input 
                                    placeholder="مثال: خبير الاستثمار العقاري" 
                                    value={data.callName} 
                                    onChange={e => setData({...data, callName: e.target.value})} 
                                    className={inputClass} 
                                />
                            </div>
                            <div>
                                <label className={labelClass}>تقييم الموظف (1 - 5)</label>
                                <input 
                                    type="number" min="1" max="5"
                                    value={data.rating} 
                                    onChange={e => setData({...data, rating: Number(e.target.value)})} 
                                    className={inputClass} 
                                />
                            </div>
                        </div>

                        {/* 🔘 أزرار التحكم في الظهور 🔘 */}
                        <div className="flex flex-col gap-3 p-3 bg-white dark:bg-gray-800 rounded-lg shadow-sm border dark:border-gray-700">
                            <label className="flex items-center justify-between cursor-pointer group">
                                <span className="text-sm font-bold text-blue-600 dark:text-blue-400">عرض الموظف في الموقع العام 🌐</span>
                                <input 
                                    type="checkbox" 
                                    checked={data.showInPortfolio !== false} 
                                    onChange={e => setData({...data, showInPortfolio: e.target.checked})} 
                                    className="w-6 h-6 accent-blue-600 rounded-md" 
                                />
                            </label>
                            
                            <div className="h-px bg-gray-100 dark:bg-gray-700 w-full"></div>

                            <label className="flex items-center justify-between cursor-pointer group">
                                <span className="text-sm font-bold text-yellow-700 dark:text-yellow-500">تمييز كـ "موظف الشهر" 🏆</span>
                                <input 
                                    type="checkbox" 
                                    checked={data.isMonthHero} 
                                    onChange={e => setData({...data, isMonthHero: e.target.checked})} 
                                    className="w-6 h-6 accent-yellow-500 rounded-md" 
                                />
                            </label>
                        </div>
                    </div>

                    {/* 💰 الإعدادات المالية */}
                    <div className={`p-4 rounded-xl border-2 border-dashed ${darkMode ? 'bg-green-900/10 border-green-800' : 'bg-green-50 border-green-200'}`}>
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <label className={labelClass}>الراتب الأساسي</label>
                                <input type="number" value={data.baseSalary} onChange={e => setData({...data, baseSalary: Number(e.target.value)})} className={inputClass} />
                            </div>
                            <div>
                                <label className={labelClass}>العمولة (%)</label>
                                <input type="number" step="0.1" value={data.commissionRate} onChange={e => setData({...data, commissionRate: Number(e.target.value)})} className={inputClass} />
                            </div>
                        </div>
                    </div>

                    {/* ⏰ المواعيد والدوام */}
                    <div className={`p-4 rounded-xl border-2 border-dashed ${darkMode ? 'bg-blue-900/10 border-blue-800' : 'bg-blue-50 border-blue-200'}`}>
                        <div className="grid grid-cols-2 gap-4 mb-4">
                            <div>
                                <label className="text-[11px] font-bold mb-1 block">وقت الحضور</label>
                                <input type="time" value={data.workStart} onChange={e => setData({...data, workStart: e.target.value})} className={inputClass} />
                            </div>
                            <div>
                                <label className="text-[11px] font-bold mb-1 block">وقت الانصراف</label>
                                <input type="time" value={data.workEnd} onChange={e => setData({...data, workEnd: e.target.value})} className={inputClass} />
                            </div>
                        </div>
                        <div>
                            <label className={labelClass}>رصيد الإجازات السنوي</label>
                            <input type="number" value={data.vacationBalance} onChange={e => setData({...data, vacationBalance: Number(e.target.value)})} className={inputClass} />
                        </div>
                    </div>
                    
                    {/* 📞 التواصل والحالة */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className={labelClass}>رقم الواتساب (رقم فقط)</label>
                            <input 
                                value={data.whatsappLink} 
                                onChange={e => setData({...data, whatsappLink: e.target.value})} 
                                className={inputClass} 
                                placeholder="010xxxxxxxx" 
                            />
                            <p className="text-[9px] text-gray-400 mt-1">اكتب الرقم، وسيقوم النظام بإضافة الرابط تلقائياً.</p>
                        </div>
                        <div>
                            <label className={labelClass}>تاريخ التعيين</label>
                            <input type="date" value={data.hireDate} onChange={e => setData({...data, hireDate: e.target.value})} className={inputClass} />
                        </div>
                    </div>
                </div>

                <div className="flex justify-end gap-3 mt-6 pt-4 border-t dark:border-gray-700">
                    <button onClick={onClose} className="px-6 py-3 bg-gray-200 dark:bg-gray-700 rounded-lg font-bold text-gray-700 dark:text-white hover:bg-gray-300">إلغاء</button>
                    <button onClick={() => onSave(data)} className="px-8 py-3 bg-blue-600 text-white rounded-lg font-bold shadow-lg flex items-center gap-2 hover:bg-blue-700 transition-all active:scale-95">
                        <FileCheck size={18} /> حفظ البيانات
                    </button>
                </div>
            </div>
        </div>
    );
};
const UserModal = ({ user, onClose, onSave, darkMode }) => {
  const [data, setData] = useState(user || { 
      name: '', email: '', password: '', 
      role: 'employee', status: 'active', permissions: [],
      assignedBranches: [] // الحقل الجديد كمصفوفة
  });
  
  const inputClass = "w-full p-2 border rounded dark:bg-gray-700 dark:border-gray-600 mb-2";

  const togglePermission = (permValue) => {
    if (data.permissions.includes(permValue)) setData({ ...data, permissions: data.permissions.filter(p => p !== permValue) });
    else setData({ ...data, permissions: [...data.permissions, permValue] });
  };

  // دالة التعامل مع اختيار الفروع المتعددة
  const toggleBranch = (branchName) => {
    const currentBranches = data.assignedBranches || [];
    if (currentBranches.includes(branchName)) {
      setData({ ...data, assignedBranches: currentBranches.filter(b => b !== branchName) });
    } else {
      setData({ ...data, assignedBranches: [...currentBranches, branchName] });
    }
  };

  const permissionOptions = [
    { key: PERMISSIONS.VIEW_DASHBOARD, label: 'لوحة التحكم (Dashboard)' },
    { key: PERMISSIONS.MANAGE_PROJECTS, label: 'إدارة العقارات' },
    { key: PERMISSIONS.MANAGE_CUSTOMERS, label: 'إدارة العملاء' },
    { key: PERMISSIONS.MANAGE_SALES, label: 'إدارة المبيعات والعقود' },
    { key: PERMISSIONS.MANAGE_FINANCE, label: 'المالية والحسابات' },
    { key: PERMISSIONS.MANAGE_TEAM, label: 'إدارة الفريق والرواتب' },
    { key: PERMISSIONS.MANAGE_REQUESTS, label: 'إدارة طلبات الموقع' },
    { key: PERMISSIONS.MANAGE_SETTINGS, label: 'الإعدادات والمستخدمين' },
    { key: PERMISSIONS.PUBLISH_FACEBOOK, label: 'إمكانية النشر على فيسبوك' },
    { key: PERMISSIONS.VIEW_LOGS, label: 'صلاحية رؤية سجل العمليات' },
    { key: PERMISSIONS.DELETE_DATA, label: 'صلاحية الحذف (خطر)' },
  ];

  const branchesList = ['المعادي', 'المهندسين', 'التجمع'];

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className={`w-full max-w-2xl p-6 rounded-xl shadow-2xl overflow-y-auto max-h-[90vh] ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
        <h3 className="font-bold text-xl mb-4 border-b pb-2 dark:border-gray-700">{user ? 'تعديل مستخدم والصلاحيات' : 'إضافة مستخدم جديد'}</h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
              <label className="text-xs font-bold mb-1 block">الاسم</label>
              <input value={data.name} onChange={e => setData({...data, name: e.target.value})} className={inputClass} />
          </div>
          <div>
              <label className="text-xs font-bold mb-1 block">اسم المستخدم (للدخول)</label>
              <input value={data.email} onChange={e => setData({...data, email: e.target.value})} className={inputClass} />
          </div>
          
          <div>
              <label className="text-xs font-bold mb-1 block">كلمة المرور</label>
              <input 
                type="text" 
                placeholder={user ? "اتركها فارغة لعدم التغيير" : "أدخل كلمة المرور"}
                value={data.password || ''} 
                onChange={e => setData({...data, password: e.target.value})} 
                className={inputClass} 
              />
          </div>

          <div>
            <label className="text-xs font-bold mb-1 block">نوع الحساب</label>
            <select value={data.role} onChange={e => setData({...data, role: e.target.value})} className={inputClass}>
                <option value="employee">موظف (صلاحيات محددة)</option>
                <option value="admin">مدير عام (كل الصلاحيات)</option>
            </select>
            
            <label className="text-xs font-bold mt-2 mb-1 block">الفروع المسؤول عنها</label>
            <div className="flex flex-wrap gap-2 p-2 border rounded dark:border-gray-600 bg-gray-50 dark:bg-gray-900/30">
                {branchesList.map(branch => (
                    <label key={branch} className="flex items-center gap-2 cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 p-1 px-2 rounded transition">
                        <input 
                            type="checkbox" 
                            checked={data.assignedBranches?.includes(branch)} 
                            onChange={() => toggleBranch(branch)} 
                            className="w-4 h-4 accent-blue-600" 
                        />
                        <span className="text-xs font-bold">{branch}</span>
                    </label>
                ))}
            </div>
            <p className="text-[10px] text-gray-400 mt-1">المحاسب سيرى بيانات الفروع المختارة فقط</p>
          </div>          
          
          <div>
              <label className="text-xs font-bold mb-1 block">الحالة</label>
              <select value={data.status} onChange={e => setData({...data, status: e.target.value})} className={inputClass}>
                  <option value="active">نشط</option>
                  <option value="inactive">محظور</option>
              </select>
          </div>
        </div>

        {/* قسم الصلاحيات يظهر فقط إذا لم يكن المدير العام */}
        {data.role === 'employee' && (
          <div className="bg-gray-50 dark:bg-gray-700/50 p-4 rounded-lg border dark:border-gray-600">
            <h4 className="font-bold text-sm mb-3 text-blue-600">تحديد الصلاحيات:</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3"> 
              {permissionOptions.map((option) => (
                <label key={option.key} className="flex items-center gap-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 p-1 rounded transition">
                    <input type="checkbox" checked={data.permissions.includes(option.key)} onChange={() => togglePermission(option.key)} className="w-4 h-4 accent-blue-600" />
                    <span className="text-sm">{option.label}</span>
                </label>
              ))}
            </div>
          </div>
        )}
        
        <div className="flex justify-end gap-2 mt-6 pt-4 border-t dark:border-gray-700">
            <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded text-black hover:bg-gray-300">إلغاء</button>
            <button onClick={() => onSave(data)} className="px-6 py-2 bg-blue-600 text-white rounded font-bold hover:bg-blue-700">حفظ البيانات</button>
        </div>
      </div>
    </div>
  );
};
// ... (بعد نهاية دالة UserModal) ...

// ----------------------------------------------------
// (جديد) تعريفات Modals الأساسية للـ TeamManager
// ----------------------------------------------------

const PayrollArchiveModal = ({ archive, onClose, onUpdate, darkMode }) => {
    // تم إضافة هذه الدالة لحل مشكلة 'PayrollArchiveModal is not defined'
    const total = archive ? archive.total.toLocaleString(undefined, { maximumFractionDigits: 2 }) : '0.00';
    
    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
            <div className={`w-full max-w-lg p-6 rounded-xl shadow-2xl overflow-y-auto max-h-[90vh] ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
                <div className="flex justify-between items-center mb-6 border-b pb-4 dark:border-gray-700">
                    <h3 className="font-bold text-xl">تفاصيل راتب شهر: {archive ? archive.month : 'غير محدد'}</h3>
                    <button onClick={onClose}><X className="w-6 h-6 text-gray-500" /></button>
                </div>
                <p className="text-lg font-bold mb-4">الإجمالي المُرحَّل: <span className="text-green-600">{total} ج.م</span></p>
                
                <h4 className="font-bold mb-3 text-blue-600">تفاصيل الموظفين:</h4>
                <div className="space-y-3 max-h-60 overflow-y-auto pr-2">
                    {archive && archive.records.map((r, index) => (
                        <div key={index} className="p-3 border rounded-lg dark:border-gray-700">
                            <p className="font-bold">{r.name} ({r.role})</p>
                            <p className="text-sm text-gray-500">الأساسي: {r.baseSalary} | العمولة: {r.commission.toFixed(2)} | الإجمالي: {r.total.toFixed(2)}</p>
                        </div>
                    ))}
                </div>
                <div className="flex justify-end gap-2 mt-6 pt-4 border-t dark:border-gray-700">
                    <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded text-black">إغلاق</button>
                </div>
            </div>
        </div>
    );
};
// ... (بعد نهاية مكون PayrollArchiveModal) ...


const AttendanceEditModal = ({ record, onClose, onSave, darkMode, standardEndHour }) => {
    const [checkIn, setCheckIn] = useState(record.checkInTime || '');
    const [checkOut, setCheckOut] = useState(record.checkOutTime || '');
    
    // دالة لحساب الأوفر تايم بناءً على الأوقات المعدلة
    const calculateNewOvertime = (inTime, outTime) => {
        // إذا لم يكن هناك وقت انصراف مسجل، لا يوجد أوفر تايم
        if (!inTime || !outTime) return 0;
        
        // تحويل الأوقات إلى كائنات Date للمقارنة والحساب
        // نستخدم تاريخ ثابت (2000/01/01) للحسابات الزمنية فقط
        const outDate = new Date(`2000/01/01 ${outTime}`);
        const standardEnd = new Date(`2000/01/01 ${standardEndHour}:00`);

        if (outDate > standardEnd) {
            // حساب الفرق بين نهاية الدوام (20:00) ووقت الانصراف
            const diffInHours = (outDate.getTime() - standardEnd.getTime()) / (1000 * 60 * 60);
            return parseFloat(diffInHours.toFixed(2));
        }
        return 0;
    };

    const handleSubmit = async () => {
        if (!checkIn) {
            alert("لا يمكن حفظ السجل بدون وقت حضور.");
            return;
        }

        const newOvertime = calculateNewOvertime(checkIn, checkOut);
        
        const updatedData = {
            checkInTime: checkIn,
            checkOutTime: checkOut || null, // يمكن أن يكون فارغًا إذا لم يسجل انصراف
            overtime: newOvertime,
            status: checkOut ? 'انصراف (معدّل)' : 'حضور (معدّل)'
        };

        try {
            await updateDoc(doc(db, "attendance_records", record.id), updatedData);
            onSave(); // إغلاق المودال
            alert('تم تحديث السجل اليومي بنجاح.');
        } catch (e) {
            alert('فشل التحديث. (تأكد من أن Firebase تعمل بشكل صحيح)');
            console.error(e);
        }
    };

    const inputClass = "w-full p-2 border rounded dark:bg-gray-700 dark:border-gray-600";

    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[100] p-4">
            <div className={`w-full max-w-md p-6 rounded-xl shadow-2xl ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
                <h3 className="font-bold text-xl mb-4 border-b pb-2 dark:border-gray-700">تعديل سجل {record.date}</h3>
                <p className="font-bold mb-4">{record.name} - ({record.repId})</p>
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-bold mb-1">وقت الحضور</label>
                        <input type="time" value={checkIn} onChange={e => setCheckIn(e.target.value)} className={inputClass} />
                    </div>
                    <div>
                        <label className="block text-sm font-bold mb-1">وقت الانصراف</label>
                        <input type="time" value={checkOut} onChange={e => setCheckOut(e.target.value)} className={inputClass} />
                        <p className="text-xs text-gray-500 mt-1">الدوام القياسي ينتهي الساعة 20:00 (8م). **الفارغ يعني عدم انصراف.**</p>
                    </div>
                    <p className="font-medium text-sm pt-2">
                        ساعات العمل الإضافية المحتسبة: <span className="font-bold text-green-600">{calculateNewOvertime(checkIn, checkOut).toFixed(2)} ساعة</span>
                    </p>
                </div>
                <div className="flex justify-end gap-2 mt-6 pt-4 border-t dark:border-gray-700">
                    <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded text-black font-medium">إلغاء</button>
                    <button onClick={handleSubmit} className="px-6 py-2 bg-blue-600 text-white rounded font-bold hover:bg-blue-700">حفظ التعديلات</button>
                </div>
            </div>
        </div>
    );
};

const AttendanceArchive = ({ dailyRecords, reps, darkMode, onDelete, standardEndHour }) => {
    const [editingRecord, setEditingRecord] = useState(null);
    const [filterDate, setFilterDate] = useState(new Date().toISOString().split('T')[0]);
    
    // ربط السجلات اليومية بأسماء الموظفين وتصفيتها حسب التاريخ
    const recordsWithNames = useMemo(() => {
        const filtered = dailyRecords
            .filter(r => r.date === filterDate)
            .map(record => {
                // 1. نبحث عن الموظف في القائمة المتاحة (المفلترة)
                const rep = reps.find(r => String(r.id) === String(record.repId));
                
                // 2. نرجع البيانات، وإذا لم نجد الموظف نضع الاسم null
                return {
                    ...record,
                    name: rep ? rep.name : null, 
                    overtime: record.overtime || 0
                };
            })
            // 3. الفلترة: نحذف أي سجل نتيجته null (أي لا يخص هذا الفرع)
            .filter(r => r.name !== null);

        // 4. ترتيب السجلات حسب وقت الحضور
        return filtered.sort((a, b) => (a.checkInTime || '').localeCompare(b.checkInTime || ''));
    }, [dailyRecords, reps, filterDate]);

    // دالة فتح نافذة التعديل (وإغلاقها بعد الحفظ)
    const handleEditClose = () => {
        setEditingRecord(null);
    };

    return (
        <div className="mt-8">
            <h3 className="font-bold text-lg mb-4 flex items-center gap-2"><ListIcon className="w-5 h-5 text-blue-600" /> أرشيف الحضور اليومي</h3>
            
            <div className="flex flex-col sm:flex-row justify-between items-center mb-4 gap-3">
                <label className="font-bold text-sm">اختر التاريخ للمراجعة:</label>
                <input 
                    type="date" 
                    value={filterDate} 
                    onChange={(e) => setFilterDate(e.target.value)} 
                    className={"p-2 rounded-lg text-sm border " + (darkMode ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300')}
                />
            </div>

            <div className={`rounded-xl shadow-sm overflow-x-auto border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                <div className="min-w-[800px]">
                    <table className="w-full text-right text-sm">
                        <thead className={darkMode ? 'bg-gray-700' : 'bg-gray-50'}>
                            <tr>
                                <th className="p-4">الموظف</th>
                                <th className="p-4">الحالة</th>
                                <th className="p-4">وقت الحضور</th>
                                <th className="p-4">وقت الانصراف</th>
                                <th className="p-4">ساعات إضافية</th>
                                <th className="p-4">إجراءات</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y dark:divide-gray-700">
                            {recordsWithNames.length > 0 ? (
                                recordsWithNames.map(r => (
                                    <tr key={r.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/50">
                                        <td className="p-4 font-bold">{r.name}</td>
                                        <td className="p-4">
                                            <span className={`px-2 py-1 rounded text-xs ${r.status.includes('حضور') ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'}`}>
                                                {r.status || 'غائب'}
                                            </span>
                                        </td>
                                        <td className="p-4 font-mono text-blue-600">{r.checkInTime || '--:--'}</td>
                                        <td className="p-4 font-mono text-red-600">{r.checkOutTime || '--:--'}</td>
                                        <td className="p-4 font-mono font-bold">{r.overtime.toFixed(2)} س</td>
                                        <td className="p-4 flex gap-2">
                                            <button onClick={() => setEditingRecord(r)} className="text-blue-500 hover:bg-blue-50 p-2 rounded" title="تعديل"><Edit className="w-4 h-4" /></button>
                                            <button onClick={() => onDelete(r.id)} className="text-red-500 hover:bg-red-50 p-2 rounded" title="حذف السجل"><Trash2 className="w-4 h-4" /></button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="p-8 text-center text-gray-500">لا توجد سجلات حضور لهذا التاريخ.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            
            {editingRecord && (
                <AttendanceEditModal
                    record={editingRecord}
                    onClose={handleEditClose}
                    onSave={handleEditClose}
                    darkMode={darkMode}
                    standardEndHour={standardEndHour}
                />
            )}
        </div>
    );
};
// --- (جديد) دوال مساعدة لحساب الإحصائيات المالية والبيانية ---
// ----------------------------------------------------------

const formatMonthLabel = (dateString) => {
    const date = new Date(dateString + '-01');
    return date.toLocaleDateString('ar-EG', { month: 'long', year: 'numeric' });
};

const getFilteredTransactions = (transactions, period) => {
    const now = new Date();
    return transactions.filter(t => {
        const transDate = new Date(t.date);
        const diffInMonths = (now.getFullYear() - transDate.getFullYear()) * 12 + (now.getMonth() - transDate.getMonth());

        if (period === 'monthly') return diffInMonths <= 1; // الشهر الحالي
        if (period === 'half-yearly') return diffInMonths < 6;
        if (period === 'yearly') return diffInMonths < 12;
        if (period === 'all') return true;
        return true;
    });
};

const getMonthlyTransactions = (transactions, period = 'half-yearly') => {
    const now = new Date();
    let numMonths = 12;
    if (period === 'monthly') numMonths = 1;
    if (period === 'half-yearly') numMonths = 6;

    const monthlyData = {};

    for (let i = 0; i < numMonths; i++) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        const yearMonth = d.toISOString().slice(0, 7);
        monthlyData[yearMonth] = { income: 0, expense: 0, balance: 0, label: formatMonthLabel(yearMonth) };
    }

    transactions.forEach(t => {
        if (t.date) {
            const yearMonth = t.date.slice(0, 7);
            if (monthlyData[yearMonth]) {
                if (t.type === 'income') {
                    monthlyData[yearMonth].income += t.amount || 0;
                } else if (t.type === 'expense') {
                    monthlyData[yearMonth].expense += t.amount || 0;
                }
            }
        }
    });

    const sortedMonths = Object.keys(monthlyData).sort();
    
    let cumulativeBalance = 0;
    sortedMonths.forEach(month => {
        const data = monthlyData[month];
        cumulativeBalance += data.income - data.expense;
        data.balance = cumulativeBalance;
    });
    
    return sortedMonths.reverse().map(month => monthlyData[month]);
};

const getMonthlySalesChartData = (sales, period = 'yearly') => {
    const now = new Date();
    let numMonths = 12;
    if (period === 'half-yearly') numMonths = 6;
    if (period === 'monthly') numMonths = 1;

    const salesByMonth = {};

    for (let i = 0; i < numMonths; i++) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        const yearMonth = d.toISOString().slice(0, 7);
        salesByMonth[yearMonth] = 0;
    }

    sales.forEach(s => {
        if (s.date) {
            const yearMonth = s.date.slice(0, 7);
            if (salesByMonth.hasOwnProperty(yearMonth)) {
                salesByMonth[yearMonth] += s.amount || 0;
            }
        }
    });

    const sortedMonths = Object.keys(salesByMonth).sort();
    const dataPoints = sortedMonths.map(month => salesByMonth[month]);
    const labels = sortedMonths.map(month => formatMonthLabel(month));

    return { labels: labels.reverse(), dataPoints: dataPoints.reverse() };
};

// ----------------------------------------------------------
// --- (جديد) مكونات Charts و Modals المساعدة ---
// ----------------------------------------------------------

const FinanceBarChart = ({ income, expense, darkMode }) => {
    const dataPoints = [income, expense];

    const chartData = {
        labels: ['الوارد', 'المنصرف'],
        datasets: [
            {
                label: 'التحليل المالي',
                data: dataPoints,
                backgroundColor: ['#10B981', '#EF4444'], // Green & Red
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
            title: { 
                display: true, 
                text: 'التحليل المالي (للفترة المحددة)',
                font: { size: 14, family: 'Tahoma' }, // تصغير الخط للموبايل
                color: darkMode ? '#F9FAFB' : '#1F2937'
            },
            tooltip: { rtl: true }
        },
        scales: {
            x: {
                grid: { display: false },
                ticks: { color: darkMode ? '#9CA3AF' : '#4B5563', font: { size: 10 } } // تصغير خط المحور
            },
            y: {
                ticks: { 
                    color: darkMode ? '#9CA3AF' : '#4B5563',
                    font: { size: 10 },
                    callback: function(value) {
                       if (value === 0) return 0;
                       return value.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
                    }
                }
            }
        }
    };

    return <Bar data={chartData} options={options} />;
};

const UnitsOccupancyDoughnut = ({ projects, darkMode }) => {
    const totalUnits = projects.length;
    // (إصلاح دقة البيانات) حساب الوحدات بناءً على حالة المشروع
    const occupiedCount = projects.filter(p => p.status === 'تم التنفيذ' || p.status === 'مباع').length;
    const availableCount = totalUnits - occupiedCount;

    const chartData = {
        labels: ['متاح', 'مشغول'],
        datasets: [
            {
                data: [availableCount, occupiedCount],
                backgroundColor: ['#10B981', '#EF4444'], // Green (متاح) و Red (مشغول)
                hoverBackgroundColor: ['#059669', '#DC2626'],
                borderWidth: 0,
            },
        ],
    };

    const options = {
        responsive: true,
        cutout: '75%', 
        plugins: {
            legend: { display: false },
            tooltip: { 
                rtl: true,
                callbacks: {
                    label: function(context) {
                        let label = context.label || '';
                        if (label) { label += ': '; }
                        if (context.parsed) { label += context.parsed.toLocaleString('ar-EG') + ' وحدة'; }
                        return label;
                    }
                }
            },
            title: { display: false }
        }
    };

    return (
        <div className="relative flex flex-col items-center">
             <div className="text-center font-bold text-lg mb-4 flex items-center gap-2">
                <span className="w-4 h-4 rounded-full bg-red-500"></span>
                نسبة إشغال العقارات (الوضع الحالي) 
                <span className="w-4 h-4 rounded-full bg-red-500"></span>
            </div>
            {/* تصغير حجم الدونات على الموبايل */}
            <div className="relative w-36 h-36 md:w-48 md:h-48"> 
                <Doughnut data={chartData} options={options} />
                   {/* النص الداخلي */}
                <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                    <p className="text-xl md:text-2xl font-extrabold" style={{ color: '#10B981' }}>
                        {totalUnits > 0 ? ((availableCount / totalUnits) * 100).toFixed(0) : 0}%
                    </p>
                    <p className="text-xs text-gray-500">متاح</p>
                </div>
            </div>
            
            <div className="mt-6 text-sm flex gap-6 font-bold">
                 <div className="flex items-center gap-2">
                    <span className="w-3 h-3 bg-red-500 rounded-full"></span>
                    <span>مشغول: <span className="text-red-500">{occupiedCount}</span></span>
                </div>
                 <div className="flex items-center gap-2">
                    <span className="w-3 h-3 bg-green-500 rounded-full"></span>
                    <span>متاح: <span className="text-green-500">{availableCount}</span></span>
                </div>
            </div>
               <p className="text-xs text-gray-400 mt-2">إجمالي العقارات: {totalUnits} عقار</p>
        </div>
    );
};

// 🛑 Modals المساعدة (يجب إضافتها لحل مشكلة 'is not defined') 🛑

// ... (المكونات السابقة)

// --- تحديث مكون TaskModal ---
const TaskModal = ({ reps, task, onClose, onSend, darkMode }) => {
    // 💡 المنطق السليم: إذا كانت مهمة جديدة، تكون القائمة فارغة. يتم تحويل ID المندوبين إلى نصوص لضمان المطابقة في Checkbox.
    const [taskText, setTaskText] = useState(task ? task.text : '');
    const [assignedTo, setAssignedTo] = useState(
        task && Array.isArray(task.assignedTo) ? 
        task.assignedTo.map(id => String(id)) : 
        [] // 🚨 القيمة الافتراضية يجب أن تكون مصفوفة فارغة
    );

    const handleSubmit = () => {
        if (!taskText || assignedTo.length === 0) {
            return alert('يرجى كتابة المهمة واختيار مندوب واحد على الأقل');
        }
        
        // عند الإرسال، نرسل الـ IDs كأرقام (إذا كانت Firestore تتوقع أرقام) أو نصوص (حسب استخدامك في saveTask).
        // سنتركها نصوصاً لتجنب التضارب، وتم تعديل دالة handleSaveTask مسبقاً لتقبلها.
        onSend({ id: task ? task.id : null, text: taskText, assignedTo }); 
    };

    // 💡 استعادة التنسيق: استخدام كلاس موحد وفعال
    const inputClass = "w-full p-3 border rounded-lg dark:bg-gray-700 dark:border-gray-600 outline-none transition focus:ring-2 focus:ring-blue-500";

    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
            <div className={`w-full max-w-md p-6 rounded-xl shadow-2xl ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
                
                <div className="flex justify-between items-center mb-6 border-b pb-4 dark:border-gray-700">
                    <h3 className="font-bold text-xl">{task ? 'تعديل المهمة' : 'تكليف بمهمة جديدة'}</h3> 
                    <button onClick={onClose} className="p-1 text-gray-500 hover:text-gray-800"><X className="w-6 h-6" /></button>
                </div>
                
                <div className="space-y-4">
                    {/* حقل تفاصيل المهمة */}
                    <div>
                        <label className="block text-sm font-bold mb-2 text-gray-700 dark:text-gray-300">تفاصيل المهمة</label>
                        <textarea
                            placeholder="اكتب تفاصيل المهمة..." 
                            className={`${inputClass} h-24 resize-none`}
                            value={taskText}
                            onChange={(e) => setTaskText(e.target.value)}
                            required
                        />
                    </div>

                    {/* قائمة اختيار المندوبين (مع scroll) */}
                    <div>
                           <label className="block text-sm font-bold mb-2 text-gray-700 dark:text-gray-300">اختر المندوبين المكلفين:</label>
                           <div className="max-h-48 overflow-y-auto border p-3 rounded-lg dark:border-gray-700 space-y-2 bg-gray-50 dark:bg-gray-700/50">
                                {reps.length === 0 && <p className="text-sm text-gray-500">لا يوجد موظفين مسجلين.</p>}
                                {reps.map(r => (
                                    // 💡 Label كـ container للـ checkbox لزيادة مساحة الضغط
                                    <label key={r.id} className="flex items-center gap-3 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 p-1 rounded transition">
                                        <input 
                                            type="checkbox" 
                                            className="w-4 h-4 accent-blue-600"
                                            checked={assignedTo.includes(String(r.id))} // المقارنة بنص
                                            onChange={(e) => {
                                                const repIdStr = String(r.id); 
                                                setAssignedTo(prev => e.target.checked ? 
                                                              [...prev, repIdStr] : 
                                                              prev.filter(id => id !== repIdStr));
                                            }}
                                        />
                                        <span className="font-medium text-sm">{r.name}</span>
                                    </label>
                                ))}
                           </div>
                    </div>
                </div>

                {/* أزرار الإجراءات */}
                <div className="flex justify-end gap-3 mt-6 pt-4 border-t dark:border-gray-700">
                    <button onClick={onClose} className="px-6 py-2 bg-gray-200 dark:bg-gray-700 rounded-lg text-black dark:text-white font-medium hover:bg-gray-300 dark:hover:bg-gray-600">إلغاء</button>
                    <button onClick={handleSubmit} className="px-6 py-2 bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700 transition shadow-lg">
                        {/* 💡 الحفاظ على اسم زر الواتساب للإرسال الجديد */}
                        {task ? 'حفظ التعديلات' : 'إرسال (واتساب)'}
                    </button>
                </div>
            </div>
        </div>
    );
};
const Dashboard = ({ projects, pendingUnits, mortgageRequests, customers, transactions, sales, darkMode }) => {
    // الحالة الافتراضية للفلترة هي "سنوي"
    const [timePeriod, setTimePeriod] = useState('yearly'); 

    // 💡 دالة داخلية لتصفية أي مصفوفة بيانات بناءً على التاريخ والمدة المختارة
    const getFilteredDataByPeriod = (dataArray, period) => {
        const now = new Date();
        return dataArray.filter(item => {
            if (!item.date) return false;
            const itemDate = new Date(item.date);
            
            // حساب الفرق بالأشهر بين تاريخ اليوم وتاريخ العنصر
            const diffInMonths = (now.getFullYear() - itemDate.getFullYear()) * 12 + (now.getMonth() - itemDate.getMonth());

            if (period === 'monthly') {
                // تصفية الشهر الحالي فقط
                return diffInMonths < 1 && now.getMonth() === itemDate.getMonth();
            }
            if (period === 'half-yearly') {
                // تصفية آخر 6 أشهر
                return diffInMonths < 6;
            }
            if (period === 'yearly') {
                // تصفية آخر 12 شهر (السنة الحالية)
                return diffInMonths < 12;
            }
            return true; // في حالة اختيار "الكل"
        });
    };

    // 💡 (تحسين الأداء) استخدام useMemo لحساب الإحصائيات المالية والمبيعات بناءً على الفلتر الزمني
    const stats = useMemo(() => {
        // 1. تصفية وحساب المعاملات المالية (وارد / مصروف)
        const filteredTransactions = getFilteredDataByPeriod(transactions, timePeriod);
        const calculatedIncome = filteredTransactions
            .filter(t => t.type === 'income')
            .reduce((acc, t) => acc + (Number(t.amount) || 0), 0);
        
        const calculatedExpense = filteredTransactions
            .filter(t => t.type === 'expense')
            .reduce((acc, t) => acc + (Number(t.amount) || 0), 0);
        
        const calculatedNetBalance = calculatedIncome - calculatedExpense;

        // 2. تصفية وحساب المبيعات
        const filteredSales = getFilteredDataByPeriod(sales, timePeriod);
        const calculatedTotalSales = filteredSales.reduce((acc, s) => acc + (Number(s.amount) || 0), 0);

        return { 
            income: calculatedIncome, 
            expense: calculatedExpense, 
            netBalance: calculatedNetBalance, 
            totalSales: calculatedTotalSales,
            salesCount: filteredSales.length
        };
    }, [transactions, sales, timePeriod]);

    return (
        <div className="space-y-6 animate-fade-in">
            {/* رأس لوحة التحكم مع أزرار الفلترة */}
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                <h2 className="text-2xl font-bold">لوحة التحكم الرئيسية</h2>
                
                {/* شريط أزرار الفلترة الزمنية */}
                <div className="flex bg-gray-100 dark:bg-gray-700 p-1 rounded-xl w-full md:w-fit justify-center md:justify-start shadow-inner">
                    <button 
                        onClick={() => setTimePeriod('monthly')} 
                        className={`px-4 py-2 rounded-lg text-sm font-black transition-all duration-300 ${timePeriod === 'monthly' ? 'bg-white dark:bg-gray-600 shadow-md text-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
                    >
                        شهري
                    </button>
                    <button 
                        onClick={() => setTimePeriod('half-yearly')} 
                        className={`px-4 py-2 rounded-lg text-sm font-black transition-all duration-300 ${timePeriod === 'half-yearly' ? 'bg-white dark:bg-gray-600 shadow-md text-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
                    >
                        نصف سنوي
                    </button>
                    <button 
                        onClick={() => setTimePeriod('yearly')} 
                        className={`px-4 py-2 rounded-lg text-sm font-black transition-all duration-300 ${timePeriod === 'yearly' ? 'bg-white dark:bg-gray-600 shadow-md text-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
                    >
                        سنوي
                    </button>
                    <button 
                        onClick={() => setTimePeriod('all')} 
                        className={`px-4 py-2 rounded-lg text-sm font-black transition-all duration-300 ${timePeriod === 'all' ? 'bg-white dark:bg-gray-600 shadow-md text-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
                    >
                        الكل
                    </button>
                </div>
            </div>
            
            <div className="flex items-center gap-2 mb-2">
                <Clock className="w-4 h-4 text-blue-500" />
                <h3 className="text-xl font-bold border-b pb-2 pt-2 flex-1">
                    ملخص الإحصائيات: {
                        timePeriod === 'monthly' ? 'الشهر الحالي' : 
                        timePeriod === 'half-yearly' ? 'آخر 6 أشهر' : 
                        timePeriod === 'yearly' ? 'السنة الحالية' : 'كامل المدة'
                    }
                </h3>
            </div>

            {/* كروت الإحصائيات (StatCards) */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"> 
                <StatCard 
                    title="إجمالي الواردات" 
                    value={stats.income.toLocaleString()} 
                    subtitle={`الصافي: ${stats.netBalance.toLocaleString()}`} 
                    icon={TrendingUp} 
                    color="green" 
                    darkMode={darkMode} 
                />
                <StatCard 
                    title="إجمالي المبيعات" 
                    value={stats.totalSales.toLocaleString()} 
                    subtitle={`عدد الصفقات: ${stats.salesCount}`} 
                    icon={DollarSign} 
                    color="blue" 
                    darkMode={darkMode} 
                />
                <StatCard 
                    title="عقارات معتمدة" 
                    value={projects.length} 
                    subtitle="جاهزة للعرض" 
                    icon={Building} 
                    color="purple" 
                    darkMode={darkMode} 
                />
                <StatCard 
                    title="إجمالي العملاء" 
                    value={customers.length} 
                    subtitle="نشط حالياً" 
                    icon={Users} 
                    color="orange" 
                    darkMode={darkMode} 
                />
            </div>

            {/* صف الرسوم البيانية */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* 1. مخطط نسبة الإشغال (الدونات) */}
                <div className={`p-6 rounded-2xl shadow-sm border flex flex-col items-center justify-center ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                    <UnitsOccupancyDoughnut projects={projects} darkMode={darkMode} />
                </div>
                
                {/* 2. التحليل المالي العمودي (مقارنة الوارد والمصروف للفترة المحددة) */}
                <div className={`p-6 rounded-2xl shadow-sm border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                    <FinanceBarChart income={stats.income} expense={stats.expense} darkMode={darkMode} />
                </div>
            </div>

            {/* قسم التنبيهات الإدارية */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div className={`p-6 rounded-2xl shadow-sm border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                    <h3 className="font-bold mb-4 text-orange-600 flex items-center">
                        <AlertCircle className="w-5 h-5 ml-2" /> تنبيهات الإدارة العامة
                    </h3>
                    {pendingUnits.length > 0 || mortgageRequests.length > 0 ? (
                        <ul className="space-y-3">
                            {pendingUnits.length > 0 && (
                                <li className="flex justify-between items-center p-3 bg-orange-50 dark:bg-orange-900/20 rounded-xl text-orange-800 dark:text-orange-200 text-sm border border-orange-100 dark:border-orange-800">
                                    <span>يوجد {pendingUnits.length} وحدات تنتظر المراجعة والنشر.</span>
                                    <span className="font-bold underline cursor-pointer">عرض الطلبات</span>
                                </li>
                            )}
                            {mortgageRequests.length > 0 && (
                                <li className="flex justify-between items-center p-3 bg-green-50 dark:bg-green-900/20 rounded-xl text-green-800 dark:text-green-200 text-sm border border-green-100 dark:border-green-800">
                                    <span>يوجد {mortgageRequests.length} طلبات تمويل عقاري جديدة.</span>
                                    <span className="font-bold underline cursor-pointer">متابعة التمويل</span>
                                </li>
                            )}
                        </ul>
                    ) : (
                        <div className="flex flex-col items-center py-4 text-gray-500">
                            <CheckCircle className="w-8 h-8 text-green-500 mb-2 opacity-50" />
                            <p className="text-sm">لا توجد مهام معلقة، جميع البيانات محدثة.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
const PendingUnitsManager = ({ pendingUnits, setPendingUnits, projects, setProjects, darkMode, customers, setCustomers }) => {
    
    // --- States الجديدة للمراجعة والتعديل ---
    const [showModal, setShowModal] = useState(false);
    const [reviewingUnit, setReviewingUnit] = useState(null); // الوحدة التي تتم مراجعتها/تعديلها

    // دالة لفتح نافذة المراجعة/التعديل
    const handleReview = (unit) => {
        setReviewingUnit(unit);
        setShowModal(true);
    };

    // 💡 دالة حفظ التعديلات وإتمام الموافقة والنشر (هذا هو الكود المصحح)
    // 💡 دالة حفظ التعديلات وإتمام الموافقة والنشر بنفس الـ ID
    const handleApproveAndSave = async (unitData) => {
        
        if (!unitData.ownerPhone) {
            alert('بيانات المالك غير كاملة (رقم الهاتف مفقود).');
            return;
        }

        try {
            const newImageUrls = [];
            // رفع الصور الجديدة إن وجدت
            const uploadPromises = (unitData.rawFiles || []).map(async (file) => {
                const storageRef = ref(storage, `project_units/${Date.now()}_${file.name}`);
                const snapshot = await uploadBytes(storageRef, file);
                const downloadURL = await getDownloadURL(snapshot.ref);
                newImageUrls.push(downloadURL);
            });
            await Promise.all(uploadPromises);

            const finalImages = [...(unitData.images || []).filter(url => !url.startsWith('blob:')), ...newImageUrls];

            // تجهيز بيانات العقار الجديد
            const newProject = { 
                ...unitData,
                images: finalImages,
                rawFiles: null, // حذف الملفات الخام
                status: unitData.status || 'كاش',
                rating: 5.0, 
                features: unitData.features || [],
                mobile: unitData.ownerPhone, 
                whatsappLink: `https://wa.me/20${String(unitData.ownerPhone).replace(/^0/,'')}`
            };

            // 🛑 الخطوة السحرية: استخدام نفس الـ ID القديم 🛑
            // بدلاً من addDoc، نستخدم setDoc ونمرر مرجع المستند بالـ ID الموجود
            const unitId = String(unitData.id); // المعرف الأصلي من طلب العرض
            await setDoc(doc(db, "projects", unitId), newProject);

            // 5. إزالة الوحدة من قائمة المراجعة (PendingUnits)
            await deleteDoc(doc(db, "pending_units", unitId));

            // 6. تحديث حالة العميل المالك (اختياري)
            const ownerCustomer = customers.find(c => String(c.phone) === String(unitData.ownerPhone));
            if (ownerCustomer) {
                const updatedCustomer = { 
                    ...ownerCustomer, 
                    status: 'تم التنفيذ', 
                    type: 'بائع', 
                    closingDate: new Date().toISOString() 
                };
                await updateDoc(doc(db, "customers", String(ownerCustomer.id)), updatedCustomer);
            }

            setShowModal(false);
            setReviewingUnit(null);
            alert('تم نشر العقار بنجاح وبنفس المعرف الأصلي لضمان سهولة الحذف لاحقاً.');

        } catch (error) {
            console.error("Error approving and saving project:", error);
            alert("حدث خطأ أثناء الحفظ والنشر: " + error.message);
        }
    };

    // دالة رفض وحذف طلب وحدة
    const handleReject = async (id) => {
        if(window.confirm('هل أنت متأكد من رفض وحذف هذا الطلب؟')) {
            try {
                // 1. الحذف من Firebase Firestore (مجموعة pending_units)
                await deleteDoc(doc(db, "pending_units", String(id)));

                // 2. تحديث الـ State محلياً
                setPendingUnits(pendingUnits.filter(u => u.id !== id));
                alert('تم حذف الطلب نهائياً.');
            } catch (error) {
                console.error("Error deleting document:", error);
                alert("فشل في حذف الطلب من قاعدة البيانات. حاول مرة أخرى.");
            }
        }
    };
    
    // دالة لفتح رابط الواتساب للمالك
    const openOwnerWhatsapp = (phone) => {
        const cleanPhone = String(phone).replace(/\D/g, '');
        if (!cleanPhone) return;
        let finalNumber = cleanPhone;
        if (finalNumber.startsWith('0')) {
            finalNumber = '20' + finalNumber.substring(1);
        } else if (!finalNumber.startsWith('20') && finalNumber.length === 10) { 
             finalNumber = '20' + finalNumber;
        }

        window.open(`https://wa.me/${finalNumber}`, '_blank');
    };

    return (
        <div className="space-y-6 animate-fade-in">
            <h2 className="text-2xl font-bold flex items-center gap-2"><ClipboardList className="w-6 h-6 text-orange-600" /> مراجعة طلبات "طلب عرض وحدة"</h2>
            {/* تحسين الجداول للموبايل */}
            <div className={`rounded-xl shadow-sm overflow-x-auto border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}> 
                {pendingUnits.length === 0 ? (
                    <div className="p-12 text-center text-gray-500">لا توجد وحدات بانتظار المراجعة حالياً.</div>
                ) : (
                    <div className="min-w-[800px]"> {/* إضافة عرض أدنى لضمان التمرير */}
                        <table className="w-full text-right text-sm">
                            <thead className={darkMode ? 'bg-gray-700' : 'bg-gray-50'}>
                                <tr>
                                     <th className="p-4">صورة</th>
                                     <th className="p-4">بيانات العقار</th>
                                     <th className="p-4">السعر والمساحة</th>
                                     <th className="p-4">بيانات المالك</th>
                                     <th className="p-4">إجراءات</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y dark:divide-gray-700">
                                {pendingUnits.map(unit => (
                                     <tr key={unit.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/50">
                                         <td className="p-4"><img src={unit.images[0]} alt="unit" className="w-16 h-16 object-cover rounded-lg border" /></td>
                                         <td className="p-4">
                                             <div className="font-bold text-lg">{unit.name}</div>
                                             <div className="text-gray-500 text-xs mt-1">{unit.location} - {unit.category}</div>
                                             <div className="text-gray-500 text-xs mt-1">{unit.bedrooms} غرف - {unit.bathrooms} حمام</div>
                                         </td>
                                         <td className="p-4">
                                             <div className="font-bold text-blue-600">{Number(unit.price).toLocaleString()} ج.م</div>
                                             <div className="text-xs">{unit.area} م²</div>
                                             <div className="text-xs bg-gray-100 px-2 py-1 rounded inline-block mt-1 text-black">{unit.status || 'كاش'}</div>
                                         </td>
                                         <td className="p-4">
                                             <div className="font-bold">{unit.ownerName}</div>
                                             <div className="text-xs font-mono">{unit.ownerPhone}</div>
                                             <div className="text-xs text-gray-400 mt-1">{unit.dateSubmitted}</div>
                                             {unit.ownerPhone && (
                                                 <button onClick={() => openOwnerWhatsapp(unit.ownerPhone)} className="mt-1 text-xs text-green-600 hover:underline flex items-center gap-1">
                                                     <MessageCircle className="w-3 h-3 ml-1" /> واتساب
                                                 </button>
                                             )}
                                         </td>
                                         <td className="p-4">
                                             <div className="flex flex-col gap-2">
                                                 <button onClick={() => handleReview(unit)} className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 text-xs font-bold flex items-center justify-center">
                                                     <Edit className="w-3 h-3 ml-1" /> مراجعة وتعديل
                                                 </button>
                                                 <button onClick={() => handleReject(unit.id)} className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 text-xs font-bold">
                                                     رفض وحذف
                                                 </button>
                                             </div>
                                         </td>
                                     </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* استخدام ProjectModal للمراجعة والتعديل */}
            {showModal && (
                <ProjectModal 
                    project={reviewingUnit} 
                    onClose={() => { setShowModal(false); setReviewingUnit(null); }} 
                    onSave={handleApproveAndSave} 
                    darkMode={darkMode} 
                />
            )}
        </div>
    );
};
// قم بتعديل السطر الأول في تعريف المكون
const MortgageRequestsManager = ({ mortgageRequests, setMortgageRequests, reps, setProjects, darkMode, logActivity }) => { 
    
    // 💡 1. دالة تحويل الطلب للمندوب عبر الواتساب (نفس نظام المهام)
    const handleTransferToRep = (request, repId) => {
        const rep = reps.find(r => String(r.id) === String(repId));
        if (!rep) return toast.error("يرجى اختيار مندوب أولاً");

        // تنسيق رسالة احترافية ببيانات التمويل كاملة للمندوب
        const message = `*📦 طلب تمويل عقاري محول إليك*%0A` +
            `--------------------------%0A` +
            `👤 *العميل:* ${request.name}%0A` +
            `📞 *الهاتف:* ${request.phone}%0A` +
            `🎂 *السن:* ${request.age || 'غير محدد'}%0A` +
            `💍 *الحالة:* ${request.maritalStatus || 'غير محدد'}%0A` +
            `💵 *الراتب:* ${Number(request.salary).toLocaleString()} ج.م%0A` +
            `🏠 *الميزانية:* ${Number(request.budget).toLocaleString()} ج.م%0A` +
            `🏦 *المبادرة:* ${request.initiativeType || 'عادية'}%0A` +
            `🚫 *قرض شخصي:* ${request.hasPersonalLoan}%0A` +
            `💳 *فيزا مشتريات:* ${request.hasCarLoan}%0A` +
            `--------------------------%0A` +
            `📝 *ملاحظات العميل:* ${request.notes || 'لا يوجد'}%0A` +
            `--------------------------%0A` +
            `*يرجى التواصل مع العميل وتحديث الحالة في السيستم.*`;

        // تنظيف رقم هاتف المندوب
        const cleanPhone = String(rep.whatsappLink || rep.phone).replace(/\D/g, '');
        const finalPhone = cleanPhone.length === 11 ? '20' + cleanPhone.substring(1) : cleanPhone;

        // فتح واتساب المندوب
        window.open(`https://wa.me/${finalPhone}?text=${message}`, '_blank');
        
        // تسجيل الحركة في سجل العمليات
        logActivity("طلبات التمويل", `تم تحويل طلب العميل (${request.name}) إلى المندوب (${rep.name}) عبر الواتساب`);
        toast.success(`تم فتح واتساب ${rep.name}`);
    };

    // 1. تصحيح تحديث الحالة: إضافة async/await لضمان اكتمال العملية في السيرفر
    const handleUpdateFollowUpStatus = async (id, newStatus) => {
        try {
            const requestRef = doc(db, "mortgage_requests", String(id));
            await updateDoc(requestRef, { followUpStatus: newStatus });
            
            // 💡 كود التسجيل:
            logActivity("طلبات التمويل", `تغيير حالة طلب التمويل رقم (${id}) إلى: ${newStatus}`);
            
            console.log("تم تحديث الحالة في السيرفر");
            toast.success("تم تحديث الحالة بنجاح");
        } catch (error) {
            console.error("خطأ في تحديث الحالة:", error);
            alert("فشل تحديث الحالة في قاعدة البيانات.");
        }
    };

    // 2. تصحيح دالة الحذف: المشكلة كانت هنا (String ID)
    // ********** دالة الحذف المُحدَّثة والكاملة **********
    const handleDelete = async (id) => {
        if (!id) {
            toast.error("عفواً، لا يوجد معرف لهذه الوحدة للحذف.");
            return;
        }

        if (window.confirm('هل أنت متأكد من حذف هذا الطلب نهائياً؟')) {
            const loadingToast = toast.loading('جاري حذف الطلب...');
            
            try {
                const docId = String(id);
                // ملاحظة: هنا نحذف من mortgage_requests وليس من projects
                const requestRef = doc(db, "mortgage_requests", docId);
                
                await deleteDoc(requestRef);

                // التحديث المحلي سيتم عبر onSnapshot تلقائياً في RealEstateApp
                toast.success("تم حذف طلب التمويل بنجاح", { id: loadingToast });
                
            } catch (error) {
                console.error("Detailed Delete Error:", error);
                toast.error(`حدث خطأ أثناء الحذف: ${error.message}`, { id: loadingToast });
            }
        }
    };
    
    // دالة مساعدة لتحديد تنسيق الحالة (بقيت كما هي)
    const statusOptions = ['لم يتم التواصل', 'تم الاتصال (مرفوض)', 'تم الاتصال (مهتم)', 'تم التواصل واتساب'];
    const getStatusStyle = (status) => {
        switch (status) {
            case 'تم الاتصال (مهتم)': return 'bg-green-100 text-green-700';
            case 'تم التواصل واتساب': return 'bg-blue-100 text-blue-700';
            case 'تم الاتصال (مرفوض)': return 'bg-red-100 text-red-700';
            default: return 'bg-yellow-100 text-yellow-700';
        }
    };
    
    return (
        <div className="space-y-6 animate-fade-in">
            <h2 className="text-2xl font-bold flex items-center gap-2">
                <Banknote className="w-6 h-6 text-green-600" /> طلبات التمويل العقاري
            </h2>
            <div className={`rounded-xl shadow-sm overflow-x-auto border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                {mortgageRequests.length === 0 ? (
                    <div className="p-12 text-center text-gray-500">لا توجد طلبات تمويل جديدة.</div>
                ) : (
                    <div className="min-w-[1200px]"> 
                        <table className="w-full text-right text-sm">
                            <thead className={darkMode ? 'bg-gray-700' : 'bg-gray-50'}>
                                <tr>
                                    <th className="p-4">الاسم والتاريخ</th>
                                    <th className="p-4">السن والحالة</th>
                                    <th className="p-4">الراتب (6 شهور)</th>
                                    <th className="p-4">الالتزامات البنكية</th>
                                    <th className="p-4">حالة التواصل</th> 
                                    <th className="p-4 text-purple-600 font-bold">تحويل لمندوب</th> {/* 👈 العمود الجديد */}
                                    <th className="p-4">التواصل</th>
                                    <th className="p-4">حذف</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y dark:divide-gray-700">
                                {mortgageRequests.map(req => (
                                    <tr key={req.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/50">
                                        <td className="p-4">
                                            <div className="font-bold text-lg">{req.name || 'غير محدد'}</div>
                                            <div className="text-xs text-gray-400">{req.date}</div>
                                            {req.notes && <div className="text-xs text-gray-500 mt-1 bg-yellow-50 dark:bg-yellow-900/20 p-1 rounded border border-yellow-100 text-black dark:text-yellow-200">ملاحظة: {req.notes}</div>}
                                        </td>
                                        <td className="p-4">
                                            <div className="font-bold text-gray-600 dark:text-gray-300">{req.age || 'غير محدد'} سنة</div>
                                            <div className="text-xs font-bold text-blue-600">{req.maritalStatus || 'غير محدد'}</div>
                                        </td>
                                        <td className="p-4">
                                            <div className="font-bold text-blue-600 text-lg">
                                                {req.salary ? Number(req.salary).toLocaleString() : '0'} ج.م
                                            </div>
                                            <div className="text-xs text-gray-500">ميزانية: {req.budget ? Number(req.budget).toLocaleString() : '0'} ج.م</div>
                                        </td>
                                        <td className="p-4 text-xs">
                                            <div className="flex flex-col gap-1">
                                                <span className={(req.hasPersonalLoan || 'لا') === 'نعم' ? 'text-red-600 font-bold' : 'text-green-600'}>• قرض شخصي: {req.hasPersonalLoan || 'لا'}</span>
                                                <span className={(req.hasCarLoan || 'لا') === 'نعم' ? 'text-red-600 font-bold' : 'text-green-600'}>• فيزا مشتريات: {req.hasCarLoan || 'لا'}</span>
                                                <span className={(req.otherObligations || 'لا') === 'نعم' ? 'text-red-600 font-bold' : 'text-green-600'}>• التزامات أخرى: {req.otherObligations || 'لا'}</span>
                                            </div>
                                        </td>
                                        <td className="p-4">
                                            <select 
                                                value={req.followUpStatus || 'لم يتم التواصل'}
                                                onChange={(e) => handleUpdateFollowUpStatus(req.id, e.target.value)}
                                                className={`px-2 py-1 rounded text-xs font-bold w-full cursor-pointer ${getStatusStyle(req.followUpStatus)} ${darkMode ? 'bg-gray-900 border-gray-600' : 'border-gray-300'}`}
                                            >
                                                {statusOptions.map(s => (<option key={s} value={s}>{s}</option>))}
                                            </select>
                                        </td>

                                        {/* 🟢 بداية خلية التحويل للمندوب */}
                                        <td className="p-4">
                                            <div className="flex flex-col gap-2 min-w-[150px]">
                                                <select 
                                                    className={`p-1.5 text-[10px] rounded-lg border font-bold shadow-sm outline-none focus:ring-1 focus:ring-purple-500 ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                                                    onChange={(e) => {
                                                        if(e.target.value) handleTransferToRep(req, e.target.value);
                                                    }}
                                                    defaultValue=""
                                                >
                                                    <option value="" disabled>اختر مندوباً للتحويل</option>
                                                    {reps && reps.map(r => (
                                                        <option key={r.id} value={r.id}>{r.name} ({r.branch})</option>
                                                    ))}
                                                </select>
                                                <div className="flex items-center justify-center gap-1 opacity-60">
                                                    <Share2 size={10} className="text-purple-500" />
                                                    <p className="text-[8px] text-gray-400 text-center">سيفتح واتساب المندوب فوراً</p>
                                                </div>
                                            </div>
                                        </td>
                                        {/* 🟢 نهاية خلية التحويل */}

                                        <td className="p-4">
                                            <div className="font-mono text-lg mb-1">{req.phone || 'N/A'}</div>
                                            <div className="flex gap-2">
                                                {req.phone && (
                                                    <>
                                                        <a href={`tel:${req.phone}`} className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 text-xs flex items-center gap-1"><Phone className="w-3 h-3"/> اتصال</a>
                                                        <a href={`https://wa.me/20${String(req.phone).replace(/^0/, '')}`} target="_blank" rel="noreferrer" className="px-3 py-1 bg-green-600 text-white rounded hover:bg-green-700 text-xs flex items-center gap-1"><MessageCircle className="w-3 h-3"/> واتساب</a>
                                                    </>
                                                )}
                                            </div>
                                        </td>
                                        <td className="p-4">
                                            <button onClick={() => handleDelete(req.id)} className="text-red-500 hover:bg-red-50 p-2 rounded transition-all active:scale-90"><Trash2 className="w-5 h-5" /></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};
// ProjectsManager (Component)
const ProjectsManager = ({ projects, setProjects, darkMode, logActivity }) => {
    // تعريف الـ States اللازمة
    const [showModal, setShowModal] = useState(false);
    const [editingProject, setEditingProject] = useState(null);
    
    // 💡 حالة البحث الجديدة
    const [searchTerm, setSearchTerm] = useState('');
const [stepFilter, setStepFilter] = useState('all'); // فلتر الخطوات الجديد
    // 💡 دالة التصفية والبحث الذكية - تحافظ على أداء التطبيق
    const filteredProjects = useMemo(() => {
        if (!searchTerm.trim()) return projects || [];
        
        const term = searchTerm.toLowerCase();
        return (projects || []).filter(p => 
            p.name?.toLowerCase().includes(term) ||      // بحث بالاسم
            p.location?.toLowerCase().includes(term) ||  // بحث بالموقع
            p.code?.toLowerCase().includes(term) ||      // بحث بالكود
            p.category?.toLowerCase().includes(term) ||  // بحث بنوع الوحدة (شقة/فيلا)
            p.description?.toLowerCase().includes(term)  // بحث داخل الوصف التفصيلي
        );
    }, [projects, searchTerm]);

    // ********** دالة الحذف المُحدَّثة والكاملة لضمان المسح النهائي **********
    const handleDelete = async (id) => {
        if (!id) {
            toast.error("عفواً، لا يوجد معرف لهذه الوحدة للحذف.");
            return;
        }

        if (window.confirm('هل أنت متأكد من حذف هذا العقار نهائياً؟ سيتم حذف جميع الصور المرتبطة به أيضاً من السيرفر.')) {
            const loadingToast = toast.loading('جاري حذف العقار وملفاته...');
            
            try {
                const docId = String(id);
                const projectRef = doc(db, "projects", docId);
                
                // 1. جلب بيانات العقار قبل حذفه للحصول على روابط الصور
                const docSnapshot = await getDoc(projectRef);
                
                if (docSnapshot.exists()) {
                    const projectData = docSnapshot.data();
                    
                    // 2. حذف الصور من Firebase Storage إذا كانت موجودة
                    if (projectData.images && Array.isArray(projectData.images) && projectData.images.length > 0) {
                        await Promise.allSettled(projectData.images.map(async (url) => {
                            try {
                                if (url && typeof url === 'string' && url.includes('firebasestorage')) {
                                    const imageRef = ref(storage, url);
                                    await deleteObject(imageRef);
                                }
                            } catch (storageError) {
                                console.warn(`فشل حذف صورة من Storage: ${url}`, storageError);
                            }
                        }));
                    }
                }

                // 3. الحذف الفعلي للمستند من Firestore
                await deleteDoc(projectRef);

                // 4. تحديث الحالة المحلية (State) فوراً ليختفي من الموقع
                if (typeof setProjects === 'function') {
                    setProjects(prevProjects => prevProjects.filter(p => String(p.id) !== docId));
                }

                toast.success("تم حذف العقار وكافة ملفاته بنجاح", { id: loadingToast });
                
            } catch (error) {
                console.error("Detailed Delete Error:", error);
                toast.error(`حدث خطأ أثناء الحذف: ${error.message}`, { id: loadingToast });
            }
        }
    };

    // 💡 دالة حفظ/تعديل العقار
    const handleSaveProject = async (data) => {
    if (!data.name || !data.price || !data.location) {
        alert("يرجى ملء الحقول الأساسية (الاسم، السعر، الموقع).");
        return;
    }

    try {
        // 1. رفع الملفات الجديدة إلى Firebase Storage
        const newImageUrls = [];
        const uploadPromises = (data.rawFiles || []).map(async (file) => {
            const storageRef = ref(storage, `project_units/${Date.now()}_${file.name}`);
            const snapshot = await uploadBytes(storageRef, file);
            const downloadURL = await getDownloadURL(snapshot.ref);
            newImageUrls.push(downloadURL);
        });

        await Promise.all(uploadPromises);
        
        // 2. تجميع قائمة الروابط النهائية
        const existingImageUrls = (data.images || []).filter(url => typeof url === 'string' && !url.startsWith('blob:'));
        const finalImageUrls = [...existingImageUrls, ...newImageUrls];

        // 3. تجهيز بيانات المشروع للحفظ في Firestore
        const projectData = {
            name: data.name || '',
            code: data.code || '',
            location: data.location || '',
            category: data.category || 'شقة',
            status: data.status || 'كاش',
            description: data.description || '',
            mobile: data.mobile || '',
            whatsappLink: data.whatsappLink || '',
            videoUrl: data.videoUrl || '', 
            price: Number(data.price) || 0,
            area: Number(data.area) || 0,
            bedrooms: Number(data.bedrooms) || 0,
            bathrooms: Number(data.bathrooms) || 0,
            images: finalImageUrls, 
            features: data.features || [],
            rawFiles: null, 
            ownerName: data.ownerName || null,
            ownerPhone: data.ownerPhone || null,
        };

        // 4. الحفظ/التعديل في Firestore مع تسجيل العملية في السجل
        if (data.id) {
            const docId = String(data.id);
            const docRef = doc(db, "projects", docId);
            const checkDoc = await getDoc(docRef);
            
            if (!checkDoc.exists()) {
                alert('عفواً، لا يمكن تحديث هذا العقار لأنه غير موجود في قاعدة البيانات.');
                return; 
            }

            await updateDoc(docRef, projectData);
            
            // 💡 تسجيل عملية التعديل في سجل العمليات
            await logActivity("إدارة العقارات", `قام بتعديل بيانات العقار: ${projectData.name} (كود: ${projectData.code})`);
            
            alert("تم تحديث العقار بنجاح.");
        } else {
            await addDoc(collection(db, "projects"), { 
                ...projectData, 
                createdAt: new Date().toISOString() 
            });
            
            // 💡 تسجيل عملية الإضافة في سجل العمليات
            await logActivity("إدارة العقارات", `قام بإضافة عقار جديد باسم: ${projectData.name} (كود: ${projectData.code})`);
            
            alert("تم إضافة العقار الجديد بنجاح.");
        }

        setShowModal(false);
        setEditingProject(null);
        
    } catch (error) {
        console.error("خطأ في حفظ المشروع:", error);
        alert(`فشل في حفظ المشروع: ${error.message}`);
    }
};

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center flex-wrap gap-4"> 
                <h2 className="text-2xl font-bold">إدارة العقارات المعتمدة</h2>
                <button onClick={() => { setEditingProject(null); setShowModal(true); }} className="px-4 py-2 bg-blue-600 text-white rounded-lg flex items-center shadow-lg hover:bg-blue-700 transition">
                    <Plus className="w-4 h-4 ml-2" /> إضافة عقار جديد
                </button>
            </div>

            {/* 🔍 شريط البحث المطور - مدمج لسهولة الوصول */}
            <div className={`p-4 rounded-xl border shadow-sm flex items-center gap-3 transition-all ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'}`}>
                <Search className="text-gray-400 w-5 h-5" />
                <input 
                    type="text" 
                    placeholder="ابحث بالكود، المنطقة، اسم العقار أو أي تفاصيل..." 
                    className="flex-1 bg-transparent outline-none text-sm font-bold"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                {searchTerm && (
                    <button onClick={() => setSearchTerm('')} className="text-gray-400 hover:text-red-500 transition-colors">
                        <X size={18} />
                    </button>
                )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"> 
                {filteredProjects.map(p => (
                    <div key={p.id} className={`rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                        <div className="h-48 relative group bg-gray-100">
                            <img 
                                src={(p.images && p.images.length > 0) ? p.images[0] : 'https://via.placeholder.com/400?text=No+Image+Found'} 
                                alt={p.name} 
                                className="w-full h-full object-cover" 
                            />
                            
                            <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                <div className="flex gap-2">
                                    <button 
                                        onClick={() => { setEditingProject(p); setShowModal(true); }} 
                                        className="bg-white p-3 rounded-full text-blue-600 shadow-md hover:bg-blue-50"
                                        title="تعديل العقار"
                                    ><Edit className="w-5 h-5" /></button>
                                    <button 
                                        onClick={() => handleDelete(p.id)} 
                                        className="bg-white p-3 rounded-full text-red-600 shadow-md hover:bg-red-50"
                                        title="حذف العقار"
                                    ><Trash2 className="w-5 h-5" /></button>
                                </div>
                            </div>
                            
                            <div className={`absolute bottom-2 left-2 text-white text-xs px-3 py-1 rounded backdrop-blur-sm font-bold ${p.status === 'تمويل عقاري' ? 'bg-green-600/80' : 'bg-black/60'}`}>{p.status}</div>
                        </div>
                        
                        <div className="p-4">
                            <div className="flex justify-between items-center mb-1">
                                <span className="text-[10px] font-bold bg-blue-100 text-blue-700 px-2 py-0.5 rounded-md">
                                    #{p.code || 'N/A'}
                                </span>
                                <h3 className="font-bold text-lg line-clamp-1 flex-1 mr-2 text-left">
                                    {p.name}
                                </h3>
                            </div>

                            <p className="text-sm text-gray-500 mb-3 flex items-center">
                                <MapPin className="w-3 h-3 ml-1" /> {p.location}
                            </p>
                            <div className="flex justify-between items-center text-sm pt-3 border-t dark:border-gray-700">
                                <span className="font-bold text-blue-600">{Number(p.price || 0).toLocaleString()} ج.م</span>
                                <span className="text-gray-500">{p.area || 0} م²</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* عرض رسالة تنبيه في حال عدم وجود نتائج بحث */}
            {filteredProjects.length === 0 && searchTerm && (
                <div className="p-12 text-center text-gray-500 bg-gray-100 dark:bg-gray-700 rounded-xl border-2 border-dashed border-gray-200 dark:border-gray-600">
                    <Search className="w-12 h-12 mx-auto mb-3 opacity-20" />
                    <p className="text-lg">لا توجد نتائج تطابق "{searchTerm}"</p>
                    <button onClick={() => setSearchTerm('')} className="mt-2 text-blue-600 font-bold underline">عرض جميع العقارات</button>
                </div>
            )}

            {(!projects || projects.length === 0) && !searchTerm && (
                <div className="p-12 text-center text-gray-500 bg-gray-100 dark:bg-gray-700 rounded-xl">لا توجد عقارات مُعتمدة بعد.</div>
            )}
            
            {showModal && <ProjectModal project={editingProject} onClose={() => setShowModal(false)} onSave={handleSaveProject} darkMode={darkMode} />}
        </div>
    );
};
const CustomersManager = ({ customers, setCustomers, reps, sales, setSales, transactions, setTransactions, darkMode, onSaveCustomer, logActivity }) => {
    const [showModal, setShowModal] = useState(false);
    const [editingCustomer, setEditingCustomer] = useState(null);
    const [filterType, setFilterType] = useState('all');
    const [searchTerm, setSearchTerm] = useState(''); 
const [stepFilter, setStepFilter] = useState('all');
    const handleSaveFromModal = (data) => {
        onSaveCustomer(data); 
        setShowModal(false); 
    };

    // 💡 الدالة المحدثة لإغلاق الصفقة (Smart Closing) 
    // تقوم بتحديث: العميل + إضافة سجل مبيعات + إضافة حركة مالية في الخزينة
    const handleCloseDeal = async (customer) => {
        const finalPrice = prompt(`أدخل المبلغ النهائي لإغلاق صفقة العميل ${customer.name}:`, customer.closedAmount || '');
        
        if (!finalPrice || isNaN(finalPrice)) return;

        const branchChoice = prompt(`اختر الفرع للترحيل المالي (1 للمعاير، 2 للمهندسين):`, "1");
        const targetBranch = branchChoice === "2" ? "المهندسين" : "المعادي";

        if (window.confirm(`هل أنت متأكد من إتمام الصفقة بمبلغ ${Number(finalPrice).toLocaleString()} ج.م وترحيلها لخزينة فرع ${targetBranch}؟`)) {
            
            const dealAmount = Number(finalPrice);
            const dateNow = new Date().toISOString().split('T')[0];
            const customerId = String(customer.id);

            try {
                // 1. تحديث حالة العميل في Firestore
                const customerRef = doc(db, "customers", customerId);
                await updateDoc(customerRef, {
                    status: 'تم التنفيذ',
                    closedAmount: dealAmount,
                    closingDate: new Date().toISOString(),
                    closingBranch: targetBranch 
                });

                // 2. إضافة سجل مبيعات جديد لـ Sales
                const saleData = {
                    contractNumber: `CNT-${Math.floor(Math.random() * 100000)}`,
                    customerId: customerId,
                    customerName: customer.name,
                    projectName: 'إغلاق سريع من سجل العملاء',
                    amount: dealAmount,
                    repId: String(customer.repId || ''),
                    date: dateNow,
                    status: 'مكتمل',
                    branch: targetBranch
                };
                await addDoc(collection(db, "sales"), saleData);

                // 3. ترحيل إيراد فوري للخزينة Transactions
                const transactionData = {
                    type: 'income',
                    title: `إتمام صفقة (سريع): ${customer.name}`,
                    amount: dealAmount,
                    date: dateNow,
                    category: 'مبيعات',
                    branch: targetBranch,
                    repId: String(customer.repId || ''),
                    customerName: customer.name // محفوظ للربط عند الحذف العكسي
                };
                await addDoc(collection(db, "transactions"), transactionData);

                alert(`تم إغلاق الصفقة بنجاح! 
- تم تحديث حالة العميل.
- تم تسجيل المبيعات.
- تم ترحيل المبلغ لخزينة ${targetBranch}.`);
                
            } catch (error) {
                console.error("Error closing deal from customers manager:", error);
                alert("حدث خطأ أثناء الاتصال بقاعدة البيانات.");
            }
        }
    };

    // 1. الدالة الجديدة بعد الاستبدال
    const getFilteredCustomers = () => {
        // 1. الفلترة حسب النوع
        let filtered = customers.filter(c => {
            switch (filterType) {
                case 'seller': return c.type === 'بائع';
                case 'regular': return c.type === 'عادي' || c.type === 'شركة';
                case 'vip': return c.type === 'VIP';
                default: return true;
            }
        });

        // 2. الفلترة حسب خطوة التمويل (هنا سيتم التعرف على stepFilter الآن)
        if (stepFilter !== 'all') {
            filtered = filtered.filter(c => c.steps?.includes(stepFilter));
        }
        
        // 3. الفلترة حسب كلمة البحث
        if (!searchTerm) return filtered;
        const lowerCaseSearch = searchTerm.toLowerCase();
        
        return filtered.filter(c => 
            c.name.toLowerCase().includes(lowerCaseSearch) ||
            c.phone.includes(lowerCaseSearch) ||
            (c.unitLocation && c.unitLocation.toLowerCase().includes(lowerCaseSearch))
        );
    };

    // 2. السطر الذي يستدعي الدالة (يجب أن يبقى كما هو)
    const displayCustomers = getFilteredCustomers();

    const handleDeleteCustomer = async (id) => {
        if(window.confirm('هل أنت متأكد من حذف هذا العميل نهائياً من قاعدة البيانات؟')) {
            try {
                await deleteDoc(doc(db, "customers", String(id)));
                setCustomers(prev => prev.filter(c => String(c.id) !== String(id)));
                alert('تم حذف العميل بنجاح');
            } catch (error) {
                console.error("Error deleting customer: ", error);
                alert('حدث خطأ أثناء الحذف، تأكد من اتصال الإنترنت');
            }
        }
    };

    return (
        <div className="space-y-6 animate-fade-in">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                <div>
                    <h2 className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>سجل العملاء والعقارات</h2>
                    <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>قاعدة بيانات العملاء والملاك</p>
                </div>
                
                <div className="flex flex-wrap gap-2 no-print">
                    <button 
                        onClick={() => exportToExcel(displayCustomers, "سجل_العملاء")}
                        className="bg-green-600 text-white px-4 py-2 rounded-lg text-sm font-bold flex items-center gap-2 hover:bg-green-700 shadow-md transition"
                    >
                        <Download className="w-4 h-4" /> إكسيل
                    </button>

                    <button 
                        onClick={() => window.print()}
                        className="bg-gray-600 text-white px-4 py-2 rounded-lg text-sm font-bold flex items-center gap-2 hover:bg-gray-700 shadow-md transition"
                    >
                        <ListIcon className="w-4 h-4" /> طباعة
                    </button>

                    <button 
                        onClick={() => { setEditingCustomer(null); setShowModal(true); }} 
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg flex items-center shadow-lg hover:bg-blue-700 transition"
                    >
                        <Plus className="w-4 h-4 ml-2" /> تسجيل جديد
                    </button>
                </div>
            </div>

            <div className="flex flex-col md:flex-row justify-between items-center gap-4 no-print">
                <input 
                    type="text"
                    placeholder="ابحث بالاسم أو الهاتف أو المنطقة..."
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    className={`p-3 border rounded-lg w-full md:w-1/3 outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                        darkMode ? 'bg-gray-800 border-gray-700 text-white placeholder-gray-400' : 'bg-white border-gray-300 text-gray-900'
                    }`}
                />
                <div className={`flex flex-wrap gap-1 p-1 rounded-lg w-full md:w-fit justify-center ${
                    darkMode ? 'bg-gray-800 border border-gray-700' : 'bg-gray-100'
                }`}>
                    <button onClick={() => setFilterType('all')} className={`px-4 py-2 rounded-md text-sm font-bold transition ${filterType === 'all' ? (darkMode ? 'bg-gray-600 text-blue-400 shadow' : 'bg-white shadow text-blue-600') : (darkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500')}`}>الكل</button>
                    <button onClick={() => setFilterType('seller')} className={`px-4 py-2 rounded-md text-sm font-bold transition ${filterType === 'seller' ? (darkMode ? 'bg-gray-600 text-orange-400 shadow' : 'bg-white shadow text-orange-600') : (darkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500')}`}>ملاك</button>
                    <button onClick={() => setFilterType('regular')} className={`px-4 py-2 rounded-md text-sm font-bold transition ${filterType === 'regular' ? (darkMode ? 'bg-gray-600 text-blue-400 shadow' : 'bg-white shadow text-blue-600') : (darkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500')}`}>عاديين</button>
                    <button onClick={() => setFilterType('vip')} className={`px-4 py-2 rounded-md text-sm font-bold transition ${filterType === 'vip' ? (darkMode ? 'bg-gray-600 text-purple-400 shadow' : 'bg-white shadow text-purple-600') : (darkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500')}`}>VIP</button>
{/* إضافة قائمة منسدلة لفلترة الخطوات */}
                <div className="flex items-center gap-2 mr-4 border-r pr-4 border-gray-300 dark:border-gray-600">
                    <span className="text-[10px] font-bold text-gray-400">مرحلة:</span>
                    <select 
                        value={stepFilter} 
                        onChange={(e) => setStepFilter(e.target.value)}
                        className={`p-1.5 rounded text-[10px] font-bold outline-none border ${
                            darkMode ? 'bg-gray-800 border-gray-700 text-blue-400' : 'bg-white border-gray-200 text-blue-600'
                        }`}
                    >
                        <option value="all">كل المراحل</option>
                        {MORTGAGE_STEPS.map(step => (
                            <option key={step.id} value={step.id}>{step.label}</option>
                        ))}
                    </select>
                </div>
                </div>
            </div>

            <div className={`rounded-xl shadow-sm overflow-x-auto border transition-all ${
                darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
            }`}>
                <table className="w-full text-right text-sm min-w-[800px]">
                    <thead className={`${darkMode ? 'bg-gray-700/50 text-gray-200' : 'bg-gray-50 text-gray-600'}`}>
                        <tr>
                            <th className={`p-4 border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>الاسم</th>
                            <th className={`p-4 border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>التصنيف</th>
                            <th className={`p-4 border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>تفاصيل الطلب/العقار</th>
                            <th className={`p-4 border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>البنك (التمويل)</th>
                            <th className={`p-4 border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>المندوب</th>
<th className={`p-4 border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>إجراءات التمويل</th>
                            <th className={`p-4 border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>الحالة</th>
                            <th className={`p-4 border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'} no-print`}>إجراءات</th>
                        </tr>
                    </thead>
                    <tbody className={`divide-y ${darkMode ? 'divide-gray-700' : 'divide-gray-200'}`}>
                        {displayCustomers.map(c => (
                            <tr key={c.id} className={`transition-colors ${darkMode ? 'hover:bg-gray-700/30 text-gray-300' : 'hover:bg-gray-50 text-gray-900'}`}>
                                <td className="p-4">
                                    <div className={`font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>{c.name}</div>
                                    <div className={`text-xs font-mono ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>{c.phone}</div>
                                </td>
                                <td className="p-4">
                                    <span className={`px-2 py-1 rounded text-xs font-bold ${c.type === 'VIP' ? 'bg-purple-100 text-purple-700' : c.type === 'بائع' ? 'bg-orange-100 text-orange-700' : 'bg-blue-50 text-blue-700'}`}>{c.type}</span>
                                </td>
                                <td className="p-4 text-xs">
                                    <div className={`font-bold mb-1 ${darkMode ? 'text-gray-200' : 'text-gray-800'}`}>{c.unitLocation} {c.unitArea ? `(${c.unitArea} م)` : ''}</div>
                                    {c.unitFloor && <div className={`${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>الدور: {c.unitFloor}</div>}
                                    <div className={`font-mono ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>{c.budget ? c.budget.toLocaleString() : '-'}</div>
                                </td>
                                <td className={`p-4 text-xs font-bold ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                    {c.bank ? <span className="flex items-center"><Landmark className="w-3 h-3 ml-1" /> {c.bank}</span> : '-'}
                                </td>
                                <td className={`p-4 font-medium ${darkMode ? 'text-blue-400' : 'text-blue-600'}`}>
                                    {reps.find(r => String(r.id) === String(c.repId))?.name || 'غير معين'}
                                </td>
<td className="p-4">
                                    <div className="w-32">
                                        <div className="flex justify-between text-[9px] mb-1 font-bold">
                                            <span className="text-gray-400">مستوى الإنجاز</span>
                                            <span className="text-blue-600">{Math.round(((c.steps?.length || 0) / MORTGAGE_STEPS.length) * 100)}%</span>
                                        </div>
                                        <div className="w-full h-1.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                                            <div 
                                                className="h-full bg-blue-600 transition-all duration-500" 
                                                style={{ width: `${((c.steps?.length || 0) / MORTGAGE_STEPS.length) * 100}%` }}
                                            ></div>
                                        </div>
                                        <div className="mt-1 flex flex-wrap gap-1">
                                            {c.steps?.length > 0 && (
                                                <span className="text-[8px] bg-green-50 text-green-600 px-1 rounded border border-green-100 font-bold">
                                                    {MORTGAGE_STEPS.find(s => s.id === c.steps[c.steps.length - 1])?.label}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </td>
                                <td className="p-4">
                                    <span className={`px-2 py-1 rounded text-xs font-bold ${c.status === 'تم التنفيذ' ? 'bg-green-100 text-green-700' : (darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-600')}`}>{c.status}</span>
                                </td>
                                <td className="p-4 flex gap-2 no-print">
                                    {c.status !== 'تم التنفيذ' && (
                                        <button onClick={() => handleCloseDeal(c)} className={`p-2 rounded transition-all ${darkMode ? 'text-green-400 bg-green-900/20 hover:bg-green-900/40' : 'text-green-600 bg-green-50 hover:bg-green-100'}`} title="إغلاق الصفقة">
                                            <CheckCircle className="w-4 h-4" />
                                        </button>
                                    )}
                                    <button onClick={() => { setEditingCustomer(c); setShowModal(true); }} className={`p-2 rounded transition-all ${darkMode ? 'text-blue-400 bg-blue-900/20 hover:bg-blue-900/40' : 'text-blue-600 bg-blue-50 hover:bg-blue-100'}`}>
                                        <Edit className="w-4 h-4" />
                                    </button>
                                    <button onClick={() => handleDeleteCustomer(c.id)} className={`p-2 rounded transition-all ${darkMode ? 'text-red-400 bg-red-900/20 hover:bg-red-900/40' : 'text-red-600 bg-red-50 hover:bg-red-100'}`}>
                                        <Trash2 className="w-4 h-4" />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {displayCustomers.length === 0 && <div className={`p-12 text-center ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>لا يوجد بيانات مطابقة للبحث في هذا القسم</div>}
            </div>

            {showModal && (
                <CustomerModal 
                    customer={editingCustomer} 
                    reps={reps} 
                    onClose={() => setShowModal(false)} 
                    onSave={handleSaveFromModal} 
                    darkMode={darkMode} 
                />
            )}
        </div>
    );
};
const SalesManager = ({ sales, setSales, projects, customers, reps, darkMode, logActivity }) => {
    const [showModal, setShowModal] = useState(false);
    const [editingSale, setEditingSale] = useState(null); // حالة للتحكم في التعديل
    
    // الحالة الابتدائية لنموذج البيع المطور
    const initialSaleState = {
        contractNumber: '', // سيتم توليده تلقائياً
        date: new Date().toISOString().split('T')[0],
        projectId: '', // ربط بالعقار (اختياري)
        projectName: '',
        branch: 'المعادي',
        
        // قسم العميل
        customerId: '',
        customerName: '',
        customerPhone: '',
        customerRepId: '', // مندوب العميل
        customerCommission: '', // عمولة الشركة من العميل
        customerPaid: '', // المبلغ المحصل من العميل
        
        // قسم المالك (الاونر)
        ownerName: '',
        ownerPhone: '',
        ownerRepId: '', // مندوب المالك
        ownerCommission: '', // عمولة الشركة من المالك
        ownerPaid: '', // المبلغ المحصل من المالك
        
        contractTotalValue: '', // إجمالي قيمة العقار في العقد
        notes: ''
    };

    const [formData, setFormData] = useState(initialSaleState);

    // توليد رقم عقد تلقائي عند فتح المودال للإضافة فقط
    useEffect(() => {
        if (showModal && !editingSale) {
            const autoCode = `HOMIX -CNT-${Date.now().toString().slice(-6)}`;
            setFormData(prev => ({ ...prev, contractNumber: autoCode }));
        }
    }, [showModal, editingSale]);

    const handleOpenEdit = (sale) => {
        setEditingSale(sale);
        setFormData(sale);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setEditingSale(null);
        setFormData(initialSaleState);
    };

    const handleSaveSale = async () => {
        if (!formData.customerName || !formData.contractTotalValue) {
            return toast.error("يرجى إدخال اسم العميل وإجمالي قيمة العقد على الأقل");
        }

        const loadingToast = toast.loading('جاري حفظ بيانات العقد والترحيل المالي...');

        try {
            const saleData = {
                ...formData,
                contractTotalValue: Number(formData.contractTotalValue) || 0,
                customerCommission: Number(formData.customerCommission) || 0,
                customerPaid: Number(formData.customerPaid) || 0,
                ownerCommission: Number(formData.ownerCommission) || 0,
                ownerPaid: Number(formData.ownerPaid) || 0,
                updatedAt: new Date().toISOString()
            };

            if (editingSale) {
                // 1. تحديث سجل البيع الحالي في Firebase
                await updateDoc(doc(db, "sales", editingSale.id), saleData);

                // 📝 تسجيل عملية التعديل في سجل العمليات
                await logActivity(
                    "المبيعات",
                    `تعديل بيانات العقد رقم (${formData.contractNumber}) للعميل: ${formData.customerName}`,
                    { previousData: editingSale, newData: saleData }
                );

            } else {
                // 1. إضافة سجل بيع جديد في Firebase
                const saleDoc = await addDoc(collection(db, "sales"), {
                    ...saleData,
                    createdAt: new Date().toISOString()
                });

                // 2. ترحيل الإيراد الإجمالي (المحصل من الطرفين) إلى الخزينة
                const totalIncome = Number(saleData.customerPaid) + Number(saleData.ownerPaid);
                if (totalIncome > 0) {
                    await addDoc(collection(db, "transactions"), {
                        type: 'income',
                        title: `تحصيل عقد رقم ${formData.contractNumber}`,
                        amount: totalIncome,
                        date: formData.date,
                        category: 'مبيعات',
                        branch: formData.branch,
                        saleId: saleDoc.id,
                        customerName: formData.customerName
                    });
                }

                // 📝 تسجيل عملية الإضافة الجديدة في سجل العمليات
                await logActivity(
                    "المبيعات",
                    `تسجيل عقد بيع جديد رقم (${formData.contractNumber}) بمبلغ ${saleData.contractTotalValue.toLocaleString()} ج.م للعميل: ${formData.customerName}`,
                    saleData
                );
            }

            toast.success("تم تسجيل البيانات بنجاح", { id: loadingToast });
            handleCloseModal();
        } catch (error) {
            console.error("Sales Error:", error);
            toast.error("حدث خطأ أثناء الحفظ: " + error.message, { id: loadingToast });
        }
    };

    const inputClass = `w-full p-2.5 border rounded-xl outline-none focus:ring-2 focus:ring-blue-500 transition-all ${darkMode ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' : 'bg-white border-gray-200 text-gray-900'}`;
    const labelClass = "text-[10px] font-bold text-gray-500 mb-1 block mr-1";
    const sectionTitle = "text-sm font-black text-blue-600 mb-4 flex items-center gap-2 border-b pb-2 dark:border-gray-700";

    return (
        <div className="space-y-6 animate-fade-in">
            {/* الهيدر */}
            <div className="flex justify-between items-center flex-wrap gap-4">
                <div>
                    <h2 className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>إدارة المبيعات والعقود</h2>
                    <p className="text-xs text-gray-500">نظام الربط بين المشتري، المالك، والمناديب</p>
                </div>
                <button onClick={() => { setEditingSale(null); setShowModal(true); }} className="bg-blue-600 text-white px-6 py-2.5 rounded-xl font-bold shadow-lg hover:bg-blue-700 transition active:scale-95 flex items-center gap-2">
                    <Plus size={18} /> تسجيل عقد جديد
                </button>
            </div>

            {/* الجدول */}
            <div className={`rounded-2xl border overflow-hidden shadow-sm ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'}`}>
                <div className="overflow-x-auto">
                    <table className="w-full text-right text-sm">
                        <thead className={darkMode ? 'bg-gray-700/50 text-gray-200' : 'bg-gray-50 text-gray-500'}>
                            <tr>
                                <th className="p-4">رقم العقد / التاريخ</th>
                                <th className="p-4">المشتري (العميل)</th>
                                <th className="p-4">البائع (المالك)</th>
                                <th className="p-4">قيمة العقد</th>
                                <th className="p-4 text-green-600">إجمالي المحصل</th>
                                <th className="p-4">الفرع</th>
                                <th className="p-4 text-center">إجراء</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y dark:divide-gray-700">
    {sales.sort((a, b) => b.date.localeCompare(a.date)).map(s => (
        <tr key={s.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors">
            <td className="p-4">
                <div className="font-bold text-blue-600">#{s.contractNumber}</div>
                <div className="text-[10px] opacity-60">{s.date}</div>
            </td>
            <td className="p-4">
                <div className="font-bold">{s.customerName}</div>
                <div className="text-[10px] text-blue-500 font-bold">مندوب: {reps.find(r => String(r.id) === String(s.customerRepId))?.name || '-'}</div>
            </td>
            <td className="p-4">
                <div className="font-bold text-orange-600">{s.ownerName || '-'}</div>
                <div className="text-[10px] text-orange-500 font-bold">مندوب: {reps.find(r => String(r.id) === String(s.ownerRepId))?.name || '-'}</div>
            </td>
            <td className="p-4 font-black">{Number(s.contractTotalValue || 0).toLocaleString()} ج.م</td>
            <td className="p-4">
                <span className="text-green-600 font-black">{(Number(s.customerPaid || 0) + Number(s.ownerPaid || 0)).toLocaleString()}</span>
            </td>
            <td className="p-4"><span className="px-2 py-1 bg-gray-100 dark:bg-gray-700 rounded text-[10px] font-bold">{s.branch}</span></td>
            <td className="p-4">
                <div className="flex justify-center gap-2">
                    {/* زر التعديل */}
                    <button onClick={() => handleOpenEdit(s)} className="p-2 text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-full transition-all" title="تعديل">
                        <Edit size={16}/>
                    </button>
                    
                    {/* زر الحذف الذكي المطور الشامل */}
                    <button onClick={async () => { 
                        if(window.confirm(`⚠️ تحذير: حذف العقد رقم (${s.contractNumber}) سيؤدي لحذف المبالغ المحصلة من الخزينة أيضاً وتصحيح الحسابات. هل تريد الاستمرار؟`)) {
                            const loadingToast = toast.loading('جاري الحذف وتطهير القيود المالية...');
                            try {
                                // 1. البحث عن الحركات المالية المرتبطة بهذا العقد في مجموعة transactions وحذفها
                                const transRef = collection(db, "transactions");
                                const q = query(transRef, where("saleId", "==", s.id));
                                const transDocs = await getDocs(q);
                                
                                let deletedTransactionsCount = 0;
                                for (const docItem of transDocs.docs) {
                                    await deleteDoc(doc(db, "transactions", docItem.id));
                                    deletedTransactionsCount++;
                                }

                                // 2. حذف مستند عقد البيع نفسه
                                await deleteDoc(doc(db, "sales", s.id));
                                
                                // 3. تسجيل العملية العكسية في سجل العمليات لضمان الرقابة
                                await logActivity(
                                    "المبيعات", 
                                    `⚠️ حذف شامل: تم حذف عقد البيع رقم (${s.contractNumber}) للعميل ${s.customerName} وحذف عدد (${deletedTransactionsCount}) قيود مالية مرتبطة به من الخزينة.`,
                                    { deletedSaleData: s, removedTransactions: deletedTransactionsCount }
                                );
                                
                                toast.success("تم حذف العقد وتصفير قيوده المالية بنجاح", { id: loadingToast });
                            } catch (error) {
                                console.error("Smart Delete Error:", error);
                                toast.error("حدث خطأ أثناء عملية الحذف الشامل", { id: loadingToast });
                            }
                        }
                    }} 
                    className="p-2 text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-full transition-all" 
                    title="حذف نهائي">
                        <Trash2 size={16}/>
                    </button>
                </div>
            </td>
        </tr>
    ))}
</tbody>
                    </table>
                </div>
                {sales.length === 0 && <div className="p-20 text-center text-gray-400 font-bold">لا توجد عقود مسجلة حالياً</div>}
            </div>

            {/* Modal الإضافة والتعديل */}
            {showModal && (
                <div className="fixed inset-0 bg-black/60 z-[120] flex items-center justify-center p-4 backdrop-blur-sm">
                    <div className={`w-full max-w-5xl max-h-[95vh] overflow-y-auto p-6 md:p-10 rounded-[2.5rem] shadow-2xl ${darkMode ? 'bg-gray-800 text-white' : 'bg-white'}`}>
                        <div className="flex justify-between items-center mb-8 border-b pb-4 dark:border-gray-700">
                            <div>
                                <h3 className="text-2xl font-black text-blue-600">{editingSale ? 'تعديل بيانات العقد' : 'تسجيل عقد بيع جديد'}</h3>
                                <p className="text-xs text-gray-500 mt-1">يرجى ملء بيانات المشتري والمالك والمناديب بدقة</p>
                            </div>
                            <button onClick={handleCloseModal} className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"><X size={28} className="text-gray-400" /></button>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                            {/* قسم المشتري (العميل) */}
                            <div className="space-y-6">
                                <div className="bg-blue-50/50 dark:bg-blue-900/10 p-6 rounded-3xl border border-blue-100 dark:border-blue-900/30">
                                    <h4 className={sectionTitle}><User size={18}/> بيانات المشتري (العميل)</h4>
                                    <div className="space-y-4">
                                        <div>
                                            <label className={labelClass}>اختيار من قائمة العملاء</label>
                                            <select className={inputClass} value={formData.customerId} onChange={e => {
                                                const c = customers.find(x => String(x.id) === String(e.target.value));
                                                setFormData({...formData, customerId: e.target.value, customerName: c?.name || '', customerPhone: c?.phone || '', customerRepId: String(c?.repId || '')});
                                            }}>
                                                <option value="">-- عميل جديد --</option>
                                                {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                                            </select>
                                        </div>
                                        <div className="grid grid-cols-2 gap-3">
                                            <div><label className={labelClass}>اسم المشتري</label><input placeholder="الاسم" className={inputClass} value={formData.customerName} onChange={e => setFormData({...formData, customerName: e.target.value})} /></div>
                                            <div><label className={labelClass}>رقم الهاتف</label><input placeholder="الهاتف" className={inputClass} value={formData.customerPhone} onChange={e => setFormData({...formData, customerPhone: e.target.value})} /></div>
                                        </div>
                                        <div>
                                            <label className={labelClass}>المندوب المسؤول عن العميل</label>
                                            <select className={inputClass} value={formData.customerRepId} onChange={e => setFormData({...formData, customerRepId: e.target.value})}>
                                                <option value="">-- اختر المندوب --</option>
                                                {reps.map(r => <option key={r.id} value={r.id}>{r.name} ({r.branch})</option>)}
                                            </select>
                                        </div>
                                        <div className="grid grid-cols-2 gap-3 pt-2">
                                            <div className="bg-white dark:bg-gray-800 p-3 rounded-2xl border dark:border-gray-700">
                                                <label className={labelClass}>عمولة الشركة (مشتري)</label>
                                                <input type="number" placeholder="0.00" className="w-full bg-transparent font-bold text-blue-600 outline-none" value={formData.customerCommission} onChange={e => setFormData({...formData, customerCommission: e.target.value})} />
                                            </div>
                                            <div className="bg-white dark:bg-gray-800 p-3 rounded-2xl border dark:border-gray-700">
                                                <label className={labelClass}>المحصل فعلياً</label>
                                                <input type="number" placeholder="0.00" className="w-full bg-transparent font-bold text-green-600 outline-none" value={formData.customerPaid} onChange={e => setFormData({...formData, customerPaid: e.target.value})} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* قسم البائع (المالك) */}
                            <div className="space-y-6">
                                <div className="bg-orange-50/50 dark:bg-orange-900/10 p-6 rounded-3xl border border-orange-100 dark:border-orange-900/30">
                                    <h4 className={sectionTitle}><Home size={18} className="text-orange-600"/> بيانات البائع (المالك)</h4>
                                    <div className="space-y-4">
                                        <div className="grid grid-cols-2 gap-3">
                                            <div><label className={labelClass}>اسم المالك</label><input placeholder="الاسم" className={inputClass} value={formData.ownerName} onChange={e => setFormData({...formData, ownerName: e.target.value})} /></div>
                                            <div><label className={labelClass}>رقم الهاتف</label><input placeholder="الهاتف" className={inputClass} value={formData.ownerPhone} onChange={e => setFormData({...formData, ownerPhone: e.target.value})} /></div>
                                        </div>
                                        <div>
                                            <label className={labelClass}>المندوب المسؤول عن المالك</label>
                                            <select className={inputClass} value={formData.ownerRepId} onChange={e => setFormData({...formData, ownerRepId: e.target.value})}>
                                                <option value="">-- اختر المندوب --</option>
                                                {reps.map(r => <option key={r.id} value={r.id}>{r.name} ({r.branch})</option>)}
                                            </select>
                                        </div>
                                        <div className="grid grid-cols-2 gap-3 pt-2">
                                            <div className="bg-white dark:bg-gray-800 p-3 rounded-2xl border dark:border-gray-700">
                                                <label className={labelClass}>عمولة الشركة (بائع)</label>
                                                <input type="number" placeholder="0.00" className="w-full bg-transparent font-bold text-orange-600 outline-none" value={formData.ownerCommission} onChange={e => setFormData({...formData, ownerCommission: e.target.value})} />
                                            </div>
                                            <div className="bg-white dark:bg-gray-800 p-3 rounded-2xl border dark:border-gray-700">
                                                <label className={labelClass}>المحصل فعلياً</label>
                                                <input type="number" placeholder="0.00" className="w-full bg-transparent font-bold text-green-600 outline-none" value={formData.ownerPaid} onChange={e => setFormData({...formData, ownerPaid: e.target.value})} />
                                            </div>
                                        </div>
                                        <div>
                                            <label className={labelClass}>ربط العقار (اختياري)</label>
                                            <select className={inputClass} value={formData.projectId} onChange={e => {
                                                const p = projects.find(x => String(x.id) === String(e.target.value));
                                                setFormData({...formData, projectId: e.target.value, projectName: p?.name || ''});
                                            }}>
                                                <option value="">-- اختر العقار من الموقع --</option>
                                                {projects.map(p => <option key={p.id} value={p.id}>{p.name} (#{p.code})</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* تفاصيل العقد العامة */}
                            <div className="lg:col-span-2 bg-gray-100 dark:bg-gray-900/50 p-6 rounded-[2rem] border-2 border-dashed dark:border-gray-700">
                                <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                                    <div><label className={labelClass}>رقم العقد</label><input readOnly className={`${inputClass} font-mono text-blue-600 bg-blue-50 dark:bg-blue-900/20`} value={formData.contractNumber} /></div>
                                    <div><label className={labelClass}>تاريخ التعاقد</label><input type="date" className={inputClass} value={formData.date} onChange={e => setFormData({...formData, date: e.target.value})} /></div>
                                    <div><label className={labelClass}>الفرع</label>
                                        <select className={inputClass} value={formData.branch} onChange={e => setFormData({...formData, branch: e.target.value})}>
                                            <option value="المعادي">المعادي</option><option value="المهندسين">المهندسين</option><option value="التجمع">التجمع</option>
                                        </select>
                                    </div>
                                    <div><label className={labelClass}>إجمالي قيمة العقار</label><input type="number" placeholder="0.00" className={`${inputClass} font-black text-red-600`} value={formData.contractTotalValue} onChange={e => setFormData({...formData, contractTotalValue: e.target.value})} /></div>
                                </div>
                                <div className="mt-4"><label className={labelClass}>ملاحظات إضافية حول العملية</label><textarea className={`${inputClass} h-16`} value={formData.notes} onChange={e => setFormData({...formData, notes: e.target.value})} placeholder="اكتب أي ملاحظات هنا.."></textarea></div>
                            </div>
                        </div>

                        <div className="mt-8 flex flex-col md:flex-row gap-4">
                            <button onClick={handleCloseModal} className="flex-1 py-4 bg-gray-200 dark:bg-gray-700 rounded-2xl font-bold transition hover:bg-gray-300 active:scale-95">إلغاء</button>
                            <button onClick={handleSaveSale} className="flex-[2] py-4 bg-blue-600 text-white rounded-2xl font-black text-lg shadow-xl shadow-blue-500/20 hover:bg-blue-700 transition transform active:scale-95 flex items-center justify-center gap-3">
                                <CheckCircle size={24} /> {editingSale ? 'حفظ التعديلات الحالية' : 'تأكيد وحفظ العقد والترحيل المالي'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
const TeamManager = ({ reps, setReps, tasks, setTasks, sales, payrollHistory, setPayrollHistory, setTransactions, transactions, darkMode, filterDataByBranch, user, dailyRecords }) => {    const [activeTab, setActiveTab] = useState('attendance');
    const [showTaskModal, setShowTaskModal] = useState(false);
    const [editingTask, setEditingTask] = useState(null);
    const [showRepModal, setShowRepModal] = useState(false);
    const [editingRep, setEditingRep] = useState(null);
    const [currentMonth, setCurrentMonth] = useState(new Date().toISOString().slice(0, 7));
    const [editingArchive, setEditingArchive] = useState(null);
const [branchFilter, setBranchFilter] = useState('الكل');
    // جلب السجلات اليومية في الوقت الحقيقي من Firebase
   

    // 💡 منطق حساب الرواتب الاحترافي (حساب التأخير، الإضافي، العمولات الفردية، وخصم الإجازات)
    // 1. تصفية سجلات الحضور حسب صلاحيات الفروع للمستخدم أولاً لضمان العزل
    // 1. تصفية سجلات الحضور حسب صلاحيات الفروع للمستخدم أولاً لضمان العزل
    const filteredDailyRecords = useMemo(() => {
        if (!dailyRecords || typeof filterDataByBranch !== 'function') return [];
        return filterDataByBranch(dailyRecords);
    }, [dailyRecords, user, filterDataByBranch]);

    // 2. منطق حساب الرواتب الاحترافي (يعتمد الآن على السجلات المفلترة)
    const payrollData = useMemo(() => {
        return reps.map(rep => {
            const baseSalaryNum = Number(rep.baseSalary) || 0;
            const hourlyRate = baseSalaryNum / 30 / 8; // قيمة ساعة العمل
            const dailyRate = baseSalaryNum / 30;     // قيمة يوم العمل

            // 1. حساب العمولات بناءً على نسبة هذا الموظف المحددة في ملفه
            const repSales = sales.filter(s => 
                String(s.repId) === String(rep.id) && 
                s.status === 'مكتمل' && 
                s.date.startsWith(currentMonth)
            );
            const totalSalesAmount = repSales.reduce((acc, curr) => acc + curr.amount, 0);
            const commission = (totalSalesAmount * (Number(rep.commissionRate) || 0)) / 100;

            // 2. تجميع السجلات (إضافي، تأخير، وإجازات) لهذا الشهر من المصفوفة المفلترة 👈
            const monthlyRecords = filteredDailyRecords.filter(rec => 
                String(rec.repId) === String(rep.id) && rec.date.startsWith(currentMonth)
            );

            const totalOvertimeHours = monthlyRecords.reduce((acc, rec) => acc + (rec.overtime || 0), 0);
            const totalLateHours = monthlyRecords.reduce((acc, rec) => acc + (rec.lateHours || 0), 0);
            
            // حساب أيام الإجازة بخصم (تعتمد على النوع vacation_deduct)
            const vacationDeductDays = monthlyRecords.filter(rec => rec.type === 'vacation_deduct').length;

            const overtimePay = totalOvertimeHours * (hourlyRate * 1.5); 
            const lateDeductions = totalLateHours * hourlyRate; 
            const vacationDeductions = vacationDeductDays * dailyRate;

            const totalDeductions = lateDeductions + vacationDeductions;
            const total = baseSalaryNum + commission + overtimePay - totalDeductions;

            return { 
                ...rep, 
                totalSalesAmount, 
                commission, 
                totalOvertimeHours: totalOvertimeHours.toFixed(2),
                totalLateHours: totalLateHours.toFixed(2),
                overtimePay, 
                deductions: totalDeductions,
                vacationDeductDays,
                total, 
                count: repSales.length 
            };
        });
    }, [reps, sales, currentMonth, filteredDailyRecords]); // 👈 تحديث الاعتمادية هنا أيضاً

    // 💡 دالة تسجيل الحضور والانصراف والإجازات (مرنة حسب مواعيد الموظف)
    const handleCheckInOut = async (repId, type) => {
        const rep = reps.find(r => String(r.id) === String(repId));
        const now = new Date();
        const dateString = now.toISOString().split('T')[0];
        const timeString = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false });
        const [currentH, currentM] = timeString.split(':').map(Number);
        
        const recordId = `${String(repId)}_${dateString}`;
        const recordRef = doc(db, "attendance_records", recordId);
        let updateData = { repId: String(repId), date: dateString };

        try {
            if (type === 'in') {
                const [startH, startM] = (rep?.workStart || "10:00").split(':').map(Number);
                const diffInMinutes = (currentH * 60 + currentM) - (startH * 60 + startM);
                let lateHours = diffInMinutes > 0 ? diffInMinutes / 60 : 0;

                updateData.checkInTime = timeString;
                updateData.lateHours = parseFloat(lateHours.toFixed(2));
                updateData.status = lateHours > 0 ? 'حضور (متأخر)' : 'حضور';
                updateData.type = 'work';
            } else if (type === 'out') {
                const [endH, endM] = (rep?.workEnd || "18:00").split(':').map(Number);
                const diffInMinutes = (currentH * 60 + currentM) - (endH * 60 + endM);
                let overtime = diffInMinutes > 0 ? diffInMinutes / 60 : 0;

                updateData.checkOutTime = timeString;
                updateData.overtime = parseFloat(overtime.toFixed(2));
                updateData.status = 'انصراف';
            } else if (type === 'vacation_free') {
                updateData.status = 'إجازة (بدون خصم)';
                updateData.type = 'vacation_free';
            } else if (type === 'vacation_deduct') {
                updateData.status = 'إجازة (بخصم يوم)';
                updateData.type = 'vacation_deduct';
            }

            await setDoc(recordRef, updateData, { merge: true });
            alert("تم تسجيل الحالة بنجاح.");
        } catch(e) {
            console.error("Error:", e);
            alert("فشل التسجيل.");
        }
    };

    const handleDeleteDailyRecord = async (id) => {
        if(window.confirm('هل أنت متأكد من حذف هذا السجل؟')) {
            try { await deleteDoc(doc(db, "attendance_records", String(id))); } catch(e) { console.error(e); }
        }
    };

    const handleSaveRep = async (repData) => {
    const loadingToast = toast.loading('جاري حفظ بيانات الموظف...');
    try {
        let finalImageUrl = repData.img || '';

        // إذا كان هناك ملف صورة جديد تم اختياره (وليس رابط نصي)
        if (repData.imageFile) {
            const storageRef = ref(storage, `reps_photos/${Date.now()}_${repData.imageFile.name}`);
            const snapshot = await uploadBytes(storageRef, repData.imageFile);
            finalImageUrl = await getDownloadURL(snapshot.ref);
        }

        // تجهيز البيانات النهائية للحفظ
        const finalData = { 
            ...repData, 
            img: finalImageUrl 
        };
        delete finalData.imageFile; // حذف ملف الـ Raw قبل الإرسال لـ Firestore

        if (editingRep) { 
            await updateDoc(doc(db, "reps", String(repData.id)), finalData); 
        } else { 
            await addDoc(collection(db, "reps"), finalData); 
        }

        toast.success('تم حفظ بيانات الموظف بنجاح', { id: loadingToast });
        setShowRepModal(false);
        setEditingRep(null);
    } catch (e) {
        console.error(e);
        toast.error('حدث خطأ أثناء الحفظ', { id: loadingToast });
    }
};

    const handleDeleteRep = async (id) => {
        if(window.confirm('حذف الموظف نهائياً؟')) {
            await deleteDoc(doc(db, "reps", String(id)));
            setReps(reps.filter(rep => rep.id !== id));
        }
    };

    const handleSaveTask = async (taskData) => {
        const { id, text, assignedTo } = taskData;
        const assignedRepIds = (assignedTo || []).map(String);
        const newTaskRaw = { text, assignedTo: assignedRepIds, status: 'جاري', date: new Date().toISOString().split('T')[0] };
        try {
            if (id) { await updateDoc(doc(db, "tasks", id), newTaskRaw); } 
            else { await addDoc(collection(db, "tasks"), newTaskRaw); }
            setShowTaskModal(false);
            setEditingTask(null);
        } catch(e) { console.error(e); }
    };

    const handleDeleteTask = async (id) => {
        if(window.confirm('حذف المهمة؟')) {
            await deleteDoc(doc(db, "tasks", String(id)));
            setTasks(tasks.filter(t => t.id !== id));
        }
    };

    const handleSendTaskToWhatsapp = (task) => {
        task.assignedTo.forEach(repId => {
            const rep = reps.find(r => String(r.id) === String(repId));
            if (rep) {
                const cleanPhone = String(rep.whatsappLink || rep.phone).replace(/\D/g, '');
                const finalPhone = cleanPhone.length === 11 ? '20' + cleanPhone.substring(1) : cleanPhone;
                window.open(`https://wa.me/${finalPhone}?text=${encodeURIComponent(task.text)}`, '_blank');
            }
        });
    };

    const handlePostPayroll = async () => {
    if (window.confirm("هل أنت متأكد من ترحيل الرواتب للخزينة؟ سيتم توزيع المصاريف على الفروع حسب تبعية الموظفين.")) {
        try {
            // 1. أرشيف الرواتب العام
            let totalAmount = 0;
            const records = payrollData.map(r => { totalAmount += r.total; return r; });
            await addDoc(collection(db, "payroll_archive"), { 
                month: currentMonth, 
                total: totalAmount, 
                records: records, 
                datePosted: new Date().toISOString() 
            });

            // 2. ترحيل المصاريف لكل فرع على حدة
            const branches = ['المعادي', 'المهندسين', 'التجمع'];
            
            for (const branch of branches) {
                // حساب مجموع رواتب موظفي هذا الفرع فقط
                const branchTotal = payrollData
                    .filter(r => (r.branch || 'المعادي') === branch)
                    .reduce((sum, r) => sum + r.total, 0);

                if (branchTotal > 0) {
                    await addDoc(collection(db, "transactions"), { 
                        type: 'expense', 
                        title: `رواتب موظفي فرع ${branch} - شهر ${currentMonth}`, 
                        amount: branchTotal, 
                        date: new Date().toISOString().split('T')[0], 
                        category: 'رواتب',
                        branch: branch // 👈 ترحيل لفرعه الخاص
                    });
                }
            }

            alert('تم ترحيل الرواتب وتوزيع المصاريف على خزائن الفروع بنجاح!');
        } catch (e) { 
            console.error(e); 
            alert("حدث خطأ أثناء الترحيل");
        }
    }
};
    const handleUpdateArchive = (archive) => {
        setEditingArchive(null);
    };

    return (
        <div className="space-y-6 animate-fade-in">
            <div className="flex justify-between items-center flex-wrap gap-4"> 
                <h2 className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>إدارة الفريق والمهام</h2>
                <div className={`flex p-1 rounded-lg w-full md:w-fit justify-center md:justify-start ${darkMode ? 'bg-gray-800 border border-gray-700' : 'bg-gray-100'}`}> 
                    <button onClick={() => setActiveTab('attendance')} className={`px-4 py-2 rounded-md text-sm font-bold transition-all duration-300 ${activeTab === 'attendance' ? (darkMode ? 'bg-gray-600 text-green-400 shadow-md' : 'bg-white shadow text-green-600') : (darkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:bg-gray-200')}`}>الحضور</button>
                    <button onClick={() => setActiveTab('reps')} className={`px-4 py-2 rounded-md text-sm font-bold transition-all duration-300 ${activeTab === 'reps' ? (darkMode ? 'bg-gray-600 text-blue-400 shadow-md' : 'bg-white shadow text-blue-600') : (darkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:bg-gray-200')}`}>الموظفين</button>
                    <button onClick={() => setActiveTab('payroll')} className={`px-4 py-2 rounded-md text-sm font-bold transition-all duration-300 ${activeTab === 'payroll' ? (darkMode ? 'bg-gray-600 text-blue-400 shadow-md' : 'bg-white shadow text-blue-600') : (darkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:bg-gray-200')}`}>الرواتب</button>
                    <button onClick={() => setActiveTab('tasks')} className={`px-4 py-2 rounded-md text-sm font-bold transition-all duration-300 ${activeTab === 'tasks' ? (darkMode ? 'bg-gray-600 text-blue-400 shadow-md' : 'bg-white shadow text-blue-600') : (darkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:bg-gray-200')}`}>المهام</button>
                </div>
            </div>

            {activeTab === 'attendance' && (
                <div className="animate-fade-in space-y-6">
                    <div className={`p-6 rounded-xl shadow-sm border ${darkMode ? 'bg-gray-800 border-gray-700 text-white' : 'bg-white border-gray-200 text-gray-900'}`}>
                        <h3 className="font-bold mb-4 flex items-center text-green-600"><Clock className="ml-2" /> بصمة الموظفين اليومية</h3>
                        <div className="overflow-x-auto">
                            <table className="w-full text-right min-w-[800px] text-sm">
                                <thead className={`${darkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-50 text-gray-600'}`}>
                                    <tr>
                                        <th className="p-4 border-b dark:border-gray-600">الموظف</th>
                                        <th className="p-4 text-center border-b dark:border-gray-600">المواعيد الشخصية</th>
                                        <th className="p-4 text-center border-b dark:border-gray-600">الحالة اليوم</th>
                                        <th className="p-4 text-center border-b dark:border-gray-600">إجراءات الحضور والإجازات</th>
                                    </tr>
                                </thead>
                                <tbody className={`divide-y ${darkMode ? 'divide-gray-700' : 'divide-gray-200'}`}>
                                    {reps.map(rep => {
                                        const todayRecord = dailyRecords.find(r => String(r.repId) === String(rep.id) && r.date === new Date().toISOString().split('T')[0]);
                                        return (
                                            <tr key={rep.id} className={`transition-colors ${darkMode ? 'hover:bg-gray-700/50' : 'hover:bg-gray-50'}`}>
                                                <td className="p-4 font-bold dark:text-white">{rep.name}</td>
                                                <td className="p-4 text-center text-xs text-gray-500 italic dark:text-gray-400">{rep.workStart || '10:00'} - {rep.workEnd || '18:00'}</td>
                                                <td className="p-4 text-center">
                                                    {todayRecord ? (
                                                        <span className={`px-3 py-1 rounded text-xs font-bold ${todayRecord.status.includes('متأخر') ? 'bg-red-100 text-red-700' : todayRecord.status.includes('إجازة') ? 'bg-blue-100 text-blue-700' : 'bg-green-100 text-green-700'}`}>
                                                            {todayRecord.status} ({todayRecord.checkInTime || '--:--'})
                                                        </span>
                                                    ) : <span className="px-3 py-1 rounded text-xs font-bold bg-red-100 text-red-700">غائب</span>}
                                                </td>
                                                <td className="p-4 flex flex-wrap justify-center gap-2">
                                                    <button onClick={() => handleCheckInOut(rep.id, 'in')} disabled={!!todayRecord} className="px-3 py-1 bg-green-600 text-white rounded text-xs disabled:opacity-50 disabled:bg-gray-500 transition-all active:scale-95">حضور</button>
                                                    <button onClick={() => handleCheckInOut(rep.id, 'out')} disabled={!todayRecord || todayRecord.checkOutTime || todayRecord.type?.includes('vacation')} className="px-3 py-1 bg-red-600 text-white rounded text-xs disabled:opacity-50 disabled:bg-gray-500 transition-all active:scale-95">انصراف</button>
                                                    <button onClick={() => handleCheckInOut(rep.id, 'vacation_free')} disabled={!!todayRecord} className="px-3 py-1 bg-blue-500 text-white rounded text-xs disabled:opacity-50 disabled:bg-gray-500 transition-all active:scale-95">إجازة (رسمية)</button>
                                                    <button onClick={() => handleCheckInOut(rep.id, 'vacation_deduct')} disabled={!!todayRecord} className="px-3 py-1 bg-orange-500 text-white rounded text-xs disabled:opacity-50 disabled:bg-gray-500 transition-all active:scale-95">إجازة (خصم)</button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <AttendanceArchive dailyRecords={filteredDailyRecords} reps={reps} darkMode={darkMode} onDelete={handleDeleteDailyRecord} standardEndHour={20} />
    </div>
)}
{activeTab === 'tasks' && (
    <div className="animate-fade-in space-y-6">
        <div className="flex justify-between items-center">
            <h3 className="font-bold text-lg flex items-center gap-2">
                <ClipboardList className="text-blue-600" /> سجل المهام والمواعيد
            </h3>
            <button 
                onClick={() => { setEditingTask(null); setShowTaskModal(true); }} 
                className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-bold shadow-md hover:bg-blue-700 transition"
            >
                <Plus className="ml-2 w-4 h-4 inline" /> إضافة مهمة يدوية
            </button>
        </div>

        <div className="grid grid-cols-1 gap-4">
            {tasks.length > 0 ? (
                tasks.sort((a, b) => b.date.localeCompare(a.date)).map(task => (
                    <div key={task.id} className={`p-5 rounded-2xl border-r-4 shadow-sm transition-all ${task.status === 'جديد' ? 'border-red-500 bg-red-50/30' : 'border-blue-500 bg-white dark:bg-gray-800'} ${darkMode ? 'border-opacity-50' : ''}`}>
                        <div className="flex flex-col md:flex-row justify-between gap-4">
                            <div className="flex-1">
                                <div className="flex items-center gap-2 mb-2">
                                    <span className={`px-2 py-0.5 rounded text-[10px] font-bold ${task.status === 'جديد' ? 'bg-red-100 text-red-700' : 'bg-blue-100 text-blue-700'}`}>
                                        {task.status}
                                    </span>
                                    <span className="text-xs text-gray-400 font-mono">{task.date}</span>
                                </div>
                                <p className="text-sm font-bold leading-relaxed">{task.text}</p>
                                
                                {task.assignedTo && task.assignedTo.length > 0 && (
                                    <div className="mt-3 flex flex-wrap gap-2">
                                        <span className="text-[10px] text-gray-500 font-bold">المكلفين:</span>
                                        {task.assignedTo.map(id => (
                                            <span key={id} className="text-[10px] bg-gray-100 dark:bg-gray-700 px-2 py-0.5 rounded-full">
                                                {reps.find(r => String(r.id) === String(id))?.name || 'موظف'}
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div className="flex items-center gap-2 no-print">
                                <button 
                                    onClick={() => handleSendTaskToWhatsapp(task)}
                                    className="p-2 bg-green-100 text-green-600 rounded-lg hover:bg-green-200 transition"
                                    title="إرسال تذكير واتساب"
                                >
                                    <MessageCircle size={18} />
                                </button>
                                <button 
                                    onClick={() => { setEditingTask(task); setShowTaskModal(true); }}
                                    className="p-2 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition"
                                >
                                    <Edit size={18} />
                                </button>
                                <button 
                                    onClick={() => handleDeleteTask(task.id)}
                                    className="p-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition"
                                >
                                    <Trash2 size={18} />
                                </button>
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                <div className="p-12 text-center text-gray-500 bg-gray-100 dark:bg-gray-800 rounded-2xl border-2 border-dashed border-gray-200 dark:border-gray-700">
                    <ClipboardList className="w-12 h-12 mx-auto mb-3 opacity-20" />
                    <p>لا توجد مهام أو مواعيد محجوزة حالياً</p>
                </div>
            )}
        </div>
    </div>
)}
            {activeTab === 'payroll' && (
                <div className="animate-fade-in space-y-6">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4"> 
                        <h3 className={`font-bold text-lg ${darkMode ? 'text-white' : 'text-gray-900'}`}>كشف الرواتب التفصيلي لشهر: {currentMonth}</h3>
                        <div className="flex gap-2">
                            <input type="month" value={currentMonth} onChange={(e) => setCurrentMonth(e.target.value)} className={`p-2 rounded-lg border outline-none ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} />
                            <button onClick={handlePostPayroll} disabled={payrollHistory.some(h => h.month === currentMonth)} className="px-4 py-2 bg-green-600 text-white rounded-lg font-bold disabled:bg-gray-400 shadow-sm transition hover:bg-green-700 active:scale-95">ترحيل الرواتب</button>
                        </div>
                    </div>
                    <div className={`rounded-xl shadow-sm overflow-x-auto border mb-8 ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                        <div className="min-w-[1000px]"> 
                            <table className="w-full text-right text-sm">
                                <thead className={`${darkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-50 text-gray-600'}`}>
                                    <tr>
                                        <th className="p-4 border-b dark:border-gray-600">الموظف</th>
                                        <th className="p-4 border-b dark:border-gray-600 text-center">الأساسي</th>
                                        <th className="p-4 border-b dark:border-gray-600 text-center">العمولة</th>
                                        <th className="p-4 border-b dark:border-gray-600 text-center text-orange-400">إضافي (+)</th>
                                        <th className="p-4 border-b dark:border-gray-600 text-center text-red-400">خصومات (-)</th>
                                        <th className="p-4 border-b dark:border-gray-600 text-center font-bold">صافي الراتب</th>
                                    </tr>
                                </thead>
                                <tbody className={`divide-y ${darkMode ? 'divide-gray-700' : 'divide-gray-200'}`}>
                                    {payrollData.map(r => (
                                        <tr key={r.id} className={`transition-colors ${darkMode ? 'hover:bg-gray-700/50 text-gray-300' : 'hover:bg-gray-50 text-gray-700'}`}>
                                            <td className="p-4">
                                                <div className="font-bold dark:text-white">{r.name}</div>
                                                <div className={`text-[10px] ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>{r.role}</div>
                                            </td>
                                            <td className="p-4 text-center font-mono">{Number(r.baseSalary).toLocaleString()}</td>
                                            <td className="p-4 text-center">
                                                <div className="font-bold text-green-600">{r.commission.toFixed(2)}</div>
                                                <div className="text-[9px] opacity-60">بنسبة {r.commissionRate}%</div>
                                            </td>
                                            <td className="p-4 text-center">
                                                <div className="font-bold text-orange-600">+{r.overtimePay.toFixed(2)}</div>
                                                <div className="text-[9px] opacity-60">{r.totalOvertimeHours} ساعة</div>
                                            </td>
                                            <td className="p-4 text-center">
                                                <div className="font-bold text-red-600">-{r.deductions.toFixed(2)}</div>
                                                {r.vacationDeductDays > 0 && <div className="text-[9px] opacity-60">خصم {r.vacationDeductDays} يوم إجازة</div>}
                                            </td>
                                            <td className="p-4 text-center">
                                                <div className={`text-lg font-black ${darkMode ? 'text-blue-400' : 'text-blue-700'}`}>{r.total.toFixed(2)}</div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    
                    <h4 className={`font-bold text-lg mb-4 flex items-center ${darkMode ? 'text-gray-200' : ''}`}><Archive className="w-5 h-5 ml-2 text-gray-500" /> أرشيف الرواتب المُرحَّلة</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {payrollHistory.sort((a, b) => b.month.localeCompare(a.month)).map(archive => (
                            <div key={archive.id} className={`p-4 rounded-xl shadow-sm border flex justify-between items-center cursor-pointer hover:scale-[1.02] transition-all duration-300 ${darkMode ? 'bg-gray-800 border-gray-700 hover:border-blue-500 text-white' : 'bg-white border-gray-100 hover:border-blue-400'}`} onClick={() => setEditingArchive(archive)}>
                                <div className="flex items-center gap-3">
                                    <div className={`p-2 rounded-lg ${darkMode ? 'bg-blue-900/30 text-blue-400' : 'bg-blue-50 text-blue-600'}`}><FileText size={20} /></div>
                                    <div><span className="block font-bold text-sm">شهر: {archive.month}</span><span className="text-[10px] text-gray-400">تم الترحيل بنجاح</span></div>
                                </div>
                                <div className="text-left"><span className={`text-xl font-black ${darkMode ? 'text-green-400' : 'text-green-700'}`}>{archive.total.toLocaleString()}</span><span className="text-[10px] block text-gray-400">ج.م</span></div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {activeTab === 'reps' && (
                <div className="animate-fade-in space-y-4">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        {/* أزرار الفلترة حسب الفرع */}
                        <div className={`flex p-1 rounded-lg border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-gray-100 border-gray-200'}`}>
                            {['الكل', 'المعادي', 'المهندسين', 'التجمع'].map(branch => (
                                <button
                                    key={branch}
                                    onClick={() => setBranchFilter(branch)}
                                    className={`px-4 py-1.5 rounded-md text-xs font-bold transition-all ${
                                        branchFilter === branch 
                                        ? 'bg-white dark:bg-gray-600 shadow text-blue-600' 
                                        : 'text-gray-500 hover:text-blue-500'
                                    }`}
                                >
                                    {branch}
                                </button>
                            ))}
                        </div>

                        <button 
                            onClick={() => { setEditingRep(null); setShowRepModal(true); }} 
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg flex items-center shadow-md hover:bg-blue-700 transition active:scale-95 w-full md:w-auto justify-center"
                        >
                            <UserPlus className="ml-2 w-4 h-4" /> إضافة موظف
                        </button>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {reps
                            .filter(r => branchFilter === 'الكل' || r.branch === branchFilter)
                            .map(r => (
                                <div key={r.id} className={`p-6 rounded-xl shadow-sm border-t-4 border-blue-500 transition-all duration-300 ${darkMode ? 'bg-gray-800 border-gray-700 text-white' : 'bg-white border-gray-100 text-gray-900 shadow-md'}`}>
                                    <div className="flex justify-between items-start">
                                        <div className="flex items-center gap-3">
                                            <div className={`w-12 h-12 rounded-full flex items-center justify-center font-extrabold text-lg ${darkMode ? 'bg-blue-900/50 text-blue-300' : 'bg-blue-100 text-blue-600'}`}>{r.name[0]}</div>
                                            <div>
                                                <h3 className="font-bold">{r.name}</h3>
                                                <p className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                    {r.role} — <span className="text-blue-500 font-bold">{r.branch || 'المعادي'}</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex gap-1">
                                            <button onClick={() => { setEditingRep(r); setShowRepModal(true); }} className={`p-1 rounded transition-colors ${darkMode ? 'text-blue-400 hover:bg-blue-900/20' : 'text-blue-600 hover:bg-blue-50'}`}><Edit size={16} /></button>
                                            <button onClick={() => handleDeleteRep(r.id)} className={`p-1 rounded transition-colors ${darkMode ? 'text-red-400 hover:bg-red-900/20' : 'text-red-500 hover:bg-red-50'}`}><Trash2 size={16} /></button>
                                        </div>
                                    </div>
                                    <div className={`mt-4 pt-4 border-t grid grid-cols-2 gap-2 text-xs ${darkMode ? 'border-gray-700' : 'border-gray-100'}`}>
                                        <div className={darkMode ? 'text-gray-400' : 'text-gray-500'}>الراتب: <span className={`font-bold ${darkMode ? 'text-white' : 'text-black'}`}>{r.baseSalary}</span></div>
                                        <div className={darkMode ? 'text-gray-400' : 'text-gray-500'}>العمولة: <span className="font-bold text-green-600">{r.commissionRate}%</span></div>
                                        <div className={darkMode ? 'text-gray-400' : 'text-gray-500'}>إجازات: <span className="font-bold text-orange-500">{r.vacationBalance || 21} يوم</span></div>
                                        <div className={darkMode ? 'text-gray-400' : 'text-gray-500'}>الدوام: <span className="font-bold text-blue-500">{r.workStart || '10:00'}</span></div>
                                    </div>
                                </div>
                            ))}
                    </div>
                    
                    {/* رسالة تنبيه في حال عدم وجود موظفين بالفرع المختار */}
                    {reps.filter(r => branchFilter === 'الكل' || r.branch === branchFilter).length === 0 && (
                        <div className="text-center py-10 text-gray-400">لا يوجد موظفين مسجلين في فرع {branchFilter}</div>
                    )}
                </div>
            )}

            {showTaskModal && <TaskModal reps={reps} task={editingTask} onClose={() => { setShowTaskModal(false); setEditingTask(null); }} onSend={handleSaveTask} darkMode={darkMode} />}
            {showRepModal && <RepModal rep={editingRep} onClose={() => { setShowRepModal(false); setEditingRep(null); }} onSave={handleSaveRep} darkMode={darkMode} />}
            {editingArchive && <PayrollArchiveModal archive={editingArchive} onClose={() => setEditingArchive(null)} onUpdate={handleUpdateArchive} darkMode={darkMode} />}
        </div>
    );
};
// --- (1) مكون التحليل المتقدم للفروع والمناديب (Cost vs Sales Analysis) ---
const FinancialAnalytics = ({ transactions, sales, reps, darkMode }) => {
    // 1. حساب إحصائيات الفروع (المعادي والمهندسين)
    const branchStats = {
    'المعادي': { income: 0, expense: 0 },
    'المهندسين': { income: 0, expense: 0 },
    'التجمع': { income: 0, expense: 0 } // أضفنا فرع التجمع هنا لجمع بياناته
};

    transactions.forEach(t => {
        if (branchStats[t.branch]) {
            if (t.type === 'income') branchStats[t.branch].income += (Number(t.amount) || 0);
            else branchStats[t.branch].expense += (Number(t.amount) || 0);
        }
    });

    // 2. تحليل أداء وكفاءة المناديب (ربط المصاريف بالمبيعات)
    const repPerformance = reps.map(rep => {
        const repExpenses = transactions
            .filter(t => t.repId && String(t.repId) === String(rep.id) && t.type === 'expense')
            .reduce((sum, t) => sum + (Number(t.amount) || 0), 0);
        
        const repSales = sales
            .filter(s => s.repId && String(s.repId) === String(rep.id))
            .reduce((sum, s) => sum + (Number(s.amount) || 0), 0);

        return {
            id: rep.id,
            name: rep.name,
            expenses: repExpenses,
            sales: repSales,
            ratio: repSales > 0 ? ((repExpenses / repSales) * 100).toFixed(1) : 0
        };
    });

    return (
        <div className="space-y-8 mt-10 animate-fade-in">
            <h3 className={`text-xl font-bold border-b pb-2 flex items-center gap-2 ${darkMode ? 'border-gray-700 text-purple-400' : 'text-purple-600'}`}>
                <Activity className="w-5 h-5" /> 📊 تحليلات الفروع وكفاءة المناديب
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {Object.keys(branchStats).map(branch => (
                    <div key={branch} className={`p-6 rounded-2xl border transition-all duration-300 ${darkMode ? 'bg-gray-800 border-gray-700 text-white shadow-none' : 'bg-white shadow-sm border-gray-100 text-gray-900'}`}>
                        <h4 className="text-lg font-bold mb-4 flex items-center gap-2 text-blue-500">
                            <Building className="w-5 h-5" /> فرع {branch}
                        </h4>
                        <div className="space-y-2">
                            <div className="flex justify-between text-sm">
                                <span className={darkMode ? 'text-gray-400' : 'text-gray-500'}>إجمالي الإيرادات:</span>
                                <span className="text-green-600 font-bold">{branchStats[branch].income.toLocaleString()} ج.م</span>
                            </div>
                            <div className="flex justify-between text-sm">
                                <span className={darkMode ? 'text-gray-400' : 'text-gray-500'}>إجمالي المصروفات:</span>
                                <span className="text-red-500 font-bold">{branchStats[branch].expense.toLocaleString()} ج.م</span>
                            </div>
                            <div className={`pt-3 border-t mt-2 flex justify-between font-extrabold text-md ${darkMode ? 'border-gray-700' : 'border-gray-100'}`}>
                                <span>صافي الربح:</span>
                                <span className={branchStats[branch].income - branchStats[branch].expense >= 0 ? 'text-green-600' : 'text-red-600'}>
                                    {(branchStats[branch].income - branchStats[branch].expense).toLocaleString()} ج.م
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className={`p-6 rounded-2xl border transition-all duration-300 ${darkMode ? 'bg-gray-800 border-gray-700 shadow-none' : 'bg-white shadow-sm border-gray-100'}`}>
                <h4 className={`font-bold mb-4 flex items-center gap-2 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`}>
                    <Users className="w-5 h-5" /> تحليل مصاريف المناديب مقابل الإنتاجية (ROI)
                </h4>
                <div className="overflow-x-auto">
                    <table className="w-full text-right text-sm">
                        <thead className={`${darkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-50 text-gray-600'}`}>
                            <tr>
                                <th className="p-3 border-b dark:border-gray-600">المندوب</th>
                                <th className="p-3 text-red-500 border-b dark:border-gray-600">مصاريفه</th>
                                <th className="p-3 text-green-600 border-b dark:border-gray-600">إجمالي المبيعات</th>
                                <th className="p-3 text-center border-b dark:border-gray-600">ROI %</th>
                            </tr>
                        </thead>
                        <tbody className={`divide-y ${darkMode ? 'divide-gray-700' : 'divide-gray-100'}`}>
                            {repPerformance.map(rp => (
                                <tr key={rp.id} className={`transition-colors ${darkMode ? 'hover:bg-gray-700/50 text-gray-300' : 'hover:bg-gray-50'}`}>
                                    <td className="p-3 font-bold dark:text-white">{rp.name}</td>
                                    <td className="p-3 font-mono">{rp.expenses.toLocaleString()} ج.م</td>
                                    <td className="p-3 font-mono font-bold dark:text-gray-100">{rp.sales.toLocaleString()} ج.م</td>
                                    <td className="p-3 text-center">
                                        <span className={`px-3 py-1 rounded-full text-[10px] md:text-xs font-bold ${Number(rp.ratio) > 10 ? 'bg-red-100 text-red-700' : 'bg-blue-100 text-blue-700'}`}>
                                            {rp.ratio}%
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

// --- (2) المكون الرئيسي لإدارة المحاسبة ---
// --- (2) المكون الرئيسي لإدارة المحاسبة (الخزينة) المطور ---
// --- (2) المكون الرئيسي لإدارة المحاسبة (الخزينة) المطور بالبحث والحذف الذكي ---
const AccountingManager = ({ transactions, setTransactions, sales, reps, darkMode, logActivity, user }) => {
    const [showModal, setShowModal] = useState(false);
    const [editingTrans, setEditingTrans] = useState(null); 
    
    // حالة اختيار الفروع: للأدمن الكل، وللموظف فروعه المسموحة فقط
    const [selectedBranches, setSelectedBranches] = useState(() => {
        if (user?.role === 'admin') return ['المعادي', 'المهندسين', 'التجمع'];
        return Array.isArray(user?.assignedBranches) ? user.assignedBranches : [user?.assignedBranch || 'المعادي'];
    });
    
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(0, 7));
    const [timePeriod, setTimePeriod] = useState('all');

    const [newTrans, setNewTrans] = useState({ 
        type: 'expense', 
        title: '', 
        amount: '', 
        date: new Date().toISOString().split('T')[0], 
        category: 'عام', 
        branch: user?.role === 'admin' ? 'المعادي' : (user?.assignedBranches?.[0] || 'المعادي'), 
        repId: '' 
    });

    // تبديل اختيار الفرع (للأدمن)
    const toggleBranch = (branchName) => {
        setSelectedBranches(prev => 
            prev.includes(branchName) ? prev.filter(b => b !== branchName) : [...prev, branchName]
        );
    };

    // دالة داخلية لجلب بيانات فرع معين (تُستخدم داخل ماب العرض)
    const getBranchStats = (branchName) => {
        let branchData = transactions.filter(t => t.branch === branchName && t.date?.startsWith(selectedMonth));
        
        // تطبيق فلترة المدة الزمنية
        branchData = getFilteredTransactions(branchData, timePeriod);
        
        // تطبيق البحث
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            branchData = branchData.filter(t => 
                t.title?.toLowerCase().includes(term) || 
                t.amount?.toString().includes(term) ||
                t.category?.toLowerCase().includes(term) ||
                reps.find(r => String(r.id) === String(t.repId))?.name?.toLowerCase().includes(term)
            );
        }

        const income = branchData.filter(t => t.type === 'income').reduce((acc, t) => acc + (Number(t.amount) || 0), 0);
        const expense = branchData.filter(t => t.type === 'expense').reduce((acc, t) => acc + (Number(t.amount) || 0), 0);

        return {
            rows: branchData.sort((a, b) => (b.date || "").localeCompare(a.date || "")),
            income,
            expense,
            balance: income - expense
        };
    };

    // الإحصائيات المجمعة لكافة الفروع المختارة (للكروت العلوية)
    const globalStats = useMemo(() => {
        return selectedBranches.reduce((acc, branch) => {
            const stats = getBranchStats(branch);
            acc.totalIncome += stats.income;
            acc.totalExpense += stats.expense;
            return acc;
        }, { totalIncome: 0, totalExpense: 0 });
    }, [transactions, selectedBranches, selectedMonth, timePeriod, searchTerm]);

    const handleEditClick = (t) => {
        setEditingTrans(t);
        setNewTrans({ ...t });
        setShowModal(true);
    };

    const handleSave = async () => {
        if (!newTrans.title || !newTrans.amount || !newTrans.date || !newTrans.branch) {
            return alert("يرجى إكمال البيانات واختيار الفرع");
        }
        
        const transData = { ...newTrans, amount: Number(newTrans.amount), repId: newTrans.repId ? String(newTrans.repId) : '' };

        try {
            if (editingTrans) {
                await updateDoc(doc(db, "transactions", String(editingTrans.id)), transData);
                logActivity("المالية", `تعديل حركة في فرع ${newTrans.branch}: ${newTrans.title}`);
                toast.success('تم التحديث بنجاح');
            } else {
                await addDoc(collection(db, "transactions"), { ...transData, createdAt: new Date().toISOString() });
                logActivity("المالية", `إضافة حركة في فرع ${newTrans.branch}: ${newTrans.title}`);
                toast.success('تمت الإضافة بنجاح');
            }
            setShowModal(false);
            setEditingTrans(null);
        } catch (e) { 
            console.error(e);
            toast.error("خطأ في الاتصال"); 
        }
    };

    const handleSmartDelete = async (t) => {
    if (!t.id) return;

    const confirmMsg = t.category === 'مبيعات' 
        ? `⚠️ تحذير: حذف هذه العملية سيحذف سجل المبيعات المرتبط بها. هل أنت متأكد؟` 
        : 'هل تريد حذف هذه العملية نهائياً؟';

    if (window.confirm(confirmMsg)) {
        const loading = toast.loading('جاري الحذف...');
        try {
            // 💡 التعديل هنا: صياغة نص تفصيلي يظهر في سجل العمليات
            const detailsText = `تم حذف معاملة (${t.type === 'income' ? 'وارد' : 'مصروف'}) 
            بمبلغ: ${Number(t.amount).toLocaleString()} ج.م 
            البيان: ${t.title} 
            التصنيف: ${t.category} 
            الفرع: ${t.branch}`;

            // استدعاء الحذف الذكي وتمرير البيانات التفصيلية للسجل
            // ملاحظة: تأكد أن ملف systemLogic يدعم استقبال هذه البيانات أو قم بالتسجيل يدوياً هنا
            await executeSmartDelete(t, logActivity, db, deleteField);
            
            // تسجيل العملية يدوياً لضمان ظهور التفاصيل الكاملة
            await logActivity("حذف مالي", detailsText, t);

            setTransactions(prev => prev.filter(item => String(item.id) !== String(t.id)));
            toast.success('تم الحذف وتحديث السجل بنجاح', { id: loading });
        } catch (e) { 
            toast.error('خطأ: ' + e.message, { id: loading }); 
        }
    }
};

    const inputClass = "w-full p-2 border rounded dark:bg-gray-700 dark:border-gray-600 outline-none focus:ring-2 focus:ring-blue-500 text-sm";
    const labelClass = "block text-xs font-bold mb-1 text-gray-500";

    return (
        <div className="space-y-6 animate-fade-in pb-10">
            {/* الهيدر العلوي */}
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 bg-blue-600 p-5 rounded-2xl shadow-xl text-white no-print">
                <div className="flex items-center gap-3">
                    <div className="bg-white/20 p-2 rounded-lg"><Wallet className="w-8 h-8" /></div>
                    <div>
                        <h2 className="text-xl font-bold">إدارة الخزائن المنفصلة</h2>
                        <p className="text-xs opacity-80">عرض وتحليل ماليات كل فرع على حدة</p>
                    </div>
                </div>

                <div className="flex items-center gap-2 bg-white/20 p-2 px-4 rounded-xl">
                    <span className="text-xs font-bold">شهر:</span>
                    <input type="month" value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)} className="bg-transparent border-none outline-none font-bold text-white cursor-pointer" />
                </div>

                {user.role === 'admin' && (
                    <div className="flex flex-wrap gap-2 bg-white/20 p-1.5 rounded-xl">
                        {['المعادي', 'المهندسين', 'التجمع'].map(branch => (
                            <button key={branch} onClick={() => toggleBranch(branch)} className={`px-4 py-2 rounded-lg font-bold text-xs transition-all ${selectedBranches.includes(branch) ? 'bg-white text-blue-600 shadow-lg' : 'bg-blue-700/30 text-blue-100'}`}>
                                {branch}
                            </button>
                        ))}
                    </div>
                )}
            </div>

            {/* الإحصائيات المجمعة */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <StatCard title="إجمالي الوارد (مجمع)" value={globalStats.totalIncome.toLocaleString()} icon={TrendingUp} color="green" darkMode={darkMode} />
                <StatCard title="إجمالي المصروف (مجمع)" value={globalStats.totalExpense.toLocaleString()} icon={ArrowRight} color="red" darkMode={darkMode} />
                <StatCard title="صافي السيولة المجمعة" value={(globalStats.totalIncome - globalStats.totalExpense).toLocaleString()} icon={PieChart} color="blue" darkMode={darkMode} />
            </div>

            {/* أدوات البحث والإضافة */}
            <div className="flex flex-wrap items-center gap-3 no-print bg-white dark:bg-gray-800 p-4 rounded-xl border dark:border-gray-700 shadow-sm">
                <div className="relative flex-1 min-w-[250px]">
                    <Search className="absolute right-3 top-2.5 text-gray-400 w-4 h-4" />
                    <input placeholder="بحث في كافة الخزائن المفتوحة..." className={inputClass + " pr-10"} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                </div>
                <button onClick={() => { setEditingTrans(null); setNewTrans({...newTrans, type: 'income'}); setShowModal(true); }} className="bg-green-600 text-white px-4 py-2 rounded-lg text-xs font-bold hover:bg-green-700 transition">+ وارد</button>
                <button onClick={() => { setEditingTrans(null); setNewTrans({...newTrans, type: 'expense'}); setShowModal(true); }} className="bg-red-600 text-white px-4 py-2 rounded-lg text-xs font-bold hover:bg-red-700 transition">+ مصروف</button>
            </div>

            {/* 🟢 عرض الجداول منفصلة لكل فرع 🟢 */}
            <div className="space-y-10">
                {selectedBranches.map(branchName => {
                    const data = getBranchStats(branchName);
                    return (
                        <div key={branchName} className={`rounded-2xl border-2 overflow-hidden shadow-sm transition-all ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-blue-50'}`}>
                            {/* رأس جدول الفرع */}
                            <div className="p-4 bg-gray-50 dark:bg-gray-700/50 flex flex-col md:flex-row justify-between items-center gap-4 border-b dark:border-gray-700">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-black shadow-md">{branchName[0]}</div>
                                    <div>
                                        <h3 className="font-black text-lg text-blue-900 dark:text-blue-300">خزينة {branchName}</h3>
                                        <p className="text-[10px] text-gray-500">عمليات شهر {selectedMonth}</p>
                                    </div>
                                </div>
                                
                                <div className="flex gap-4 bg-white dark:bg-gray-800 p-2 px-4 rounded-xl border dark:border-gray-600 shadow-inner">
                                    <div className="text-center">
                                        <p className="text-[9px] text-gray-400 font-bold">الوارد</p>
                                        <p className="text-sm font-black text-green-600">{data.income.toLocaleString()}</p>
                                    </div>
                                    <div className="w-px h-8 bg-gray-200 dark:bg-gray-600"></div>
                                    <div className="text-center">
                                        <p className="text-[9px] text-gray-400 font-bold">المصروف</p>
                                        <p className="text-sm font-black text-red-600">{data.expense.toLocaleString()}</p>
                                    </div>
                                    <div className="w-px h-8 bg-gray-200 dark:bg-gray-600"></div>
                                    <div className="text-center">
                                        <p className="text-[9px] text-gray-400 font-bold">الرصيد</p>
                                        <p className={`text-sm font-black ${data.balance >= 0 ? 'text-blue-600' : 'text-orange-600'}`}>{data.balance.toLocaleString()}</p>
                                    </div>
                                </div>
                            </div>

                            {/* الجدول الخاص بالفرع */}
                            <div className="overflow-x-auto">
                                <table className="w-full text-right text-sm">
                                    <thead className={darkMode ? 'bg-gray-700/30' : 'bg-gray-50'}>
                                        <tr>
                                            <th className="p-4">البيان / التصنيف</th>
                                            <th className="p-4">المندوب</th>
                                            <th className="p-4">المبلغ</th>
                                            <th className="p-4">التاريخ</th>
                                            <th className="p-4 text-center no-print">إجراءات</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y dark:divide-gray-700">
                                        {data.rows.length > 0 ? data.rows.map(t => (
                                            <tr key={t.id} className="hover:bg-blue-50/30 dark:hover:bg-gray-700/30 transition-colors">
                                                <td className="p-4">
                                                    <div className="font-bold">{t.title}</div>
                                                    <div className="text-[10px] text-gray-400">{t.category}</div>
                                                </td>
                                                <td className="p-4 text-gray-500 italic">
                                                    {reps.find(r => String(r.id) === String(t.repId))?.name || '--'}
                                                </td>
                                                <td className={`p-4 font-extrabold ${t.type === 'income' ? 'text-green-600' : 'text-red-600'}`}>
                                                    {t.type === 'income' ? '+' : '-'} {Number(t.amount).toLocaleString()} ج.م
                                                </td>
                                                <td className="p-4 font-mono text-gray-400">{t.date}</td>
                                                <td className="p-4 text-center no-print">
                                                    <div className="flex justify-center gap-2">
                                                        <button onClick={() => handleEditClick(t)} className="text-blue-500 p-2 hover:bg-blue-100 rounded-lg transition-colors"><Edit size={14} /></button>
                                                        <button onClick={() => handleSmartDelete(t)} className="text-gray-400 p-2 hover:text-red-500 rounded-lg transition-colors"><Trash2 size={14} /></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )) : (
                                            <tr><td colSpan="5" className="p-10 text-center text-gray-400 italic">لا توجد حركات مسجلة لهذا الفرع حالياً</td></tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* المودال */}
            {showModal && (
                <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[110] p-4 backdrop-blur-sm">
                    <div className={`w-full max-w-md p-6 rounded-2xl shadow-2xl transform animate-scale-in ${darkMode ? 'bg-gray-800 text-white' : 'bg-white'}`}>
                        <div className="flex justify-between items-center mb-6 border-b pb-3 dark:border-gray-700">
                            <h3 className={`font-bold text-xl ${newTrans.type === 'income' ? 'text-green-600' : 'text-red-600'}`}>
                                {editingTrans ? 'تعديل حركة مالية' : (newTrans.type === 'income' ? 'تسجيل توريد' : 'تسجيل مصروف')}
                            </h3>
                            <button onClick={() => setShowModal(false)}><X className="w-6 h-6 text-gray-400" /></button>
                        </div>
                        <div className="space-y-4">
                            <div>
                                <label className={labelClass}>الفرع المستهدف</label>
                                <select className={inputClass} value={newTrans.branch} onChange={e => setNewTrans({...newTrans, branch: e.target.value})}>
                                    {selectedBranches.map(b => <option key={b} value={b}>{b}</option>)}
                                </select>
                            </div>
                            <div>
                                <label className={labelClass}>البيان / الوصف</label>
                                <input className={inputClass} value={newTrans.title} onChange={e => setNewTrans({...newTrans, title: e.target.value})} />
                            </div>
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className={labelClass}>المبلغ</label>
                                    <input type="number" className={inputClass} value={newTrans.amount} onChange={e => setNewTrans({...newTrans, amount: e.target.value})} />
                                </div>
                                <div>
                                    <label className={labelClass}>التاريخ</label>
                                    <input type="date" className={inputClass} value={newTrans.date} onChange={e => setNewTrans({...newTrans, date: e.target.value})} />
                                </div>
                            </div>
                            <div>
                                <label className={labelClass}>التصنيف</label>
                                <select className={inputClass} value={newTrans.category} onChange={e => setNewTrans({...newTrans, category: e.target.value})}>
                                    <option value="عام">عام</option>
                                    <option value="انتقالات">انتقالات</option>
                                    <option value="تسويق">تسويق</option>
                                    <option value="رواتب">رواتب</option>
                                    <option value="إيجار">إيجار</option>
                                    <option value="مبيعات">مبيعات</option>
                                </select>
                            </div>
                            <div>
                                <label className={labelClass}>ربط بمندوب (اختياري)</label>
                                <select className={inputClass} value={newTrans.repId} onChange={e => setNewTrans({...newTrans, repId: e.target.value})}>
                                    <option value="">-- مصروف عام --</option>
                                    {reps.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
                                </select>
                            </div>
                            <button onClick={handleSave} className={`w-full py-4 rounded-xl font-black text-white shadow-lg transition-all active:scale-95 ${newTrans.type === 'income' ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'}`}>
                                تأكيد وحفظ
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
const SettingsManager = ({ settings, setSettings, sections, setSections, users, setUsers, darkMode, getAllData, onSaveSettings }) => {
  const [activeTab, setActiveTab] = useState('general');
  const [showUserModal, setShowUserModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [editingSection, setEditingSection] = useState(null);

  // --- دوال المستخدمين ---
 // --- دالة الحفظ المحسنة ---
  const handleSaveUser = async (userData) => {
    try {
      const cleanData = {
        name: userData.name || '',
        email: userData.email || '',
        password: userData.password || '',
        role: userData.role || 'employee',
        status: userData.status || 'active',
        permissions: userData.permissions || [],
        // 👈 إضافة الحقل الجديد كمصفوفة
        assignedBranches: userData.assignedBranches || [] 
      };

      if (editingUser) {
        // --- حالة التعديل ---
        if (userData.id && typeof userData.id === 'string') {
          const userRef = doc(db, "users", userData.id);
          await updateDoc(userRef, cleanData);
          
          setUsers(users.map(u => u.id === userData.id ? { ...u, ...cleanData } : u));
          alert("تم تعديل بيانات المستخدم بنجاح");
        } else {
          alert("لا يمكن تعديل المستخدمين الافتراضيين.");
        }
      } else {
        // --- حالة الإضافة الجديدة ---
        const docRef = await addDoc(collection(db, "users"), cleanData);
        // إضافة المستخدم الجديد للقائمة المعروضة فوراً
        const newUser = { ...cleanData, id: docRef.id };
        setUsers(prevUsers => [...prevUsers, newUser]); 
        alert("تم إضافة المستخدم الجديد بنجاح");
      }
      setShowUserModal(false);
    } catch (error) {
      console.error("Error saving user: ", error);
      // هذا السطر سيخبرك بالسبب الحقيقي في رسالة تنبيه
      alert("حدث خطأ أثناء الحفظ: " + error.message);
    }
  };
  const handleDeleteUser = async (userId) => {
    if (window.confirm('هل أنت متأكد من الحذف؟')) {
      try {
        if (typeof userId === 'string') {
          await deleteDoc(doc(db, "users", userId));
        }
        setUsers(users.filter(x => x.id !== userId));
        alert("تم الحذف.");
      } catch (error) {
        console.error("Error:", error);
        alert("حدث خطأ أثناء الحذف.");
      }
    }
  };

  // --- دوال الأقسام ---
  const handleMoveSection = (index, direction) => {
    const newSections = [...sections];
    const targetIndex = direction === 'up' ? index - 1 : index + 1;
    if (targetIndex >= 0 && targetIndex < newSections.length) {
      [newSections[index], newSections[targetIndex]] = [newSections[targetIndex], newSections[index]];
      setSections(newSections);
    }
  };

  const handleToggleVisibility = (index) => {
    const newSections = [...sections];
    newSections[index].visible = !newSections[index].visible;
    setSections(newSections);
  };

  const handleSectionUpdate = (index, field, value) => {
    const newSections = [...sections];
    newSections[index][field] = value;
    setSections(newSections);
  };

  // --- دوال العناصر الفرعية ---
  const handleAddItem = (sectionIndex) => {
    const newSections = [...sections];
    if (!newSections[sectionIndex].items) newSections[sectionIndex].items = [];
    newSections[sectionIndex].items.push({ title: 'عنوان', desc: 'وصف', img: '' });
    setSections(newSections);
  };

  const handleUpdateItem = (sectionIndex, itemIndex, field, value) => {
    const newSections = [...sections];
    newSections[sectionIndex].items[itemIndex][field] = value;
    setSections(newSections);
  };

  const handleDeleteItem = (sectionIndex, itemIndex) => {
    if (window.confirm('حذف هذا العنصر؟')) {
      const newSections = [...sections];
      newSections[sectionIndex].items.splice(itemIndex, 1);
      setSections(newSections);
    }
  };

  const handleBackup = () => {
    const data = getAllData();
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `backup_${settings.storeName}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const inputClass = "w-full p-2 border rounded dark:bg-gray-700 dark:border-gray-600 outline-none";
  const labelClass = "block text-sm font-bold mb-2 text-gray-700 dark:text-gray-300";

  return (
    <div className="space-y-6 animate-fade-in">
      <h2 className="text-2xl font-bold">الإعدادات والمستخدمين</h2>

      {/* Tabs Navigation */}
      {/* Tabs Navigation */}
      <div className="flex flex-wrap gap-2 bg-gray-100 dark:bg-gray-700 p-1.5 rounded-lg w-fit">
        {/* إضافة 'footer' هنا */}
        {['general', 'content', 'sections', 'footer', 'users', 'backup'].map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 rounded-md font-bold text-sm transition ${activeTab === tab ? 'bg-white dark:bg-gray-600 shadow text-blue-600' : 'text-gray-500'}`}
          >
            {tab === 'general' ? 'المظهر' : tab === 'content' ? 'المحتوى' : tab === 'sections' ? 'الأقسام' : tab === 'users' ? 'المستخدمين' : tab === 'backup' ? 'نسخ احتياطي' : 'روابط الفوتر'} 
          </button>
        ))}
      </div>

      {/* 1. General Settings */}
      {activeTab === 'general' && (
        <div className={`p-6 rounded-xl shadow-sm border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
          <h3 className="font-bold mb-6 text-blue-600">تخصيص المظهر</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div><label className={labelClass}>اسم الموقع</label><input value={settings.storeName} onChange={e => setSettings({ ...settings, storeName: e.target.value })} className={inputClass} /></div>
            <div><label className={labelClass}>نوع الخط</label><select value={settings.fontType} onChange={e => setSettings({ ...settings, fontType: e.target.value })} className={inputClass}><option value="sans">حديث (Sans)</option><option value="serif">كلاسيكي (Serif)</option></select></div>
            <div><label className={labelClass}>اللون الأساسي</label><div className="flex gap-2"><input type="color" value={settings.primaryColor} onChange={e => setSettings({ ...settings, primaryColor: e.target.value })} className="h-10 w-16" /><input value={settings.primaryColor} onChange={e => setSettings({ ...settings, primaryColor: e.target.value })} className={inputClass} /></div></div>
            <div><label className={labelClass}>لون القائمة (Admin)</label><select value={settings.adminSidebarColor} onChange={e => setSettings({ ...settings, adminSidebarColor: e.target.value })} className={inputClass}><option value="dark">داكن</option><option value="light">فاتح</option></select></div>
          </div>
        </div>
      )}

      {/* 2. Content Settings */}
      {/* 2. Content Settings */}
{activeTab === 'content' && (
  <div className={`p-6 rounded-xl shadow-sm border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
    <h3 className="font-bold mb-6 text-blue-600">إدارة المحتوى</h3>
    <div className="space-y-6">

      {/* --- قسم الرئيسية (Hero) --- */}
      <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
        <h4 className="font-bold mb-4 border-b pb-2">الرئيسية (Hero)</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="md:col-span-2"><label className={labelClass}>العنوان</label><input value={settings.heroTitle} onChange={e => setSettings({ ...settings, heroTitle: e.target.value })} className={inputClass} /></div>
          <div className="md:col-span-2"><label className={labelClass}>الوصف</label><textarea value={settings.heroSubtitle} onChange={e => setSettings({ ...settings, heroSubtitle: e.target.value })} className={`${inputClass} h-20`} /></div>
          <div><label className={labelClass}>نص الزر</label><input value={settings.ctaButtonText} onChange={e => setSettings({ ...settings, ctaButtonText: e.target.value })} className={inputClass} /></div>
          <div><label className={labelClass}>الشفافية (0.1 - 1.0)</label><input type="number" step="0.1" value={settings.heroOverlayOpacity} onChange={e => setSettings({ ...settings, heroOverlayOpacity: parseFloat(e.target.value) })} className={inputClass} /></div>
          
          <div className="md:col-span-2"><label className={labelClass}>صورة الخلفية (رابط صورة)</label><input value={settings.heroImage} onChange={e => setSettings({ ...settings, heroImage: e.target.value })} className={inputClass} /></div>
          
          {/* --- حقل الفيديو --- */}
          <div className="md:col-span-2">
            <label className={labelClass}>رابط فيديو الخلفية (URL)</label>
            <input 
              placeholder="https://example.com/video.mp4" 
              value={settings.heroVideo || ''} 
              onChange={e => setSettings({ ...settings, heroVideo: e.target.value })} 
              className={inputClass} 
            />
            <p className="text-xs text-gray-500 mt-1">اتركه فارغاً إذا كنت تريد استخدام الصورة فقط.</p>
          </div>
          {/* ----------------- */}

        </div>
      </div>

      {/* --- قسم التواصل --- */}
      <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
        <h4 className="font-bold text-lg mb-4 border-b pb-2">التواصل</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div><label className={labelClass}>هاتف</label><input value={settings.contactPhone} onChange={e => setSettings({ ...settings, contactPhone: e.target.value })} className={inputClass} /></div>
          <div><label className={labelClass}>إيميل</label><input value={settings.contactEmail} onChange={e => setSettings({ ...settings, contactEmail: e.target.value })} className={inputClass} /></div>
          
          <div><label className={labelClass}>واتساب (رابط القناة/الرقم)</label><input value={settings.socialWhatsapp} onChange={e => setSettings({ ...settings, socialWhatsapp: e.target.value })} className={inputClass} /></div>
          <div><label className={labelClass}>فيسبوك (URL)</label><input value={settings.socialFacebook} onChange={e => setSettings({ ...settings, socialFacebook: e.target.value })} className={inputClass} /></div>
          
          <div><label className={labelClass}>إنستجرام (URL)</label><input value={settings.socialInstagram} onChange={e => setSettings({ ...settings, socialInstagram: e.target.value })} className={inputClass} /></div>
          <div><label className={labelClass}>لينكد إن (URL) - (Briefcase)</label><input value={settings.socialLinkedIn} onChange={e => setSettings({ ...settings, socialLinkedIn: e.target.value })} className={inputClass} /></div>
          <div><label className={labelClass}>تويتر / X (URL) - (افتراضي)</label><input value={settings.socialTwitter} onChange={e => setSettings({ ...settings, socialTwitter: e.target.value })} className={inputClass} /></div>
          <div><label className={labelClass}>تيك توك (URL) - (Activity)</label><input value={settings.socialTikTok} onChange={e => setSettings({ ...settings, socialTikTok: e.target.value })} className={inputClass} /></div>

          {/* 🛑 حقل الخريطة (الذي كنا نعمل عليه) 🛑 */}
          <div className="md:col-span-2">
            <label className={labelClass}>رابط تضمين الخريطة (Google Maps Iframe URL)</label>
            <input 
              value={settings.mapEmbedUrl} 
              onChange={e => setSettings({ ...settings, mapEmbedUrl: e.target.value })} 
              className={inputClass} 
            />
            <p className="text-xs text-gray-400 mt-1">يمكنك الحصول عليه من Google Maps > مشاركة > تضمين الخريطة.</p>
          </div>
          {/* --------------------------------------------- */}

          {/* 💡 هذا هو الجزء الذي يضيف زر الحفظ في نهاية التبويب */}
          <div className="md:col-span-2"><label className={labelClass}>الفوتر</label><input value={settings.footerText} onChange={e => setSettings({ ...settings, footerText: e.target.value })} className={inputClass} /></div>
        </div>

        {/* 💡 زر حفظ المحتوى - تم إضافته هنا */}
        <div className="flex justify-end mt-6">
            <button 
                onClick={() => onSaveSettings(settings)}
                className="px-6 py-2 bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700"
            >
                حفظ إعدادات المحتوى (بما فيها الخريطة)
            </button>
        </div>
        
      </div>

    </div>
  </div>
)}
      {/* 3. Sections Settings */}
      {activeTab === 'sections' && (
        <div className={`p-6 rounded-xl shadow-sm border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
          <h3 className="font-bold mb-6 text-purple-600">الأقسام الإضافية</h3>
          <div className="space-y-4">
            {sections.map((section, index) => (
              <div key={section.id} className={`border rounded-xl overflow-hidden ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                <div className={`p-4 flex justify-between items-center ${darkMode ? 'bg-gray-700' : 'bg-gray-50'}`}>
                  <div className="flex items-center gap-3">
                    <button onClick={() => setEditingSection(editingSection === index ? null : index)} className="font-bold hover:text-blue-600 flex items-center gap-2">
                      {section.title} <Edit className="w-4 h-4" />
                    </button>
                    <span className={`text-xs px-2 py-1 rounded ${section.visible ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>{section.visible ? 'ظاهر' : 'مخفي'}</span>
                  </div>
                  <div className="flex gap-2">
                    <button onClick={() => handleMoveSection(index, 'up')} disabled={index === 0}><TrendingUp className="w-4 h-4" /></button>
                    <button onClick={() => handleMoveSection(index, 'down')} disabled={index === sections.length - 1}><TrendingUp className="w-4 h-4 transform rotate-180" /></button>
                    <button onClick={() => handleToggleVisibility(index)}>{section.visible ? <CheckCircle className="w-4 h-4 text-green-600" /> : <X className="w-4 h-4" />}</button>
                  </div>
                </div>

                {editingSection === index && (
                  <div className="p-4 bg-white dark:bg-gray-800 border-t dark:border-gray-700">
                    {/* تحسين الـ Grid هنا أيضاً */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6"> 
                      <div><label className={labelClass}>العنوان</label><input value={section.title} onChange={e => handleSectionUpdate(index, 'title', e.target.value)} className={inputClass} /></div>
                      <div><label className={labelClass}>فرعي</label><input value={section.subtitle} onChange={e => handleSectionUpdate(index, 'subtitle', e.target.value)} className={inputClass} /></div>
                      <div className="md:col-span-2"><label className={labelClass}>المحتوى</label><textarea value={section.content} onChange={e => handleSectionUpdate(index, 'content', e.target.value)} className={inputClass} /></div>
                      <div className="md:col-span-2"><label className={labelClass}>صورة</label><input value={section.image} onChange={e => handleSectionUpdate(index, 'image', e.target.value)} className={inputClass} /></div>
                    </div>
                    <div className="bg-gray-50 dark:bg-gray-900/50 p-4 rounded-xl border dark:border-gray-600">
                      <div className="flex justify-between mb-4">
                        <h4 className="font-bold text-sm">العناصر الفرعية</h4>
                        <button onClick={() => handleAddItem(index)} className="text-xs bg-blue-600 text-white px-3 py-1 rounded"><Plus className="w-3 h-3 ml-1" /> إضافة</button>
                      </div>
                      {section.items && section.items.map((item, i) => (
                        // تحسين تنسيق العناصر الفرعية (مرن على الموبايل)
                        <div key={i} className="flex flex-col md:flex-row gap-2 mb-2"> 
                          <input placeholder="عنوان" value={item.title} onChange={(e) => handleUpdateItem(index, i, 'title', e.target.value)} className="p-2 border rounded flex-1 dark:bg-gray-700" />
                          <input placeholder="وصف" value={item.desc} onChange={(e) => handleUpdateItem(index, i, 'desc', e.target.value)} className="p-2 border rounded flex-1 dark:bg-gray-700" />
                          <input placeholder="صورة" value={item.img} onChange={(e) => handleUpdateItem(index, i, 'img', e.target.value)} className="p-2 border rounded flex-1 dark:bg-gray-700" />
                          <button onClick={() => handleDeleteItem(index, i)} className="text-red-500 p-2 flex-shrink-0"><Trash2 className="w-4 h-4" /></button> {/* تم تثبيت العرض */}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
{activeTab === 'footer' && (
    <div className={`p-6 rounded-xl shadow-sm border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
        <div className="flex justify-between items-center mb-6">
            <h3 className="font-bold text-blue-600">إدارة روابط الفوتر السريعة</h3>
            <button 
                onClick={() => setSettings(prev => ({ 
                    ...prev, 
                    footerLinks: [...(prev.footerLinks || []), { id: Date.now(), label: 'رابط جديد', tab: 'home' }] 
                }))}
                className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-bold"
            >
                <Plus className="w-4 h-4 ml-2" /> إضافة رابط
            </button>
        </div>

        <div className="space-y-4">
            {settings.footerLinks && settings.footerLinks.map((link, index) => (
                <div key={link.id} className="flex flex-col md:flex-row gap-3 items-center p-3 border rounded-lg dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50">
                    <input 
                        placeholder="عنوان الرابط"
                        value={link.label} 
                        onChange={e => {
                            const newLinks = [...settings.footerLinks];
                            newLinks[index].label = e.target.value;
                            setSettings(prev => ({ ...prev, footerLinks: newLinks }));
                        }}
                        className="p-2 border rounded dark:bg-gray-700 flex-1" 
                    />
                    <select 
                        value={link.tab} 
                        onChange={e => {
                            const newLinks = [...settings.footerLinks];
                            newLinks[index].tab = e.target.value;
                            setSettings(prev => ({ ...prev, footerLinks: newLinks }));
                        }}
                        className="p-2 border rounded dark:bg-gray-700 flex-1"
                    >
                        <option value="home">الرئيسية</option>
                        <option value="all-properties">عقارات عامة</option>
                        <option value="mortgage-properties">شقق تمويل</option>
                        <option value="mortgage-request">طلب تمويل</option>
                        <option value="add-unit">طلب عرض وحدة</option>
                    </select>
                    <button 
                        onClick={() => setSettings(prev => ({ ...prev, footerLinks: prev.footerLinks.filter(l => l.id !== link.id) }))}
                        className="p-2 text-red-600 hover:bg-red-50 rounded"
                    >
                        <Trash2 className="w-5 h-5" />
                    </button>
                </div>
            ))}
        </div>

        {/* 💡 زر الحفظ المضاف حديثاً لتبويب الفوتر */}
        <div className="flex justify-end mt-8 pt-4 border-t dark:border-gray-700">
            <button 
                onClick={() => onSaveSettings(settings)}
                className="px-8 py-3 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 shadow-lg"
            >
                حفظ تغييرات الفوتر نهائياً
            </button>
        </div>
    </div>
)}
      {/* 4. Users Settings */}
{activeTab === 'users' && (
  <div className={`p-6 rounded-xl shadow-sm border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
    <div className="flex justify-between items-center mb-6 flex-wrap gap-4"> {/* تحسين الاستجابة */}
      <h3 className="font-bold text-purple-600">إدارة المستخدمين والصلاحيات</h3>
      <button onClick={() => { setEditingUser(null); setShowUserModal(true); }} className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-bold"><UserPlus className="w-4 h-4 ml-2" /> إضافة مستخدم جديد</button>
    </div>
    
    <div className="space-y-8">
        
        {/* جدول الموظفين (الموظفين والمدراء) */}
        <h4 className="font-bold text-xl border-b pb-2 text-blue-600 flex items-center gap-2"><Briefcase className="w-5 h-5" /> فريق العمل والإدارة</h4>
        {/* تحسين الجداول للموبايل */}
        <div className="overflow-x-auto"> 
            <table className="w-full text-right text-sm min-w-[600px]">
              <thead className={darkMode ? 'bg-gray-700' : 'bg-gray-100'}>
                <tr><th className="p-3">الاسم</th><th className="p-3">اسم الدخول</th><th className="p-3">الدور/الصلاحيات</th><th className="p-3">الحالة</th><th className="p-3">إجراء</th></tr>
              </thead>
              <tbody className="divide-y dark:divide-gray-700">
                {users.filter(u => u.role === 'admin' || u.role === 'employee').map(u => (
                  <tr key={u.id}>
                    <td className="p-3 font-bold">{u.name}</td>
                    <td className="p-3 font-mono text-gray-500">{u.email}</td>
                    <td className="p-3">
                        <span className={`px-2 py-1 rounded text-xs font-bold ${u.role === 'admin' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                          {u.role === 'admin' ? 'مدير عام (Admin)' : 'موظف (Employee)'}
                        </span>
                        {u.role === 'employee' && u.permissions.length > 0 && <span className="text-xs text-gray-400 block mt-1">({u.permissions.length} صلاحية)</span>}
                    </td>
                    <td className="p-3">{u.status}</td>
                    <td className="p-3 flex gap-2">
                      <button onClick={() => { setEditingUser(u); setShowUserModal(true); }} className="text-blue-500 p-2"><Edit className="w-4 h-4" /></button>
                      <button onClick={() => handleDeleteUser(u.id)} className="text-red-500 p-2"><Trash2 className="w-4 h-4" /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
        </div>

        {/* جدول العملاء (العملاء) */}
        <h4 className="font-bold text-xl border-b pb-2 text-orange-600 flex items-center gap-2"><Users className="w-5 h-5" /> العملاء المسجلين</h4>
        {/* تحسين الجداول للموبايل */}
        <div className="overflow-x-auto">
            <table className="w-full text-right text-sm min-w-[600px]">
              <thead className={darkMode ? 'bg-gray-700' : 'bg-gray-100'}>
                <tr><th className="p-3">الاسم</th><th className="p-3">رقم الهاتف</th><th className="p-3">تاريخ التسجيل</th><th className="p-3">الحالة</th><th className="p-3">إجراء</th></tr>
              </thead>
              <tbody className="divide-y dark:divide-gray-700">
                {users.filter(u => u.role === 'client').map(u => (
                  <tr key={u.id}>
                    <td className="p-3 font-bold">{u.name}</td>
                    <td className="p-3 font-mono text-gray-500">{u.phone || u.email}</td>
                    <td className="p-3 text-xs text-gray-400">{u.createdAt ? new Date(u.createdAt).toLocaleDateString() : 'غير معروف'}</td>
                    <td className="p-3">
                      <span className={`px-2 py-1 rounded text-xs font-bold ${u.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>{u.status}</span>
                    </td>
                    <td className="p-3 flex gap-2">
                      {/* هنا يمكنك فتح مودال لتعديل حالة العميل أو بياناته الأساسية */}
                      <button onClick={() => { setEditingUser(u); setShowUserModal(true); }} className="text-blue-500 p-2"><Edit className="w-4 h-4" /></button>
                      <button onClick={() => handleDeleteUser(u.id)} className="text-red-500 p-2"><Trash2 className="w-4 h-4" /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
        </div>
        
    </div>
  </div>
)}
      {/* 5. Backup Settings */}
      {activeTab === 'backup' && (
        <div className={`p-6 rounded-xl shadow-sm border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
          <h3 className="font-bold mb-4 text-gray-500">النسخ الاحتياطي</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6"> {/* تحسين الاستجابة */}
            <div className="p-6 border rounded-xl bg-green-50 dark:bg-green-900/20">
              <h4 className="font-bold mb-2 text-green-700">تصدير (Backup)</h4>
              <button onClick={handleBackup} className="px-6 py-3 bg-green-600 text-white rounded-lg w-full font-bold">تحميل البيانات</button>
            </div>
            <div className="p-6 border rounded-xl bg-blue-50 dark:bg-blue-900/20">
              <h4 className="font-bold mb-2 text-blue-700">استرداد (Restore)</h4>
              <label className="px-6 py-3 bg-blue-600 text-white rounded-lg w-full font-bold cursor-pointer block text-center">
                رفع ملف
                <input type="file" accept=".json" onChange={(e) => { if (e.target.files[0]) alert('تم الاسترداد'); }} className="hidden" />
              </label>
            </div>
          </div>
        </div>
      )}

      {showUserModal && <UserModal user={editingUser} onClose={() => setShowUserModal(false)} onSave={handleSaveUser} darkMode={darkMode} />}
    </div>
  );
};
const DealClosingManager = ({ customers, setCustomers, reps, sales, setSales, transactions, setTransactions, darkMode, logActivity }) => {
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [finalPrice, setFinalPrice] = useState('');
  const [targetBranch, setTargetBranch] = useState('المعادي'); // الحالة الافتراضية للفرع المختار

  const activeCustomers = customers.filter(c => c.status !== 'تم التنفيذ' && c.status !== 'ملغى');

  const handleConfirmDeal = async () => {
    if (!selectedCustomer || !finalPrice) { 
      alert('يرجى اختيار عميل وإدخال المبلغ النهائي.'); 
      return; 
    }
    
    if (window.confirm(`هل أنت متأكد من إتمام صفقة العميل "${selectedCustomer.name}" بمبلغ ${Number(finalPrice).toLocaleString()} وترحيلها لخزينة فرع ${targetBranch}؟`)) {
      
      const dealAmount = Number(finalPrice);
      const dateNow = new Date().toISOString().split('T')[0];
      const customerId = String(selectedCustomer.id);

      try {
        // 1. تحديث حالة العميل في Firestore
        const customerRef = doc(db, "customers", customerId);
        await updateDoc(customerRef, {
          status: 'تم التنفيذ',
          closedAmount: dealAmount,
          closingDate: new Date().toISOString(),
          closingBranch: targetBranch 
        });

        // 2. إضافة سجل مبيعات جديد لـ Firebase
        const saleData = {
          contractNumber: `CNT-${Math.floor(Math.random() * 100000)}`,
          customerId: customerId,
          customerName: selectedCustomer.name,
          projectName: 'إنهاء معاملة',
          amount: dealAmount,
          repId: String(selectedCustomer.repId),
          date: dateNow,
          status: 'مكتمل',
          branch: targetBranch
        };
        await addDoc(collection(db, "sales"), saleData);

        // 3. ترحيل المبلغ للخزينة المختارة (Transactions) في Firebase
        const transactionData = {
          type: 'income',
          title: `إتمام صفقة: ${selectedCustomer.name}`,
          amount: dealAmount,
          date: dateNow,
          category: 'مبيعات',
          branch: targetBranch, // تحديد الفرع المطلوب الترحيل إليه
          repId: String(selectedCustomer.repId),
          customerName: selectedCustomer.name
        };
        await addDoc(collection(db, "transactions"), transactionData);

        // 💡 4. تسجيل العملية في سجل العمليات (Activity Log)
        await logActivity(
          "إنهاء المعاملات", 
          `إتمام صفقة للعميل (${selectedCustomer.name}) بمبلغ ${dealAmount.toLocaleString()} ج.م وترحيلها لخزينة فرع ${targetBranch}`
        );

        alert(`تم إغلاق الصفقة بنجاح! تم تحويلها للمبيعات، وإضافتها لخزينة فرع ${targetBranch}، وسيتم احتساب العمولة للمندوب.`);
        
        // إعادة تعيين الحقول بعد النجاح
        setSelectedCustomer(null);
        setFinalPrice('');
      } catch (error) {
        console.error("Error closing deal:", error);
        alert("حدث خطأ أثناء الاتصال بقاعدة البيانات، يرجى المحاولة مرة أخرى.");
      }
    }
};

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold flex items-center gap-2 text-blue-600">
          <CheckSquare className="w-6 h-6" /> إنهاء المعاملات وإغلاق الصفقات
        </h2>
      </div>
      
      {/* تحسين الـ Grid على الموبايل: عرض عمود واحد ثم الانتقال لـ 3 أعمدة على شاشات أكبر */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6"> 
        <div className={`lg:col-span-2 p-6 rounded-xl shadow-sm border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
            <h3 className="font-bold mb-4 text-gray-500">اختر عميلاً لإغلاق صفقته</h3>
            <div className="overflow-y-auto max-h-[500px] space-y-2">
                {activeCustomers.length > 0 ? activeCustomers.map(c => (
                    <div key={c.id} onClick={() => setSelectedCustomer(c)} className={`p-4 rounded-lg border cursor-pointer transition-all ${selectedCustomer?.id === c.id ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20 ring-1 ring-blue-500' : 'border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'}`}>
                        <div className="flex justify-between items-center">
                            <div>
                                <p className="font-bold">{c.name}</p>
                                <p className="text-xs text-gray-500">{c.unitLocation} - {c.phone}</p>
                            </div>
                            <div className="text-right">
                                <span className={`px-2 py-1 rounded text-xs ${c.type === 'VIP' ? 'bg-purple-100 text-purple-700' : 'bg-gray-100 text-gray-600'}`}>{c.type}</span>
                                <p className="text-xs text-gray-400 mt-1">{c.status}</p>
                            </div>
                        </div>
                    </div>
                )) : <p className="text-center text-gray-500 py-8">لا توجد معاملات جارية حالياً</p>}
            </div>
        </div>
        
        <div className={`p-6 rounded-xl shadow-sm border h-fit sticky top-4 ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
            <h3 className="font-bold mb-6 flex items-center"><FileCheck className="w-5 h-5 ml-2 text-green-600" /> بيانات الإغلاق والترحيل</h3>
            {selectedCustomer ? (
                <div className="space-y-6">
                    <div className="bg-gray-50 dark:bg-gray-700/50 p-4 rounded-lg">
                        <p className="text-sm text-gray-500 mb-1">العميل المحدد</p>
                        <p className="font-bold text-lg">{selectedCustomer.name}</p>
                        <div className="flex items-center gap-2 mt-2 text-sm text-blue-600">
                            <User className="w-4 h-4" />
                            <span>المندوب: {reps.find(r => String(r.id) === String(selectedCustomer.repId))?.name || 'غير محدد'}</span>
                        </div>
                    </div>

                    {/* حقل اختيار الفرع المضاف */}
                    <div>
                        <label className="block text-sm font-bold mb-2">ترحيل إلى خزينة فرع:</label>
    <select 
        value={targetBranch} 
        onChange={(e) => setTargetBranch(e.target.value)}
        className="w-full p-3 border rounded-lg bg-white dark:bg-gray-700 outline-none focus:ring-2 focus:ring-blue-500 font-bold"
    >
        <option value="المعادي">فرع المعادي</option>
        <option value="المهندسين">فرع المهندسين</option>
        <option value="التجمع">فرع التجمع</option> {/* أضفنا هذا السطر */}
    </select>
</div>
                    
                    <div>
                        <label className="block text-sm font-bold mb-2">مبلغ التنفيذ النهائي (ج.م)</label>
                        <input 
                          type="number" 
                          className="w-full p-3 border rounded-lg text-lg font-bold text-green-600 focus:ring-2 focus:ring-green-500 outline-none dark:bg-gray-700 dark:border-gray-600" 
                          placeholder="0.00" 
                          value={finalPrice} 
                          onChange={(e) => setFinalPrice(e.target.value)} 
                        />
                    </div>
                    
                    <button onClick={handleConfirmDeal} className="w-full py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg font-bold shadow-lg shadow-green-600/20 transition transform active:scale-95 flex items-center justify-center">
                        <CheckCircle className="w-5 h-5 ml-2" /> تأكيد وإتمام وترحيل الصفقة
                    </button>
                    
                    <div className="text-xs text-gray-400 space-y-1 bg-gray-50 dark:bg-gray-800 p-3 rounded border dark:border-gray-700">
                        <p>• سيتم تحويل حالة العميل إلى "تم التنفيذ".</p>
                        <p>• سيتم إضافة المبلغ إلى سجل مبيعات فرع {targetBranch}.</p>
                        <p>• سيتم ترحيل إيراد فوري لخزينة <strong>{targetBranch}</strong>.</p>
                        <p>• سيتم احتساب العمولة للمندوب تلقائياً.</p>
                    </div>
                </div>
            ) : (
                <div className="text-center py-10 text-gray-400">
                    <ArrowRight className="w-12 h-12 mx-auto mb-2 opacity-20" />
                    <p>يرجى اختيار عميل من القائمة لبدء الإغلاق</p>
                </div>
            )}
        </div>
      </div>
    </div>
  );
};
const ImageSlider = ({ images, videoUrl, heightClass = "h-64" }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // دمج الصور مع الفيديو (كعنصر أخير) إذا وُجد فيديو
  const slides = useMemo(() => {
    const allSlides = images ? [...images] : [];
    if (videoUrl) {
      allSlides.push({ type: 'video', url: videoUrl });
    }
    return allSlides;
  }, [images, videoUrl]);

  if (slides.length === 0) return null;

  const prevSlide = (e) => {
    e.stopPropagation();
    setCurrentIndex(prev => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const nextSlide = (e) => {
    e.stopPropagation();
    setCurrentIndex(prev => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const currentSlide = slides[currentIndex];

  return (
    <div className={`relative w-full ${heightClass} group overflow-hidden`}>
      {/* عرض الصورة العادية */}
      {typeof currentSlide === 'string' ? (
        <img 
          src={currentSlide} 
          alt="property" 
          className="w-full h-full object-cover transition-opacity duration-500" 
        />
      ) : (
        /* عرض واجهة الفيديو (واتساب) */
        <div 
          onClick={(e) => { e.stopPropagation(); window.open(currentSlide.url, '_blank'); }}
          className="w-full h-full bg-gradient-to-br from-green-900 to-black flex flex-col items-center justify-center cursor-pointer p-4"
        >
          <div className="bg-green-500 p-4 rounded-full shadow-[0_0_20px_rgba(34,197,94,0.6)] animate-pulse mb-3">
            <Play fill="white" size={30} className="text-white ml-1" />
          </div>
          <span className="text-white font-bold text-sm bg-black/30 px-3 py-1 rounded-full flex items-center gap-2">
            <MessageCircle size={16} className="text-green-400" />
            مشاهدة فيديو المعاينة على واتساب
          </span>
        </div>
      )}

      {/* الأسهم للتنقل */}
      {slides.length > 1 && (
        <>
          <button onClick={prevSlide} className="absolute top-1/2 -translate-y-1/2 left-2 z-20 p-2 bg-black/40 text-white rounded-full hover:bg-black/60 transition opacity-0 group-hover:opacity-100">
            <ChevronLeft size={20} />
          </button>
          <button onClick={nextSlide} className="absolute top-1/2 -translate-y-1/2 right-2 z-20 p-2 bg-black/40 text-white rounded-full hover:bg-black/60 transition opacity-0 group-hover:opacity-100">
            <ChevronRight size={20} />
          </button>
          
          {/* النقاط السفلية */}
          <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-1.5 z-20">
            {slides.map((_, i) => (
              <div 
                key={i} 
                className={`w-2 h-2 rounded-full transition-all ${currentIndex === i ? 'bg-white scale-125' : 'bg-white/40'}`}
              ></div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
const ComparisonModal = ({ selectedUnits, onClose, darkMode }) => {
  if (selectedUnits.length === 0) return null;

  return (
    <div className="fixed inset-0 bg-black/80 z-[60] flex items-center justify-center p-4 animate-fade-in">
      <div className={`w-full max-w-6xl max-h-[90vh] overflow-y-auto rounded-2xl p-6 relative ${darkMode ? 'bg-gray-800 text-white' : 'bg-white'}`}>
        <button onClick={onClose} className="absolute top-4 left-4 p-2 bg-gray-200 hover:bg-red-500 hover:text-white rounded-full transition"><X className="w-5 h-5" /></button>
        <h3 className="text-2xl font-bold mb-6 flex items-center gap-2"><Scale className="w-6 h-6 text-orange-500" /> مقارنة الوحدات</h3>
        
        {/* تحسين الجداول للموبايل */}
        <div className="overflow-x-auto"> 
          <table className="w-full text-center border-collapse min-w-[700px]"> {/* إضافة عرض أدنى */}
            <thead>
              <tr>
                <th className="p-4 text-right text-gray-500 w-32">وجه المقارنة</th>
                {selectedUnits.map(unit => (
                  <th key={unit.id} className="p-4 border-b border-gray-200 dark:border-gray-700 min-w-[200px]">
                    <div className="h-32 w-full mb-3 rounded-lg overflow-hidden">
                      <img src={unit.images[0]} className="w-full h-full object-cover" alt="unit" />
                    </div>
                    <div className="font-bold text-lg">{unit.name}</div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y dark:divide-gray-700">
              <tr>
                <td className="p-4 font-bold bg-gray-50 dark:bg-gray-700/50">السعر الإجمالي</td>
                {selectedUnits.map(unit => <td key={unit.id} className="p-4 font-bold text-blue-600">{unit.price.toLocaleString()} ج.م</td>)}
              </tr>
              <tr>
                <td className="p-4 font-bold bg-gray-50 dark:bg-gray-700/50">المساحة</td>
                {selectedUnits.map(unit => <td key={unit.id} className="p-4">{unit.area} م²</td>)}
              </tr>
              <tr>
                <td className="p-4 font-bold bg-gray-50 dark:bg-gray-700/50">سعر المتر</td>
                {selectedUnits.map(unit => <td key={unit.id} className="p-4 text-green-600 font-bold">{Math.round(unit.price / unit.area).toLocaleString()} ج.م</td>)}
              </tr>
              <tr>
                <td className="p-4 font-bold bg-gray-50 dark:bg-gray-700/50">الموقع</td>
                {selectedUnits.map(unit => <td key={unit.id} className="p-4">{unit.location}</td>)}
              </tr>
              <tr>
                <td className="p-4 font-bold bg-gray-50 dark:bg-gray-700/50">التشطيب</td>
                {/* افتراض بيانات التشطيب أو عرض نص ثابت إذا لم تتوفر */}
                {selectedUnits.map(unit => <td key={unit.id} className="p-4 text-sm">{unit.description.includes('تشطيب') ? 'متشطب' : 'نصف تشطيب / محارة'}</td>)}
              </tr>
                <tr>
                <td className="p-4 font-bold bg-gray-50 dark:bg-gray-700/50">الغرف/الحمامات</td>
                {selectedUnits.map(unit => <td key={unit.id} className="p-4">{unit.bedrooms} غرف | {unit.bathrooms} حمام</td>)}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
// --- (جديد) مكون عداد الزيارات (VisitorCounter) ---
const VisitorCounter = ({ count, darkMode }) => {
    // تنسيق الرقم بالفاصلات للأناقة (1245 -> 1,245)
    const formattedCount = typeof count === 'number' ? count.toLocaleString('en-US') : '...';

    return (
        <div className={`visitor-counter flex items-center p-2 rounded-full text-sm font-bold transition ${darkMode ? 'bg-gray-700/50 border-gray-600' : 'bg-gray-100 border-gray-200'} border`}>
            {/* أيقونة شيك (Star) */}
            <Star className={`w-4 h-4 ml-1 ${darkMode ? 'text-yellow-400' : 'text-orange-500'}`} />
            
            <span className={`count-label text-gray-500 ${darkMode ? 'text-gray-300' : ''} hidden sm:inline`}>زيارة:</span> {/* إخفاء كلمة "زيارة" على أصغر الشاشات */}
            
            {/* قيمة العداد */}
            <span id="visitCount" className={`count-value font-extrabold mr-1 ${darkMode ? 'text-white' : 'text-blue-600'}`}>
                {formattedCount}
            </span>
        </div>
    );
};
// --- مكون MortgageRequestForm المُحدَّث ---
// --- مكون MortgageRequestForm المُحدَّث ---
const MortgageRequestForm = ({ darkMode, mortgageForm, setMortgageForm, onSubmit }) => {
    // تنسيق المدخلات ليدعم الوضعين (احترافي)
    const inputClass = `w-full p-3 border rounded-lg outline-none transition-all duration-300 focus:ring-2 focus:ring-blue-500 
        ${darkMode 
            ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
            : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500'
        }`;
    
    const labelClass = `block text-sm font-bold mb-2 ${darkMode ? 'text-gray-200' : 'text-gray-700'}`;

    const handleSubmit = (e) => {
        e.preventDefault();
        // تأكيد إدخال البيانات المطلوبة قبل الإرسال
        if (!mortgageForm.name || !mortgageForm.phone || !mortgageForm.salary || !mortgageForm.budget) {
            alert('يرجى ملء جميع الحقول المطلوبة (الاسم، الهاتف، الدخل الشهري، والميزانية).');
            return;
        }
        onSubmit(mortgageForm);
    };

    const handleSelectChange = (field, value) => {
        setMortgageForm(prev => ({ ...prev, [field]: value }));
    };

    return (
        <div className="max-w-3xl mx-auto p-4 md:p-12 w-full animate-fade-in pt-10">
            {/* الحاوية الرئيسية للنموذج */}
            <div className={`p-6 md:p-8 rounded-2xl shadow-xl transition-all duration-500 border 
                ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-transparent'}`}>
                
                <h3 className={`text-2xl font-bold mb-8 text-center flex items-center justify-center gap-3 
                    ${darkMode ? 'text-white' : 'text-gray-800'}`}>
                    <Banknote className="w-8 h-8 text-green-500" /> نموذج طلب تمويل عقاري
                </h3>

                <form onSubmit={handleSubmit} className="space-y-6">
                    
                    {/* 1. بيانات العميل الأساسية */}
                    <div className={`p-5 border rounded-xl transition-colors 
                        ${darkMode ? 'bg-gray-700/30 border-blue-900/50' : 'bg-blue-50 border-blue-100'}`}>
                        
                        <h4 className={`font-bold text-lg mb-4 flex items-center gap-2 
                            ${darkMode ? 'text-blue-400' : 'text-blue-700'}`}>
                            <User className="w-5 h-5" /> معلومات التواصل والبيانات الشخصية
                        </h4>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4"> 
                            <div>
                                <label className={labelClass}>الاسم بالكامل <span className="text-red-500">*</span></label>
                                <input 
                                    required 
                                    className={inputClass} 
                                    placeholder="أدخل اسمك الثلاثي"
                                    value={mortgageForm.name} 
                                    onChange={e => handleSelectChange('name', e.target.value)} 
                                />
                            </div>
                            <div>
                                <label className={labelClass}>رقم الموبايل <span className="text-red-500">*</span></label>
                                <input 
                                    required 
                                    type="tel" 
                                    className={inputClass} 
                                    placeholder="01xxxxxxxxx"
                                    value={mortgageForm.phone} 
                                    onChange={e => handleSelectChange('phone', e.target.value)} 
                                />
                            </div>
                            <div>
                                <label className={labelClass}>السن</label>
                                <input 
                                    type="number" 
                                    placeholder="مثال: 30" 
                                    className={inputClass} 
                                    value={mortgageForm.age} 
                                    onChange={e => handleSelectChange('age', Number(e.target.value))} 
                                />
                            </div>
                            <div>
                                <label className={labelClass}>الحالة الاجتماعية</label>
                                <select 
                                    className={inputClass} 
                                    value={mortgageForm.maritalStatus} 
                                    onChange={e => handleSelectChange('maritalStatus', e.target.value)}
                                >
                                    <option value="أعزب">أعزب</option>
                                    <option value="متزوج">متزوج</option>
                                    <option value="مطلق">مطلق</option>
                                    <option value="أرمل">أرمل</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* 2. البيانات المالية */}
                    <div className={`p-5 border rounded-xl transition-colors 
                        ${darkMode ? 'bg-gray-700/30 border-green-900/50' : 'bg-green-50 border-green-100'}`}>
                        
                        <h4 className={`font-bold text-lg mb-4 flex items-center gap-2 
                            ${darkMode ? 'text-green-400' : 'text-green-700'}`}>
                            <DollarSign className="w-5 h-5" /> المعلومات المالية
                        </h4>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className={labelClass}>متوسط الدخل الشهري (صافي) <span className="text-red-500">*</span></label>
                                <input 
                                    required 
                                    type="number" 
                                    placeholder="مثال: 15000" 
                                    className={inputClass} 
                                    value={mortgageForm.salary} 
                                    onChange={e => handleSelectChange('salary', Number(e.target.value))} 
                                />
                            </div>
                            <div>
                                <label className={labelClass}>الميزانية المتوقعة للعقار <span className="text-red-500">*</span></label>
                                <input 
                                    required 
                                    type="number" 
                                    placeholder="مثال: 1500000" 
                                    className={inputClass} 
                                    value={mortgageForm.budget} 
                                    onChange={e => handleSelectChange('budget', Number(e.target.value))} 
                                />
                            </div>
                        </div>
                        
                        {/* حقل نوع المبادرة */}
                        <div className="mt-4">
                            <label className={labelClass}>نوع المبادرة المطلوبة</label>
                            <select 
                                className={inputClass} 
                                value={mortgageForm.initiativeType} 
                                onChange={e => handleSelectChange('initiativeType', e.target.value)}
                            >
                                <option value="8%">المبادرة العقارية (8%)</option>
                                <option value="12%">المبادرة العقارية (12%)</option>
                                <option value="عادية">تمويل عادي/حر</option>
                            </select>
                            
                            {/* صندوق التلميحات */}
                            <div className={`mt-3 p-4 text-xs rounded-lg border leading-relaxed 
                                ${darkMode 
                                    ? 'bg-gray-900/50 border-gray-600 text-gray-300' 
                                    : 'bg-white border-gray-200 text-gray-600'}`}>
                                
                                <h5 className={`font-extrabold text-sm mb-2 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`}>شروط المبادرات العقارية:</h5>
                                <ul className="list-disc pr-4 space-y-1">
                                    <li className="font-bold">مبادرة 8%: مرتب السنجل حتى 13 ألف، والمتزوج حتى 18 ألف.</li>
                                    <li className="font-bold">مبادرة 12%: مرتب السنجل حتى 40 ألف، والمتزوج حتى 50 ألف.</li>
                                    <li>القسط لا يتجاوز 40% من صافي الدخل الشهري.</li>
                                </ul>
                                
                                <h5 className="font-extrabold text-sm mb-1 mt-4 text-red-500">الورق المطلوب مبدئياً:</h5>
                                <p>مفردات مرتب - كشف حساب بنكي (6 شهور) - برنت تأمينات - إيصال مرافق - صورة بطاقة.</p>
                            </div>
                        </div>

                        {/* الالتزامات البنكية */}
                        <div className="mt-4 space-y-3">
                            <h5 className={`font-bold text-sm ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>هل لديك التزامات بنكية حالية؟</h5>
                            <div className={`flex items-center justify-between p-3 border rounded-lg 
                                ${darkMode ? 'border-gray-600 bg-gray-800/40' : 'bg-white border-gray-200'}`}>
                                <span className="flex items-center gap-2 text-sm"><Banknote className="w-4 h-4 text-gray-400" /> قرض شخصي؟</span>
                                <select className="p-1 border rounded bg-transparent outline-none text-sm" value={mortgageForm.hasPersonalLoan} onChange={e => handleSelectChange('hasPersonalLoan', e.target.value)}>
                                    <option value="لا">لا</option><option value="نعم">نعم</option>
                                </select>
                            </div>
                            <div className={`flex items-center justify-between p-3 border rounded-lg 
                                ${darkMode ? 'border-gray-600 bg-gray-800/40' : 'bg-white border-gray-200'}`}>
                                <span className="flex items-center gap-2 text-sm"><Briefcase className="w-4 h-4 text-gray-400" /> فيزا مشتريات؟</span>
                                <select className="p-1 border rounded bg-transparent outline-none text-sm" value={mortgageForm.hasCarLoan} onChange={e => handleSelectChange('hasCarLoan', e.target.value)}>
                                    <option value="لا">لا</option><option value="نعم">نعم</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    
                    {/* 3. ملاحظات وتفاصيل العقار */}
                    <div className={`p-4 border rounded-xl 
                        ${darkMode ? 'bg-gray-700/20 border-gray-600' : 'bg-gray-50 border-gray-200'}`}>
                        
                        <h4 className={`font-bold text-lg mb-4 flex items-center gap-2 
                            ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}>
                            <Building className="w-5 h-5" /> تفاصيل العقار المرغوب
                        </h4>
                        <textarea 
                            placeholder="اكتب هنا ملاحظاتك حول العقار (الموقع، المساحة، عدد الغرف...)" 
                            className={`${inputClass} h-24 resize-none`} 
                            value={mortgageForm.notes} 
                            onChange={e => handleSelectChange('notes', e.target.value)}
                        />
                        <p className={`text-xs mt-2 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                            سيتم التواصل معك فوراً من قبل فريق التمويل لدينا لمساعدتك في التقييم.
                        </p>
                    </div>

                    <button 
                        type="submit" 
                        className="w-full py-4 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 shadow-lg transition-all transform active:scale-95 flex items-center justify-center gap-2"
                    >
                        <ArrowRight className="w-5 h-5" /> إرسال طلب التقييم والتمويل
                    </button>
                </form>
            </div>
        </div>
    );
};
// --- (جديد) مكون Footer المتقدم (بناءً على الصورة) ---
const AdvancedFooter = ({ settings, darkMode }) => {
    // 💡 تحديد الألوان مع قيم احتياطية
    const secondaryColor = settings?.secondaryColor || '#222222';
    const primaryColor = settings?.primaryColor || '#c0a062';
    
    // 💡 منطق استعادة الروابط: يبحث في الإعدادات أولاً، ثم الثوابت، ثم مصفوفة فارغة
    // تم وضعه هنا مرة واحدة فقط لتجنب خطأ "Identifier already declared"
    // التعديل الصحيح: عرض الروابط من السيتنج مباشرة حتى لو كانت فارغة
const quickLinks = settings?.footerLinks || [];
    
    return (
        // استخدام اللون الداكن لـ secondaryColor كخلفية
        <footer className="text-white pt-16 pb-8 px-6 no-print" style={{ backgroundColor: secondaryColor }}>
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
                
                {/* 1. معلومات الشركة والشبكات الاجتماعية */}
                <div className="md:col-span-1 text-right">
                    <div className="flex items-center gap-3 mb-4 justify-start">
                        <img src="/logo.png" alt="Logo" className="w-10 h-10 object-contain" style={{ filter: 'invert(1) grayscale(1) brightness(1.5)' }} />
                        <span className="text-2xl font-black uppercase" style={{ color: primaryColor }}>
                            {settings?.storeName?.split(' ')[0] || "HOMIX "}
                        </span>
                    </div>
                    <p className="text-gray-400 leading-relaxed mb-6 text-sm">
                        نحن في (HOMIX ) للاستثمار العقاري، شركة رائدة في مجال التسويق العقاري، نقدم لك أفضل الحلول العقارية المتكاملة.
                    </p>
                    
                    {/* أيقونات التواصل الاجتماعي */}
                    <div className="flex gap-3 justify-start">
                        <a href={settings?.socialFacebook} target="_blank" rel="noopener noreferrer" className="p-2 border border-gray-600 rounded-full hover:bg-blue-600 transition" title="Facebook"><Facebook size={20} /></a>
                        <a href={settings?.socialInstagram} target="_blank" rel="noopener noreferrer" className="p-2 border border-gray-600 rounded-full hover:bg-pink-600 transition" title="Instagram"><Instagram size={20} /></a>
                        <a href={settings?.socialWhatsapp} target="_blank" rel="noopener noreferrer" className="p-2 border border-gray-600 rounded-full hover:bg-green-600 transition" title="WhatsApp"><MessageCircle size={20} /></a>
                        
                        {settings?.socialLinkedIn && (
                            <a href={settings.socialLinkedIn} target="_blank" rel="noopener noreferrer" className="p-2 border border-gray-600 rounded-full hover:bg-blue-800 transition" title="LinkedIn"><Briefcase size={20} /></a>
                        )}
                        {settings?.socialTwitter && (
                            <a href={settings.socialTwitter} target="_blank" rel="noopener noreferrer" className="p-2 border border-gray-600 rounded-full hover:bg-sky-500 transition" title="Twitter/X"><Briefcase size={20} /></a>
                        )}
                        {settings?.socialTikTok && (
                            <a href={settings.socialTikTok} target="_blank" rel="noopener noreferrer" className="p-2 border border-gray-600 rounded-full hover:bg-black transition" title="TikTok"><Activity size={20} /></a>
                        )}
                    </div>
                </div>

                {/* 2. الروابط السريعة (الوسط) */}
                <div className="md:col-span-1 text-right">
                    <h4 className="font-bold text-lg mb-4 border-b border-gray-700 pb-2 inline-block"></h4>
                    <ul className="space-y-2 text-gray-400 text-sm">
                        {quickLinks.map(link => (
                            <li key={link.id}>
                                <button
                                    onClick={() => {
                                        if (link.tab === 'custom' && link.url) {
                                            window.open(link.url, '_blank');
                                        } else {
                                            window.dispatchEvent(new CustomEvent('changeTab', { detail: link.tab }));
                                        }
                                    }}
                                    className="hover:text-white transition cursor-pointer text-right w-full"
                                >
                                    {link.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                
                {/* 3. اتصل بنا */}
                <div className="md:col-span-1 text-right">
                    <h4 className="font-bold text-lg mb-4 border-b border-gray-700 pb-2 inline-block">اتصل بنا</h4>
                    <div className="space-y-3">
                        <a href={`tel:${settings?.contactPhone}`} className="flex items-center gap-3 text-gray-300 hover:text-white transition justify-start">
                            <Phone className="w-5 h-5 text-green-400" />
                            <span className="font-mono text-lg">{settings?.contactPhone}</span>
                        </a>
                        <a href={`mailto:${settings?.contactEmail}`} className="flex items-center gap-3 text-gray-300 hover:text-white transition justify-start">
                            <Mail className="w-5 h-5 text-red-400" />
                            <span className="font-mono text-sm">{settings?.contactEmail}</span>
                        </a>
                        <button
                            onClick={() => window.dispatchEvent(new CustomEvent('changeTab', { detail: 'add-unit' }))}
                            className="w-full mt-4 py-2 text-sm font-bold rounded-lg text-white transition hover:brightness-110 active:scale-95"
                            style={{ backgroundColor: primaryColor }}
                        >
                            طلب عرض وحدة 
                        </button>
                    </div>
                </div>

                {/* 4. الخريطة الفعلية */}
                <div className="md:col-span-1 text-right">
                    <h4 className="font-bold text-lg mb-4 border-b border-gray-700 pb-2 inline-block">تابعنا على الخريطة</h4>
                    <div className="w-full h-48 rounded-xl overflow-hidden shadow-lg border-2 border-gray-700 relative bg-gray-800">
                        {settings?.mapEmbedUrl ? (
                            <iframe
                                src={settings.mapEmbedUrl} 
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Map Location"
                            ></iframe>
                        ) : (
                            <div className="flex flex-col items-center justify-center w-full h-full text-gray-400 text-sm p-4 text-center">
                                <MapPin className="w-6 h-6 mb-2 text-gray-500" /> 
                                <span>لم يتم تحديد رابط الخريطة بعد في الإعدادات.</span>
                            </div>
                        )}
                    </div>
                </div>

            </div>

            {/* سطر حقوق النشر */}
            <div className="border-t border-gray-700 pt-8 text-center text-gray-500 text-sm">
                {settings?.footerText || "جميع الحقوق محفوظة لشركة HOMIX Real Estate © 2025"}
            </div>
        </footer>
    );
};
const ClientView = ({ 
  projects, 
  reps, 
  settings, 
  sections, 
  darkMode, 
  activeTab, 
  onAddUnitSubmit, 
  onMortgageRequestSubmit,
  onPostToFacebook, 
  clientFavorites = [], 
  toggleFavorite,
  user,
  pendingUnits,
  mortgageRequests
}) => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const propertiesPerPage = 10;

  // 1. مراجع التحكم (Refs)
  const scrollRef = useRef(null);

  // 2. دالة التمرير اليدوي (الأسهم) للفريق
  const scroll = (direction) => {
    const { current } = scrollRef;
    if (current) {
        const shift = direction === 'left' ? 300 : -300; 
        current.scrollBy({ left: shift, behavior: 'smooth' });
    }
  };

  // 3. تأثير التحريك التلقائي لسلايدر الفريق
  useEffect(() => {
    const interval = setInterval(() => {
      if (scrollRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
        if (Math.abs(scrollLeft) + clientWidth >= scrollWidth - 10) {
          scrollRef.current.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
        }
      }
    }, 4000);

    return () => clearInterval(interval);
  }, [reps]); 

  // 4. حالات الفلترة والنماذج
  const [filters, setFilters] = useState({ 
    location: '', category: '', status: '', minPrice: '', maxPrice: '', bedrooms: '', bathrooms: '' 
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [filters, activeTab]);

  const [compareList, setCompareList] = useState([]);
  const [showCompareModal, setShowCompareModal] = useState(false);

  // 5. حساب العقارات المفلترة وتقسيمها لصفحات (Pagination Logic)
  const filteredProjects = useMemo(() => {
    const baseProjects = activeTab === 'mortgage-properties' 
      ? projects.filter(p => p.status === 'تمويل عقاري') 
      : projects;

    return baseProjects
      .filter(p => {
        const matchLoc = !filters.location || p.location?.toLowerCase().includes(filters.location.toLowerCase());
        const matchCat = !filters.category || p.category === filters.category;
        const matchStatus = !filters.status || p.status === filters.status;
        const matchMin = !filters.minPrice || Number(p.price) >= Number(filters.minPrice);
        const matchMax = !filters.maxPrice || Number(p.price) <= Number(filters.maxPrice);
        const matchBed = !filters.bedrooms || Number(p.bedrooms) === Number(filters.bedrooms);
        const matchBath = !filters.bathrooms || Number(p.bathrooms) === Number(filters.bathrooms);
        return matchLoc && matchCat && matchStatus && matchMin && matchMax && matchBed && matchBath;
      })
      .sort((a, b) => {
        const dateA = a.createdAt ? new Date(a.createdAt) : new Date(0);
        const dateB = b.createdAt ? new Date(b.createdAt) : new Date(0);
        return dateB - dateA;
      });
  }, [projects, filters, activeTab]);

  const indexOfLastProject = currentPage * propertiesPerPage;
  const indexOfFirstProject = indexOfLastProject - propertiesPerPage;
  const currentProjects = filteredProjects.slice(indexOfFirstProject, indexOfLastProject);
  const totalPages = Math.ceil(filteredProjects.length / propertiesPerPage);

  const resetFilters = () => setFilters({ location: '', category: '', status: '', minPrice: '', maxPrice: '', bedrooms: '', bathrooms: '' });

  const primaryColor = settings?.primaryColor || '#c0a062';

  const toggleCompare = (e, project) => {
    e.stopPropagation();
    if (compareList.find(p => p.id === project.id)) {
      setCompareList(compareList.filter(p => p.id !== project.id));
    } else {
      if (compareList.length >= 3) {
        alert("يمكنك مقارنة 3 عقارات كحد أقصى");
        return;
      }
      setCompareList([...compareList, project]);
    }
  };

  const [mortgageForm, setMortgageForm] = useState({ 
      name: '', phone: '', salary: '', budget: '', age: '', maritalStatus: 'أعزب', 
      initiativeType: '8%', hasPersonalLoan: 'لا', hasCarLoan: 'لا', otherObligations: 'لا', notes: '' 
  });
  
  const [addUnitForm, setAddUnitForm] = useState({ 
      name: '', location: '', category: 'شقة', price: '', area: '', 
      ownerName: '', ownerPhone: '', description: '', images: [], rawFiles: [] 
  });

  const handleMortgageSubmit = (formData) => { 
    onMortgageRequestSubmit(formData); 
    setMortgageForm({ 
        name: '', phone: '', salary: '', budget: '', age: '', maritalStatus: 'أعزب', initiativeType: '8%', 
        hasPersonalLoan: 'لا', hasCarLoan: 'لا', otherObligations: 'لا', notes: '' 
    }); 
  };

  const handleUnitSubmit = async (e) => {
      e.preventDefault(); 
      const success = await onAddUnitSubmit(addUnitForm); 
      if (success) {
        setAddUnitForm({ 
            name: '', location: '', category: 'شقة', price: '', area: '',
            ownerName: '', ownerPhone: '', description: '', images: [], rawFiles: [] 
        });
      }
  };

  const handleAddUnitImage = (e) => { 
      if (e.target.files) { 
          const newFiles = Array.from(e.target.files);
          const newImageUrls = newFiles.map(file => URL.createObjectURL(file));
          setAddUnitForm(prev => ({ 
              ...prev, 
              images: [...(prev.images || []), ...newImageUrls],
              rawFiles: [...(prev.rawFiles || []), ...newFiles] 
          })); 
      } 
  };

  const removeAddUnitImage = (index) => { 
      setAddUnitForm(prev => ({ 
          ...prev, 
          images: prev.images.filter((_, i) => i !== index),
          rawFiles: prev.rawFiles.filter((_, i) => i !== index) 
      })); 
  };
  
  const navButtons = [
    { id: 'home', label: 'الرئيسية' }, 
    { id: 'all-properties', label: 'عقارات عامة' }, 
    { id: 'mortgage-properties', label: 'شقق تمويل' }, 
    { id: 'mortgage-request', label: 'طلب تمويل' }, 
    { id: 'add-unit', label: 'طلب عرض وحدة' }
  ];
  
  const renderImprovedSections = (repsList) => {
    return (
      <div className="space-y-16 py-10 px-4 md:px-0 text-right" dir="rtl">
        {sections.find(s => s.id === 'about')?.visible && (
          <div className="space-y-12">
            <div className={`relative overflow-hidden rounded-[2.5rem] transition-all duration-500 ${darkMode ? 'bg-gray-800' : 'bg-white shadow-2xl border border-gray-100'}`}>
              <div className="flex flex-col md:flex-row items-center">
                <div className="md:w-2/5 w-full relative h-72 md:h-[400px]">
                  <img src={sections.find(s => s.id === 'about').image} className="w-full h-full object-cover" alt="About" />
                  <div className="absolute inset-0 bg-gradient-to-l from-transparent to-black/30"></div>
                </div>
                <div className="md:w-3/5 w-full p-8 md:p-12 text-right">
                  <div className="inline-block px-4 py-1 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 text-xs font-black mb-4 uppercase tracking-widest">قصة نجاحنا</div>
                  <h2 className="text-3xl md:text-4xl font-black mb-6">{sections.find(s => s.id === 'about').title}</h2>
                  <p className="text-gray-500 dark:text-gray-400 leading-relaxed text-base md:text-lg mb-8">{sections.find(s => s.id === 'about').content}</p>
                  <div className="flex gap-10">
                     <div className="text-right">
                        <span className="block font-black text-3xl text-blue-600">+5</span>
                        <span className="text-[10px] text-gray-400 font-bold uppercase">سنة خبرة</span>
                     </div>
                     <div className="text-right">
                        <span className="block font-black text-3xl text-green-600">+10000</span>
                        <span className="text-[10px] text-gray-400 font-bold uppercase">عميل سعيد</span>
                     </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-10 md:mt-16 animate-fade-in relative overflow-hidden">
              <div className="text-center mb-6 md:mb-12">
                <h3 className="text-xl md:text-3xl font-black mb-2 text-blue-600">عائلة {settings.storeName}</h3>
                <p className="text-gray-500 text-[10px] md:text-base px-4">نخبة من أفضل الخبراء العقاريين في خدمتك</p>
                <div className="h-1 w-12 md:w-20 bg-blue-600 mx-auto mt-3 rounded-full"></div>
              </div>
              
              <div className="relative w-full group px-4">
                <button 
                  type="button"
                  onClick={() => scroll('right')} 
                  className="absolute right-0 top-1/2 -translate-y-1/2 z-[40] p-2 bg-white/90 dark:bg-gray-800 shadow-lg rounded-full text-blue-600 flex md:p-3 border border-gray-100"
                >
                  <ChevronRight size={24} />
                </button>

                <button 
                  type="button"
                  onClick={() => scroll('left')} 
                  className="absolute left-0 top-1/2 -translate-y-1/2 z-[40] p-2 bg-white/90 dark:bg-gray-800 shadow-lg rounded-full text-blue-600 flex md:p-3 border border-gray-100"
                >
                  <ChevronLeft size={24} />
                </button>

                <div 
                  ref={scrollRef}
                  className="hide-scrollbar"
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    WebkitOverflowScrolling: 'touch',
                    scrollSnapType: 'x mandatory',
                    padding: '10px 20px 40px 20px',
                    gap: '15px',
                    scrollBehavior: 'smooth'
                  }}
                >
                  {repsList && repsList
                    .filter(r => r.status === 'نشط' && r.showInPortfolio !== false)
                    .map((member, idx) => (
                    <div 
                      key={member.id || idx} 
                      style={{
                        flex: '0 0 auto',
                        width: '80%',
                        minWidth: '260px', 
                        maxWidth: '320px',
                        scrollSnapAlign: 'center',
                        height: 'auto'
                      }}
                    >
                      <div className={`relative text-center flex flex-col items-center p-6 rounded-[2rem] border transition-all duration-500 h-full
                        ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100 shadow-lg'}`}
                        style={{ boxShadow: darkMode ? 'none' : '0 10px 25px -5px rgba(0, 0, 0, 0.1)' }}
                      >
                        {member.isMonthHero && (
                          <div className="absolute -top-3 z-20 bg-gradient-to-r from-yellow-400 to-orange-500 text-white text-[8px] font-black px-4 py-1.5 rounded-full border-2 border-white shadow-md">
                            Hero 🏆
                          </div>
                        )}
                        <div className="relative w-20 h-20 mb-4 overflow-hidden rounded-full ring-4 ring-blue-50 dark:ring-blue-900 shadow-md">
                          <img src={member.img || `https://ui-avatars.com/api/?name=${encodeURIComponent(member.name)}&background=random&size=128`} className="w-full h-full object-cover" alt={member.name} loading="lazy" />
                        </div>
                        <span style={{ color: settings.primaryColor }} className="text-[9px] font-black uppercase tracking-widest mb-1 opacity-90">{member.callName || 'Property Consultant'}</span>
                        <h4 className={`font-black text-lg mb-1 truncate w-full ${darkMode ? 'text-white' : 'text-gray-900'}`}>{member.name}</h4>
                        <div className="inline-block px-3 py-1 rounded-full bg-gray-100 dark:bg-gray-700 mb-3 border border-gray-200 dark:border-gray-600">
                          <span className="text-[10px] font-bold text-blue-600">{member.role}</span>
                        </div>
                        <div className="flex items-center justify-center gap-0.5 mb-5 bg-gray-50 dark:bg-gray-900/50 px-3 py-1.5 rounded-xl">
                           {[...Array(5)].map((_, i) => (
                             <Star key={i} size={12} className={`${i < (member.rating || 5) ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300 dark:text-gray-600'}`} />
                           ))}
                           <span className="text-[10px] font-bold text-gray-500 mr-1">{member.rating || 5}.0</span>
                        </div>
                        <button type="button" onClick={(e) => { e.stopPropagation(); const rawValue = member.whatsappLink ? String(member.whatsappLink).trim() : ''; const finalLink = rawValue.startsWith('http') ? rawValue : `https://wa.me/20${rawValue.startsWith('0') ? rawValue.substring(1) : rawValue}`; window.open(finalLink, '_blank'); }} className="mt-auto w-full py-3.5 bg-green-500 text-white rounded-2xl shadow-md active:scale-95 transition-all flex items-center justify-center gap-2 font-bold text-sm">
                          <MessageCircle size={18} /> تواصل الآن
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-16">
          {sections.filter(s => s.id !== 'about' && s.visible).map((section) => (
            <div key={section.id} className={`group p-8 rounded-[2rem] border transition-all duration-500 ${darkMode ? 'bg-gray-800 border-gray-700 hover:border-blue-500/50' : 'bg-white border-gray-100 shadow-xl hover:shadow-2xl'}`}>
               <div className="flex items-center justify-between mb-8">
                  <div className="flex items-center gap-4">
                    <div className="p-4 rounded-2xl bg-gradient-to-br from-blue-500 to-blue-700 text-white shadow-lg">
                      {section.id === 'works' ? <Briefcase size={24}/> : <Palette size={24}/>}
                    </div>
                    <h3 className="font-black text-2xl">{section.title}</h3>
                  </div>
               </div>
               <div className="grid grid-cols-1 gap-4">
                  {section.items && section.items.slice(0, 3).map((item, i) => (
                    <div key={i} className="flex items-center gap-5 p-4 rounded-2xl bg-gray-50/50 dark:bg-gray-900/30 hover:bg-blue-50 transition-all cursor-pointer group/item">
                      <div className="w-20 h-20 rounded-xl overflow-hidden flex-shrink-0 shadow-md">
                        <img src={item.img} className="w-full h-full object-cover transform group-hover/item:scale-110 transition-transform duration-500" alt={item.title} />
                      </div>
                      <div className="text-right">
                        <h4 className="font-bold text-base mb-1 group-hover/item:text-blue-600">{item.title}</h4>
                        <p className="text-xs text-gray-500 dark:text-gray-400 line-clamp-2 leading-relaxed">{item.desc}</p>
                      </div>
                    </div>
                  ))}
               </div>
               <button onClick={() => window.dispatchEvent(new CustomEvent('changeTab', { detail: 'all-properties' }))} className="w-full mt-8 py-3 rounded-xl border-2 border-dashed border-gray-200 dark:border-gray-700 text-sm font-bold text-gray-400 hover:text-blue-600 hover:border-blue-600 hover:bg-blue-50/30 transition-all">
                 اكتشف كافة التفاصيل
               </button>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderHeroSection = () => (
    <div className="relative h-[650px] flex items-center justify-center text-center px-4 overflow-hidden">
      {settings?.heroVideo ? ( 
        <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover z-0"> 
          <source src={settings.heroVideo} type="video/mp4" /> 
        </video> 
      ) : ( 
        <div className="absolute inset-0 w-full h-full bg-cover bg-center z-0" style={{ backgroundImage: `url(${settings?.heroImage})`, backgroundAttachment: 'fixed' }} ></div> 
      )}
      <div className="absolute inset-0 bg-black z-0 transition-opacity duration-300" style={{ opacity: settings?.heroOverlayOpacity || 0.6 }}></div>
      <div className="relative z-10 max-w-5xl mx-auto animate-fade-in-up w-full">
            <h2 style={{ color: primaryColor }} className="text-xl md:text-2xl font-bold mb-4 tracking-wide uppercase">{settings?.storeName}</h2>
            <h1 className="text-3xl md:text-6xl font-extrabold text-white mb-8 leading-tight drop-shadow-lg">{settings?.heroTitle}</h1>
            <div className="flex flex-wrap justify-center gap-3 mb-8"> 
             {navButtons.map(btn => ( 
               <button key={btn.id} onClick={() => window.dispatchEvent(new CustomEvent('changeTab', { detail: btn.id }))} className={`px-4 md:px-6 py-2 md:py-3 rounded-full font-bold text-xs md:text-sm transition-all duration-300 transform hover:-translate-y-1 ${ activeTab === btn.id ? 'bg-blue-600 text-white shadow-lg shadow-blue-600/40 ring-2 ring-white/20' : 'bg-white/10 text-white backdrop-blur-md hover:bg-white/20' }`} > {btn.label} </button> 
             ))} 
            </div>
      </div>
    </div>
  );

  const renderPagination = () => {
    if (totalPages <= 1) return null;
    return (
      <div className="flex justify-center items-center gap-2 mt-12 mb-8" dir="ltr">
        <button 
          type="button"
          disabled={currentPage === 1}
          onClick={() => {
            setCurrentPage(prev => prev - 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className="p-2 rounded-lg border bg-white dark:bg-gray-800 disabled:opacity-30 text-gray-600 dark:text-gray-300 shadow-sm"
        >
          <ChevronLeft size={20} />
        </button>
        
        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i + 1}
            type="button"
            onClick={() => {
              setCurrentPage(i + 1);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className={`w-10 h-10 rounded-lg font-bold transition-all ${
              currentPage === i + 1 
              ? 'bg-blue-600 text-white shadow-lg' 
              : 'bg-white dark:bg-gray-800 border text-gray-600 dark:text-gray-400'
            }`}
          >
            {i + 1}
          </button>
        ))}

        <button 
          type="button"
          disabled={currentPage === totalPages}
          onClick={() => {
            setCurrentPage(prev => prev + 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className="p-2 rounded-lg border bg-white dark:bg-gray-800 disabled:opacity-30 text-gray-600 dark:text-gray-300 shadow-sm"
        >
          <ChevronRight size={20} />
        </button>
      </div>
    );
  };

  return (
    <div className={`min-h-screen flex flex-col font-sans ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-50 text-gray-900'}`}>
      {/* عرض الـ Hero Section فقط في تبويب الرئيسية */}
      {activeTab === 'home' && renderHeroSection()}
      
      <div className="max-w-7xl mx-auto w-full flex flex-col lg:flex-row gap-8 p-6 md:p-12">
        
        {/* 🟢 القائمة الجانبية للفلترة */}
        {(activeTab === 'all-properties' || activeTab === 'mortgage-properties') && (
          <aside className={`lg:w-72 w-full h-fit sticky top-24 p-6 rounded-2xl shadow-sm border transition-all duration-300 
            ${darkMode ? 'bg-gray-800 border-gray-700 text-white' : 'bg-white border-gray-100 text-gray-900'}`}>
            <div className="flex justify-between items-center mb-6">
              <h3 className={`font-bold text-lg flex items-center gap-2 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`}>
                <Search className="w-5 h-5" /> بحث متقدم
              </h3>
              <button onClick={resetFilters} className="text-xs text-red-500 font-bold hover:underline">مسح الكل</button>
            </div>

            <div className="space-y-5">
              <div>
                <label className={`text-xs font-bold block mb-2 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>المنطقة</label>
                <input 
                  type="text" 
                  placeholder="ابحث بالمنطقة..." 
                  className={`w-full p-2.5 rounded-lg border text-sm outline-none focus:ring-2 focus:ring-blue-500 transition-all
                    ${darkMode ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' : 'bg-gray-50 border-gray-200 text-gray-900 placeholder-gray-500'}`} 
                  value={filters.location} 
                  onChange={e => setFilters({...filters, location: e.target.value})} 
                />
              </div>

              <div className="grid grid-cols-2 gap-2">
                <div>
                  <label className={`text-[10px] font-bold block mb-1 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>النوع</label>
                  <select 
                    className={`w-full p-2 rounded-lg border text-xs outline-none transition-all
                      ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-gray-50 border-gray-200 text-gray-900'}`} 
                    value={filters.category} 
                    onChange={e => setFilters({...filters, category: e.target.value})}
                  >
                    <option value="">الكل</option>
                    <option value="شقة">شقة</option>
                    <option value="فيلا">فيلا</option>
                    <option value="تجاري">تجاري</option>
                    <option value="أرض">أرض</option>
                  </select>
                </div>
                <div>
                  <label className={`text-[10px] font-bold block mb-1 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>الحالة</label>
                  <select 
                    className={`w-full p-2 rounded-lg border text-xs outline-none transition-all
                      ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-gray-50 border-gray-200 text-gray-900'}`} 
                    value={filters.status} 
                    onChange={e => setFilters({...filters, status: e.target.value})}
                  >
                    <option value="">الكل</option>
                    <option value="كاش">كاش</option>
                    <option value="تمويل عقاري">تمويل عقاري</option>
                    <option value="تقسيط">تقسيط</option>
                  </select>
                </div>
              </div>

              <div>
                <label className={`text-xs font-bold block mb-2 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>نطاق السعر (ج.م)</label>
                <div className="flex gap-2">
                  <input 
                    type="number" 
                    placeholder="من" 
                    className={`w-1/2 p-2 rounded-lg border text-xs outline-none transition-all
                      ${darkMode ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' : 'bg-gray-50 border-gray-200 text-gray-900 placeholder-gray-500'}`} 
                    onChange={e => setFilters({...filters, minPrice: e.target.value})} 
                  />
                  <input 
                    type="number" 
                    placeholder="إلى" 
                    className={`w-1/2 p-2 rounded-lg border text-xs outline-none transition-all
                      ${darkMode ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' : 'bg-gray-50 border-gray-200 text-gray-900 placeholder-gray-500'}`} 
                    onChange={e => setFilters({...filters, maxPrice: e.target.value})} 
                  />
                </div>
              </div>

              <div>
                <label className={`text-xs font-bold block mb-2 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>عدد الغرف</label>
                <div className="flex flex-wrap gap-2">
                  {['1', '2', '3', '4', '5+'].map(num => (
                    <button 
                      key={num} 
                      onClick={() => setFilters({...filters, bedrooms: num.includes('+') ? '5' : num})} 
                      className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all duration-300
                        ${filters.bedrooms === (num.includes('+') ? '5' : num) 
                          ? 'bg-blue-600 text-white shadow-lg' 
                          : darkMode ? 'bg-gray-700 text-gray-300 hover:bg-gray-600' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'}`}
                    >
                      {num}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </aside>
        )}

        {/* 🟢 منطقة عرض المحتوى الرئيسي */}
        <main className="flex-1">
          {activeTab === 'home' && (
            <>
              <div className="mb-10 text-center"><h3 className="text-3xl font-bold mb-3 text-blue-600">أحدث العروض المختارة</h3><div className="h-1 w-20 mx-auto rounded-full bg-blue-600"></div></div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8"> 
                 {currentProjects.map(p => (
                      <div key={p.id} onClick={() => setSelectedProject(p)} className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-lg cursor-pointer hover:-translate-y-2 transition-all border border-gray-100 dark:border-gray-700 group relative">
                          <div className="relative h-48 overflow-hidden">
                              <div className="absolute top-4 left-4 z-20 flex gap-2">
                                <button onClick={(e) => toggleCompare(e, p)} className={`p-2 rounded-full shadow-lg transition-all ${compareList.find(i => i.id === p.id) ? 'bg-orange-500 text-white' : 'bg-white/80 text-gray-600 hover:bg-orange-500 hover:text-white'}`}><Scale className="w-4 h-4" /></button>
                                <button onClick={(e) => toggleFavorite(e, p.id)} className="p-2 rounded-full shadow-lg transition-all bg-white hover:bg-gray-100 text-yellow-500"><Star className={`w-4 h-4 ${clientFavorites.includes(p.id) ? 'fill-current' : ''}`} /></button>
                              </div>
                              <ImageSlider images={p.images} videoUrl={p.videoUrl} heightClass="h-48" />
                          </div>
                          <div className="p-4">
                              <div className="flex justify-between items-start"><h4 className="font-bold text-lg line-clamp-1">{p.name}</h4><span className="text-[10px] font-bold px-2 py-1 rounded bg-blue-100 text-blue-800">{p.status}</span></div>
                              <p className="text-gray-500 text-xs mt-1">{p.location}</p>
                              <div className="mt-3 font-bold text-blue-600">{p.price?.toLocaleString() || '0'} ج.م</div>
                          </div>
                      </div>
                  ))}
              </div>
              {renderPagination()}
              {renderImprovedSections(reps)}
            </>
          )}

          {(activeTab === 'all-properties' || activeTab === 'mortgage-properties') && (
            <div className="animate-fade-in">
              <div className="mb-8 text-center md:text-right">
                <h3 className={`text-2xl font-bold mb-3 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                  {activeTab === 'mortgage-properties' ? 'شقق تصلح للتمويل العقاري' : 'نتائج البحث عن العقارات'}
                </h3>
                <p className={`${darkMode ? 'text-gray-400' : 'text-gray-500'} font-bold`}>
                  تم العثور على ({filteredProjects.length}) وحدة متاحة
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {currentProjects.length > 0 ? (
                  currentProjects.map((project) => (
                    <div
                      key={project.id}
                      onClick={() => setSelectedProject(project)}
                      className={`group cursor-pointer rounded-xl overflow-hidden shadow-lg border transition-all duration-300 ${
                        darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'
                      }`}
                    >
                      <div className="relative h-64 overflow-hidden bg-gray-200 dark:bg-gray-700">
                        {/* أزرار التحكم السريعة */}
                        <div className="absolute top-4 left-4 z-20 flex flex-col gap-2">
                            <button onClick={(e) => toggleCompare(e, project)} className={`p-2 rounded-full shadow-lg transition-all ${compareList.find((i) => i.id === project.id) ? 'bg-orange-500 text-white' : 'bg-white/80 text-gray-600 hover:bg-orange-500 hover:text-white'}`}><Scale size={18} /></button>
                        </div>
                        <div className="absolute top-4 right-4 z-20 flex flex-col gap-2">
                            <button onClick={(e) => { e.stopPropagation(); const text = `🏠 عقار جديد من HOMIX :\n*${project.name}*\n📍 ${project.location}\n💰 ${project.price.toLocaleString()} ج.م`; window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank'); }} className="p-2 rounded-full bg-white/90 text-green-600 shadow-lg"><Share2 size={18} /></button>
                            <button onClick={(e) => toggleFavorite(e, project.id)} className="p-2 rounded-full bg-white/90 shadow-lg text-yellow-500"><Star className={`w-[18px] h-[18px] ${clientFavorites.includes(project.id) ? 'fill-current' : ''}`} /></button>
                        </div>

                        <ImageSlider images={project.images} videoUrl={project.videoUrl} heightClass="h-64" />
                        <div className="absolute bottom-0 left-0 bg-black/70 text-white px-4 py-2 rounded-tr-xl font-bold z-10">
                          {project.price?.toLocaleString() || '0'} ج.م
                        </div>
                      </div>

                      <div className="p-5 text-right">
                        <h3 className={`font-bold text-lg mb-2 truncate group-hover:text-blue-500 transition-colors ${darkMode ? 'text-white' : 'text-gray-800'}`}>
                          {project.name}
                        </h3>
                        <p className={`text-sm mb-4 flex items-center gap-1 justify-end ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                          {project.location} <MapPin className="w-4 h-4" />
                        </p>
                        
                        <div className={`flex justify-between items-center py-3 border-t border-b text-xs mb-4 ${darkMode ? 'border-gray-700 text-gray-300' : 'border-gray-100 text-gray-600'}`}>
                          <span>{project.bedrooms} غرف</span>
                          <span>{project.bathrooms} حمام</span>
                          <span>{project.area} م²</span>
                        </div>

                        <button className={`w-full py-2.5 border rounded-lg text-sm font-bold transition-all ${darkMode ? 'border-gray-600 text-gray-300 hover:bg-gray-700' : 'border-gray-300 text-gray-600 hover:bg-gray-50'}`}>
                          عرض كامل التفاصيل
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className={`col-span-full text-center py-20 rounded-xl border-2 border-dashed ${darkMode ? 'bg-gray-800 border-gray-700 text-gray-400' : 'bg-gray-100 border-gray-300 text-gray-500'}`}>
                    <p className="text-xl">لا توجد عقارات مطابقة حالياً.</p>
                    <button onClick={resetFilters} className="mt-4 text-blue-600 font-bold underline">عرض كل العقارات</button>
                  </div>
                )}
              </div>
              {renderPagination()}
            </div>
          )}

          {activeTab === 'mortgage-request' && ( 
              <MortgageRequestForm darkMode={darkMode} mortgageForm={mortgageForm} setMortgageForm={setMortgageForm} onSubmit={handleMortgageSubmit} />
          )}
          
          {activeTab === 'add-unit' && ( 
            <div className="max-w-3xl mx-auto p-4 w-full animate-fade-in pt-10"> 
              <div className={`p-6 md:p-8 rounded-2xl shadow-xl border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-transparent'}`}> 
                <h3 className="text-2xl font-bold mb-2 text-center flex items-center justify-center gap-2"><Plus className="w-8 h-8 text-blue-500" /> أضف عقارك معنا</h3> 
                <form onSubmit={handleUnitSubmit} className="space-y-5 mt-6 text-right"> 
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5"> 
                    <div><label className="block text-sm font-bold mb-2">اسم العقار</label><input required className={`w-full p-3 border rounded-lg outline-none ${darkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50'}`} value={addUnitForm.name} onChange={e => setAddUnitForm({...addUnitForm, name: e.target.value})} /></div> 
                    <div><label className="block text-sm font-bold mb-2">المنطقة</label><input required className={`w-full p-3 border rounded-lg outline-none ${darkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50'}`} value={addUnitForm.location} onChange={e => setAddUnitForm({...addUnitForm, location: e.target.value})} /></div> 
                  </div> 
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-5"> 
                    <div><label className="block text-sm font-bold mb-2">السعر</label><input required type="number" className={`w-full p-3 border rounded-lg outline-none ${darkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50'}`} value={addUnitForm.price} onChange={e => setAddUnitForm({...addUnitForm, price: Number(e.target.value)})} /></div> 
                    <div><label className="block text-sm font-bold mb-2">المساحة</label><input required type="number" className={`w-full p-3 border rounded-lg outline-none ${darkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50'}`} value={addUnitForm.area} onChange={e => setAddUnitForm({...addUnitForm, area: Number(e.target.value)})} /></div> 
                    <div><label className="block text-sm font-bold mb-2">النوع</label><select className={`w-full p-3 border rounded-lg outline-none ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-gray-50'}`} value={addUnitForm.category} onChange={e => setAddUnitForm({...addUnitForm, category: e.target.value})}><option value="شقة">شقة</option><option value="فيلا">فيلا</option></select></div> 
                  </div> 
                  <div><label className="block text-sm font-bold mb-2">اسم المالك</label><input required className={`w-full p-3 border rounded-lg outline-none ${darkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50'}`} value={addUnitForm.ownerName} onChange={e => setAddUnitForm({...addUnitForm, ownerName: e.target.value})} /></div> 
                  <div><label className="block text-sm font-bold mb-2">رقم التواصل</label><input required type="tel" className={`w-full p-3 border rounded-lg outline-none ${darkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50'}`} value={addUnitForm.ownerPhone} onChange={e => setAddUnitForm({...addUnitForm, ownerPhone: e.target.value})} /></div> 
                  <div><label className="block text-sm font-bold mb-2">وصف العقار</label><textarea className={`w-full p-3 border rounded-lg h-24 ${darkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50'}`} value={addUnitForm.description} onChange={e => setAddUnitForm({...addUnitForm, description: e.target.value})} /></div> 
                  <div className="space-y-2">
                    <label className="block text-sm font-bold">صور العقار</label>
                    <div className="p-6 border-2 border-dashed rounded-lg text-center cursor-pointer hover:bg-gray-50">
                        <label className="cursor-pointer flex flex-col items-center">
                            <Camera className="w-8 h-8 mb-2 text-blue-500" />
                            <span className="text-blue-500 font-bold">اضغط لرفع الصور</span>
                            <input type="file" multiple accept="image/*" onChange={handleAddUnitImage} className="hidden" />
                        </label>
                    </div>
                  </div>
                  <button type="submit" className="w-full py-4 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 shadow-lg">إرسال للمراجعة</button> 
                </form> 
              </div> 
            </div> 
          )}

          {activeTab === 'profile' && user && (
            <ClientProfile user={user} projects={projects} favorites={clientFavorites} pendingUnits={pendingUnits} mortgageRequests={mortgageRequests} onRemoveFavorite={(id) => toggleFavorite(null, id)} onLogout={settings.onLogout} />
          )}
        </main>
      </div>
{compareList.length > 0 && (
            <div className="fixed bottom-24 right-6 z-[60] animate-bounce">
              <button 
                onClick={() => setShowCompareModal(true)}
                className="bg-orange-500 text-white px-6 py-3 rounded-full shadow-2xl font-bold flex items-center gap-2 hover:bg-orange-600 transition-all"
              >
                <Scale size={20} />
                مقارنة ({compareList.length}) وحدات
              </button>
            </div>
          )}

          {showCompareModal && (
            <ComparisonModal 
              selectedUnits={compareList} 
              onClose={() => setShowCompareModal(false)} 
              darkMode={darkMode} 
            />
          )}
      {/* نافذة تفاصيل العقار */}
      {selectedProject && (
        <div className="fixed inset-0 bg-black/95 z-[60] flex items-center justify-center p-4 animate-fade-in">
          <div className={`w-full max-w-5xl bg-white rounded-2xl flex flex-col md:flex-row relative overflow-hidden h-[90vh] ${darkMode ? 'bg-gray-800 text-white' : ''}`}>
            <button onClick={() => setSelectedProject(null)} className="absolute top-4 left-4 z-50 bg-black/50 hover:bg-black/80 text-white p-2 rounded-full transition-colors"><X className="w-6 h-6" /></button>
            <div className="md:w-1/2 h-64 md:h-auto bg-black flex items-center justify-center relative"><ImageSlider images={selectedProject.images} videoUrl={selectedProject.videoUrl} heightClass="h-full w-full" /></div>
            <div className="md:w-1/2 p-8 overflow-y-auto text-right custom-scrollbar" dir="rtl">
              <h2 className="text-2xl font-bold mb-2">{selectedProject.name}</h2>
              <p className="text-blue-600 font-black text-2xl mb-6">{selectedProject.price?.toLocaleString()} ج.م</p>
              <div className="space-y-4 mb-8 text-sm text-gray-600 dark:text-gray-300">
                  <p><strong>الموقع:</strong> {selectedProject.location}</p>
                  <p><strong>المساحة:</strong> {selectedProject.area} م²</p>
                  <p><strong>التفاصيل:</strong> {selectedProject.description}</p>
              </div>
              <ScheduleVisitForm project={selectedProject} user={user} onSubmit={settings?.onScheduleSubmit} />
              <div className="grid grid-cols-2 gap-4 mt-8 pb-4">
                <button onClick={() => window.open(selectedProject.whatsappLink, '_blank')} className="py-3 bg-green-600 text-white rounded-lg font-bold flex justify-center items-center gap-2"><MessageCircle size={20} /> واتساب</button>
                <button onClick={() => window.open(`tel:${selectedProject.mobile}`, '_self')} className="py-3 bg-gray-900 text-white rounded-lg font-bold flex justify-center items-center gap-2"><Phone size={20} /> اتصال</button>
              </div>
              {user && hasPermission(user, PERMISSIONS.PUBLISH_FACEBOOK) && (
                <button onClick={() => onPostToFacebook(selectedProject)} className="w-full py-3 mt-2 bg-[#1877F2] text-white rounded-lg font-bold flex justify-center items-center gap-2 shadow-lg"><Facebook size={20} /> نشر فيسبوك (إدارة)</button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
// --- مكون التحليل المالي المحترف للفروع ---
const BranchFinancialPro = ({ transactions, sales, darkMode }) => {
  const branches = ['المعادي', 'المهندسين', 'التجمع'];

  const branchAnalysis = useMemo(() => {
    return branches.map(branch => {
      const branchTrans = transactions.filter(t => t.branch === branch);
      const branchSales = sales.filter(s => s.branch === branch);

      const income = branchTrans.filter(t => t.type === 'income').reduce((sum, t) => sum + (Number(t.amount) || 0), 0);
      const expenses = branchTrans.filter(t => t.type === 'expense').reduce((sum, t) => sum + (Number(t.amount) || 0), 0);
      const totalSalesValue = branchSales.reduce((sum, s) => sum + (Number(s.amount) || 0), 0);
      
      const netProfit = income - expenses;
      // مؤشر الربحية (ROI): كم قرش ربح مقابل كل جنيه مصروف
      const roi = expenses > 0 ? ((netProfit / expenses) * 100).toFixed(1) : 0;
      // نسبة المصاريف من إجمالي الدخل
      const expenseRatio = income > 0 ? ((expenses / income) * 100).toFixed(1) : 0;

      return { branch, income, expenses, netProfit, totalSalesValue, roi, expenseRatio, dealsCount: branchSales.length };
    });
  }, [transactions, sales]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 animate-fade-in">
      {branchAnalysis.map((data) => (
        <div key={data.branch} className={`p-6 rounded-[2rem] border transition-all hover:shadow-xl ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100 shadow-sm'}`}>
          <div className="flex justify-between items-start mb-6">
            <div>
              <h4 className="text-xl font-black text-blue-600 mb-1">فرع {data.branch}</h4>
              <span className="text-[10px] text-gray-400 font-bold uppercase tracking-tighter">تقرير الكفاءة المالية</span>
            </div>
            <div className={`p-2 rounded-xl ${data.netProfit >= 0 ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
              <Landmark size={20} />
            </div>
          </div>

          <div className="space-y-4">
            {/* الدخل والمصاريف */}
            <div className="flex justify-between items-end border-b border-dashed pb-3 dark:border-gray-700">
              <div className="text-right">
                <p className="text-[10px] text-gray-500 font-bold mb-1">إجمالي الوارد</p>
                <p className="text-lg font-black text-green-500">{data.income.toLocaleString()}</p>
              </div>
              <div className="text-left">
                <p className="text-[10px] text-gray-500 font-bold mb-1">إجمالي المنصرف</p>
                <p className="text-lg font-black text-red-500">{data.expenses.toLocaleString()}</p>
              </div>
            </div>

            {/* الأرباح والنسب */}
            <div className="grid grid-cols-2 gap-4 pt-2">
              <div className={`p-3 rounded-2xl ${darkMode ? 'bg-gray-700/50' : 'bg-gray-50'}`}>
                <p className="text-[9px] text-gray-400 font-bold mb-1">عائد الاستثمار ROI</p>
                <p className={`text-sm font-black ${data.roi > 0 ? 'text-blue-500' : 'text-orange-500'}`}>{data.roi}%</p>
              </div>
              <div className={`p-3 rounded-2xl ${darkMode ? 'bg-gray-700/50' : 'bg-gray-50'}`}>
                <p className="text-[9px] text-gray-400 font-bold mb-1">نسبة التكلفة</p>
                <p className="text-sm font-black text-purple-500">{data.expenseRatio}%</p>
              </div>
            </div>

            {/* شريط التقدم للربحية */}
            <div className="pt-2">
              <div className="flex justify-between text-[10px] font-bold mb-1">
                <span>صافي الربح الفعلي</span>
                <span className={data.netProfit >= 0 ? 'text-green-500' : 'text-red-500'}>{data.netProfit.toLocaleString()} ج.م</span>
              </div>
              <div className="w-full h-1.5 bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden">
                <div 
                  className={`h-full transition-all duration-1000 ${data.netProfit >= 0 ? 'bg-green-500' : 'bg-red-500'}`} 
                  style={{ width: `${Math.min(Math.abs(data.roi), 100)}%` }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
const DetailedTeamAnalytics = ({ transactions, sales, reps, darkMode }) => {
    // 1. حساب وتحليل بيانات كل مندوب
    const repStats = useMemo(() => {
        return reps.map(rep => {
            const repIdStr = String(rep.id);
            
            // حساب إجمالي مبيعات المندوب
            const totalSales = sales
                .filter(s => String(s.repId) === repIdStr)
                .reduce((sum, s) => sum + (Number(s.amount) || 0), 0);
            
            // حساب عدد الصفقات
            const dealsCount = sales.filter(s => String(s.repId) === repIdStr).length;

            // حساب إجمالي مصاريف المندوب (انتقالات، عينات، الخ) من الخزينة
            const totalExpenses = transactions
                .filter(t => String(t.repId) === repIdStr && t.type === 'expense')
                .reduce((sum, t) => sum + (Number(t.amount) || 0), 0);

            // صافي الربح للمكتب من هذا المندوب (المبيعات - المصاريف)
            const netProfit = totalSales - totalExpenses;

            return {
                id: rep.id,
                name: rep.name,
                role: rep.role,
                sales: totalSales,
                expenses: totalExpenses,
                netProfit: netProfit,
                deals: dealsCount,
                // نسبة المصاريف للمبيعات
                efficiency: totalSales > 0 ? (totalExpenses / totalSales) * 100 : 100
            };
        });
    }, [reps, sales, transactions]);

    // 2. ترتيب أفضل 5 مناديب (بناءً على إجمالي المبيعات)
    const top5Reps = [...repStats]
        .sort((a, b) => b.sales - a.sales)
        .slice(0, 5);

    // 3. تحليل المجموعات (حسب الوظيفة/القسم)
    const groupStats = useMemo(() => {
        const groups = {};
        repStats.forEach(rep => {
            if (!groups[rep.role]) {
                groups[rep.role] = { name: rep.role, totalSales: 0, totalExpenses: 0, members: 0 };
            }
            groups[rep.role].totalSales += rep.sales;
            groups[rep.role].totalExpenses += rep.expenses;
            groups[rep.role].members += 1;
        });
        return Object.values(groups).sort((a, b) => b.totalSales - a.totalSales);
    }, [repStats]);

    const bestRep = top5Reps[0];

    return (
        <div className="space-y-8 animate-fade-in">
            {/* كارت بطل الشهر */}
            {bestRep && bestRep.sales > 0 && (
                <div className="bg-gradient-to-r from-yellow-500 to-orange-600 rounded-3xl p-1 shadow-xl">
                    <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-[1.4rem] p-6 flex flex-col md:flex-row items-center justify-between gap-6`}>
                        <div className="flex items-center gap-6">
                            <div className="relative">
                                <div className="w-24 h-24 bg-yellow-100 rounded-full flex items-center justify-center text-yellow-600">
                                    <Star size={48} className="fill-current" />
                                </div>
                                <span className="absolute -bottom-2 -right-2 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">#1</span>
                            </div>
                            <div>
                                <h3 className="text-sm font-bold text-gray-400 uppercase tracking-widest">أفضل مندوب مبيعات</h3>
                                <p className="text-3xl font-black">{bestRep.name}</p>
                                <p className="text-green-500 font-bold">بإجمالي مبيعات: {bestRep.sales.toLocaleString()} ج.م</p>
                            </div>
                        </div>
                        <div className="text-center md:text-left">
                            <div className="text-xs text-gray-400 font-bold mb-1">نسبة الكفاءة المادية</div>
                            <div className="text-2xl font-black text-blue-600">{(100 - bestRep.efficiency).toFixed(1)}%</div>
                        </div>
                    </div>
                </div>
            )}

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* قائمة التوب 5 */}
                <div className={`p-6 rounded-2xl border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100 shadow-sm'}`}>
                    <h4 className="font-bold text-lg mb-6 flex items-center gap-2">
                        <TrendingUp className="text-green-500" /> قائمة أفضل 5 مناديب
                    </h4>
                    <div className="space-y-4">
                        {top5Reps.map((rep, index) => (
                            <div key={rep.id} className="flex items-center justify-between p-3 rounded-xl bg-gray-50 dark:bg-gray-700/50 transition-hover hover:scale-[1.01]">
                                <div className="flex items-center gap-4">
                                    <span className={`w-8 h-8 rounded-lg flex items-center justify-center font-bold ${index === 0 ? 'bg-yellow-400 text-white' : 'bg-gray-200 dark:bg-gray-600'}`}>{index + 1}</span>
                                    <div>
                                        <p className="font-bold text-sm">{rep.name}</p>
                                        <p className="text-[10px] text-gray-400">{rep.deals} صفقات ناجحة</p>
                                    </div>
                                </div>
                                <div className="text-left font-mono font-bold text-blue-600">
                                    {rep.sales.toLocaleString()}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* مقارنة المجموعات */}
                <div className={`p-6 rounded-2xl border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100 shadow-sm'}`}>
                    <h4 className="font-bold text-lg mb-6 flex items-center gap-2">
                        <Users className="text-blue-500" /> تحليل أداء المجموعات
                    </h4>
                    <div className="space-y-6">
                        {groupStats.map(group => (
                            <div key={group.name} className="space-y-2">
                                <div className="flex justify-between text-sm font-bold">
                                    <span>قسم {group.name} <span className="text-[10px] text-gray-400">({group.members} أفراد)</span></span>
                                    <span className="text-blue-600">{group.totalSales.toLocaleString()} ج.م</span>
                                </div>
                                <div className="w-full h-3 bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden">
                                    <div 
                                        className="h-full bg-blue-600 rounded-full" 
                                        style={{ width: `${(group.totalSales / (groupStats[0].totalSales || 1)) * 100}%` }}
                                    ></div>
                                </div>
                                <div className="flex justify-between text-[10px] text-gray-500 font-bold">
                                    <span>إجمالي المصاريف: {group.totalExpenses.toLocaleString()}</span>
                                    <span>صافي الربح: {(group.totalSales - group.totalExpenses).toLocaleString()}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* جدول تفصيلي شامل */}
            <div className={`rounded-2xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100 shadow-sm'}`}>
                <div className="p-4 bg-gray-50 dark:bg-gray-700/50 border-b dark:border-gray-600 font-bold text-sm">التفاصيل المالية للمناديب (ROI Analysis)</div>
                <div className="overflow-x-auto">
                    <table className="w-full text-right text-xs md:text-sm">
                        <thead className="text-gray-400">
                            <tr>
                                <th className="p-4">المندوب</th>
                                <th className="p-4">المبيعات</th>
                                <th className="p-4">المصاريف</th>
                                <th className="p-4">صافي الربح</th>
                                <th className="p-4">العائد %</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y dark:divide-gray-700">
                            {repStats.sort((a,b) => b.netProfit - a.netProfit).map(rep => (
                                <tr key={rep.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors">
                                    <td className="p-4 font-bold">{rep.name}</td>
                                    <td className="p-4 text-green-600 font-mono font-bold">{rep.sales.toLocaleString()}</td>
                                    <td className="p-4 text-red-500 font-mono">{rep.expenses.toLocaleString()}</td>
                                    <td className={`p-4 font-bold ${rep.netProfit >= 0 ? 'text-blue-600' : 'text-red-600'}`}>
                                        {rep.netProfit.toLocaleString()}
                                    </td>
                                    <td className="p-4">
                                        <span className={`px-2 py-1 rounded text-[10px] font-black ${rep.efficiency < 10 ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700'}`}>
                                            {rep.efficiency.toFixed(1)}%
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
const INITIAL_SECTIONS = [
  { 
    id: 'about', 
    title: 'من نحن', 
    subtitle: 'شريكك العقاري الأول', 
    content: 'نحن شركة HOMIX Real Estate، نسعى لتقديم أفضل الحلول العقارية المتكاملة. خبرتنا تمتد لسنوات في السوق المصري.', 
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80', 
    visible: true,
    items: []
  },
  { 
    id: 'works', 
    title: 'آخر أعمالنا', 
    subtitle: 'إنجازات تتحدث عن نفسها', 
    content: 'تصفح سابقة أعمالنا التي نعتز بها والتي تعكس ثقة عملائنا.', 
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80', 
    visible: true,
    items: [
      { title: 'كمبوند الياسمين', desc: 'تم تسويق المشروع بالكامل', img: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800' },
      { title: 'مول العاصمة', desc: 'وحدات تجارية وإدارية', img: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800' }
    ]
  },
  { 
    id: 'finishing', 
    title: 'خدمات التشطيبات', 
    subtitle: 'نسلمك مفتاح السعادة', 
    content: 'نوفر باقات تشطيب متكاملة تناسب جميع الميزانيات.', 
    image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&q=80', 
    visible: true,
    items: [
      { title: 'باقة الترا سوبر لوكس', desc: 'أعلى خامات التشطيب', img: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=800' },
      { title: 'باقة اقتصادية', desc: 'جودة عالية وسعر مناسب', img: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4f9d?w=800' }
    ]
  }
];
// --- استبدل مكون ClientProfile بهذا الكود المعدل ---
const ClientProfile = ({ user, projects, favorites, pendingUnits, mortgageRequests, onRemoveFavorite, onLogout }) => {
  const [activeTab, setActiveTab] = useState('favorites');
  
  // تصفية البيانات الخاصة بهذا العميل المحددة بالـ ID الخاص به
  const favoriteProjects = projects.filter(p => favorites.includes(p.id));
  const myUnits = pendingUnits ? pendingUnits.filter(u => u.userId === user.id) : [];
  const myMortgages = mortgageRequests ? mortgageRequests.filter(r => r.userId === user.id) : [];

  // دالة العودة للتصفح
  const handleBackToBrowsing = () => {
    window.dispatchEvent(new CustomEvent('changeTab', { detail: 'home' }));
  };

  const tabClass = (id) => `pb-2 font-bold px-4 transition-all duration-300 flex-shrink-0 ${
    activeTab === id ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'
  }`;

  return (
    <div className="max-w-7xl mx-auto p-6 animate-fade-in min-h-[60vh]">
      
      {/* زر العودة للتصفح */}
      <div className="mb-6 no-print">
        <button 
          onClick={handleBackToBrowsing} 
          className="flex items-center gap-2 text-blue-600 font-bold hover:bg-blue-50 px-4 py-2 rounded-lg transition w-fit"
        >
          <ArrowRight className="w-5 h-5" /> عودة لتصفح العقارات
        </button>
      </div>

      {/* بطاقة معلومات المستخدم - تحسين الـ Flexbox للموبايل */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-8 bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 gap-6">
        <div className="flex flex-col sm:flex-row items-center gap-4 text-center sm:text-right">
          <div className="w-16 h-16 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center text-blue-600 dark:text-blue-300 font-bold text-2xl shadow-inner">
            {user.name ? user.name[0].toUpperCase() : 'U'}
          </div>
          <div>
            <h2 className="text-2xl font-bold">مرحباً، {user.name}</h2>
            <p className="text-gray-500 dark:text-gray-400 font-mono">{user.phone || user.email}</p>
          </div>
        </div>
        <button 
          onClick={onLogout} 
          className="px-6 py-2 bg-red-50 text-red-600 rounded-lg font-bold hover:bg-red-100 transition flex items-center gap-2 w-full md:w-auto justify-center"
        >
          <LogOut className="w-5 h-5" /> تسجيل خروج
        </button>
      </div>

      {/* أزرار التبويب - قابلة للتمرير في الموبايل */}
      <div className="flex gap-4 mb-6 border-b dark:border-gray-700 pb-2 overflow-x-auto no-scrollbar">
        <button onClick={() => setActiveTab('favorites')} className={tabClass('favorites')}>
          المفضلة ({favoriteProjects.length})
        </button>
        <button onClick={() => setActiveTab('my-units')} className={tabClass('my-units')}>
          وحداتي المعروضة ({myUnits.length})
        </button>
        <button onClick={() => setActiveTab('requests')} className={tabClass('requests')}>
          طلبات التمويل ({myMortgages.length})
        </button>
      </div>

      {/* محتوى التبويبات */}
      <div className="tab-content">
        {/* 1. قائمة المفضلة */}
        {activeTab === 'favorites' && (
          favoriteProjects.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {favoriteProjects.map(p => (
                <div key={p.id} className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-md border dark:border-gray-700 relative group">
                  <div className="relative h-48 overflow-hidden">
                    <img src={p.images && p.images[0]} alt={p.name} className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-500" />
                    <button 
                      onClick={() => onRemoveFavorite(p.id)} 
                      className="absolute top-2 right-2 p-2 bg-white/90 rounded-full text-red-500 hover:bg-red-50 shadow-sm"
                      title="حذف من المفضلة"
                    >
                      <Trash2 className="w-5 h-5" />
                    </button>
                  </div>
                  <div className="p-4">
                    <h4 className="font-bold mb-1 truncate">{p.name}</h4>
                    <div className="flex items-center gap-1 text-gray-500 text-xs mb-2">
                      <MapPin size={12} /> {p.location}
                    </div>
                    <p className="text-blue-600 font-black">{p.price.toLocaleString()} ج.م</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-20 text-gray-500 border-2 border-dashed rounded-xl bg-gray-50 dark:bg-gray-800/20">
              <Star className="w-12 h-12 mx-auto mb-3 opacity-20" />
              <p>لا توجد عقارات مفضلة حالياً</p>
              <button onClick={handleBackToBrowsing} className="text-blue-600 font-bold underline mt-2">
                تصفح العقارات لإضافة بعضها
              </button>
            </div>
          )
        )}

        {/* 2. قائمة وحداتي المعروضة */}
        {activeTab === 'my-units' && (
          <div className="space-y-4">
            {myUnits.length > 0 ? myUnits.map(u => (
              <div key={u.id} className="p-4 bg-white dark:bg-gray-800 border dark:border-gray-700 rounded-xl flex flex-col sm:flex-row justify-between items-center shadow-sm gap-4 transition-hover hover:border-blue-300">
                <div className="flex items-center gap-4 w-full sm:w-auto">
                  <div className="w-16 h-16 rounded-lg bg-gray-100 overflow-hidden flex-shrink-0">
                    <img src={u.images && u.images[0]} className="w-full h-full object-cover" alt="unit" />
                  </div>
                  <div>
                    <h4 className="font-bold">{u.name}</h4>
                    <p className="text-sm text-gray-500">{u.dateSubmitted} - {u.location}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 w-full sm:w-auto justify-between">
                  <span className="font-bold text-blue-600 text-sm">{u.price?.toLocaleString()} ج.م</span>
                  <span className={`px-4 py-1.5 rounded-full text-xs font-black ${
                    u.status === 'قيد المراجعة' ? 'bg-orange-100 text-orange-700' : 'bg-green-100 text-green-700'
                  }`}>
                    {u.status || 'تحت المعالجة'}
                  </span>
                </div>
              </div>
            )) : (
              <div className="text-center py-20 text-gray-500 border-2 border-dashed rounded-xl bg-gray-50 dark:bg-gray-800/20">
                <Layout className="w-12 h-12 mx-auto mb-3 opacity-20" />
                <p>لم تقم بإضافة وحدات للبيع حتى الآن</p>
              </div>
            )}
          </div>
        )}

        {/* 3. محتوى طلبات التمويل */}
        {activeTab === 'requests' && (
          <div className="space-y-4">
            {myMortgages.length > 0 ? myMortgages.map(r => (
              <div key={r.id} className="p-5 bg-white dark:bg-gray-800 border dark:border-gray-700 rounded-xl flex flex-col sm:flex-row justify-between items-center shadow-sm gap-4">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-green-50 dark:bg-green-900/30 rounded-full text-green-600">
                    <Banknote size={24} />
                  </div>
                  <div>
                    <h4 className="font-bold">طلب تمويل: {r.name}</h4>
                    <p className="text-sm text-gray-500">ميزانية العقار: {Number(r.budget).toLocaleString()} ج.م</p>
                    <p className="text-[10px] text-gray-400 mt-1">تاريخ الطلب: {r.date}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                   <div className="flex flex-col items-end">
                      <span className="px-3 py-1 rounded-full text-xs font-bold bg-blue-100 text-blue-700">
                        {r.followUpStatus || 'لم يتم التواصل بعد'}
                      </span>
                      <span className="text-[9px] text-gray-400 mt-1 italic">سيقوم المختص بالرد قريباً</span>
                   </div>
                </div>
              </div>
            )) : (
              <div className="text-center py-20 text-gray-500 border-2 border-dashed rounded-xl bg-gray-50 dark:bg-gray-800/20">
                <ClipboardList className="w-12 h-12 mx-auto mb-3 opacity-20" />
                <p>لا توجد طلبات تمويل سابقة</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
const ScheduleVisitForm = ({ project, user, onSubmit }) => {
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [notes, setNotes] = useState('');
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // التحقق من وجود مستخدم مسجل
    if (!user) {
      toast.error('يرجى تسجيل الدخول أولاً لحجز موعد.');
      return; 
    }

    // التحقق من ملء الحقول الأساسية
    if (!date || !time) {
        toast.error('يرجى تحديد التاريخ والوقت المناسبين للمعاينة.');
        return;
    }

    // تجهيز بيانات الطلب للإرسال
    onSubmit({
      projectId: project.id,
      projectName: project.name,
      userId: user.id,
      userName: user.name,
      userPhone: user.phone || 'غير مسجل',
      date: date,
      time: time,
      notes: notes,
      timestamp: new Date().toISOString()
    });

    // إعادة تعيين الحقول بعد الإرسال الناجح
    setDate('');
    setTime('');
    setNotes('');
  };

  return (
    <div className="mt-6 p-5 bg-blue-50/50 dark:bg-gray-700/50 rounded-2xl border border-blue-100 dark:border-gray-600 shadow-inner animate-fade-in">
      <h4 className="font-bold mb-4 flex items-center gap-2 text-blue-800 dark:text-blue-300">
        <Clock className="w-5 h-5 animate-pulse" /> احجز موعد لمعاينة العقار
      </h4>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* تحسين الـ Grid ليكون عمودياً في الموبايل وأفقياً في الشاشات الأكبر */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="space-y-1">
            <label className="text-[10px] font-bold text-gray-500 mr-2">تاريخ المعاينة</label>
            <input 
              type="date" 
              required 
              min={new Date().toISOString().split('T')[0]} // منع اختيار تاريخ سابق
              className="p-3 rounded-xl border w-full dark:bg-gray-600 dark:border-gray-500 outline-none focus:ring-2 focus:ring-blue-500 transition-all shadow-sm" 
              onChange={e => setDate(e.target.value)} 
              value={date} 
            />
          </div>
          <div className="space-y-1">
            <label className="text-[10px] font-bold text-gray-500 mr-2">وقت المعاينة</label>
            <input 
              type="time" 
              required 
              className="p-3 rounded-xl border w-full dark:bg-gray-600 dark:border-gray-500 outline-none focus:ring-2 focus:ring-blue-500 transition-all shadow-sm" 
              onChange={e => setTime(e.target.value)} 
              value={time} 
            />
          </div>
        </div>

        <div className="space-y-1">
          <label className="text-[10px] font-bold text-gray-500 mr-2">ملاحظات للمندوب (اختياري)</label>
          <textarea 
            placeholder="مثال: أفضل التواصل قبل الموعد بساعة.." 
            className="p-3 rounded-xl border w-full h-24 dark:bg-gray-600 dark:border-gray-500 outline-none focus:ring-2 focus:ring-blue-500 transition-all shadow-sm resize-none" 
            onChange={e => setNotes(e.target.value)} 
            value={notes} 
          />
        </div>

        <button 
          type="submit" 
          className={`w-full py-3.5 rounded-xl font-bold transition-all transform active:scale-95 shadow-lg flex items-center justify-center gap-2 ${
            user 
            ? 'bg-blue-600 text-white hover:bg-blue-700 shadow-blue-500/20' 
            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`} 
          disabled={!user}
        >
            <CheckCircle size={18} />
            {user ? 'تأكيد إرسال طلب المعاينة' : 'سجل الدخول لإتمام الحجز'}
        </button>
        
        {!user && (
          <p className="text-[10px] text-center text-red-500 font-bold">
            يجب تسجيل الدخول ليتمكن المندوب من التواصل معك عبر رقمك المسجل.
          </p>
        )}
      </form>
    </div>
  );
};
const ActivityLogsManager = ({ darkMode }) => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterAction, setFilterAction] = useState('الكل'); // حالة الفلتر الجديد

    useEffect(() => {
        const logsRef = collection(db, "activity_logs");
        const unsub = onSnapshot(logsRef, (snapshot) => {
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            // ترتيب من الأحدث للأقدم
            setLogs(data.sort((a, b) => b.timestamp.localeCompare(a.timestamp)));
            setLoading(false);
        });
        return unsub;
    }, []);

    // 💡 منطق الفلترة
    const filteredLogs = useMemo(() => {
        if (filterAction === 'الكل') return logs;
        return logs.filter(log => log.action === filterAction);
    }, [logs, filterAction]);

    // استخراج الأنواع المتاحة تلقائياً لعرضها في القائمة
    const actionTypes = ['الكل', ...new Set(logs.map(log => log.action))];

    return (
        <div className="space-y-6 animate-fade-in">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                <h2 className="text-2xl font-bold flex items-center gap-2">
                    <ClipboardList className="text-purple-600" /> سجل عمليات النظام
                </h2>

                {/* 🔍 صندوق الفلترة */}
                <div className="flex items-center gap-2 bg-white dark:bg-gray-800 p-2 rounded-xl shadow-sm border dark:border-gray-700">
                    <span className="text-xs font-bold text-gray-500 mr-2">تصفية حسب القسم:</span>
                    <select 
                        value={filterAction} 
                        onChange={(e) => setFilterAction(e.target.value)}
                        className="bg-transparent outline-none text-sm font-bold text-blue-600 cursor-pointer"
                    >
                        {actionTypes.map(type => (
                            <option key={type} value={type} className="dark:bg-gray-800">{type}</option>
                        ))}
                    </select>
                </div>
            </div>

            <div className={`rounded-xl border shadow-sm overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white'}`}>
                <div className="overflow-x-auto">
                    <table className="w-full text-right text-sm">
                        <thead className={darkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-50 text-gray-600'}>
                            <tr>
                                <th className="p-4">المسؤول</th>
                                <th className="p-4">القسم</th>
                                <th className="p-4">التفاصيل</th>
                                <th className="p-4">الوقت والتاريخ</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y dark:divide-gray-700">
                            {filteredLogs.map(log => (
                                <tr key={log.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors">
                                    <td className="p-4">
                                        <div className="font-bold text-blue-600 dark:text-blue-400">{log.adminName}</div>
                                        <div className="text-[10px] text-gray-400 font-mono">ID: {log.adminId?.slice(0,5)}</div>
                                    </td>
                                    <td className="p-4">
                                        <span className={`px-2 py-1 rounded text-[10px] font-bold ${
                                            log.action.includes('حذف') ? 'bg-red-100 text-red-700' : 
                                            log.action.includes('إضافة') ? 'bg-green-100 text-green-700' : 'bg-purple-100 text-purple-700'
                                        }`}>
                                            {log.action}
                                        </span>
                                    </td>
                                    <td className="p-4 text-gray-600 dark:text-gray-300 leading-relaxed">
                                        {log.details}
                                    </td>
                                    <td className="p-4 text-xs">
                                        <div className="font-bold">{new Date(log.timestamp).toLocaleDateString('ar-EG')}</div>
                                        <div className="text-blue-500 font-mono">{new Date(log.timestamp).toLocaleTimeString('ar-EG', {hour: '2-digit', minute:'2-digit'})}</div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {filteredLogs.length === 0 && !loading && (
                    <div className="p-20 text-center text-gray-400">
                        <Search className="w-12 h-12 mx-auto mb-3 opacity-20" />
                        <p className="font-bold">لا توجد عمليات مسجلة لهذا القسم حالياً</p>
                    </div>
                )}
            </div>
        </div>
    );
};
// --- بداية التطبيق الرئيسي ---
const RealEstateApp = () => {
  // --- States Definitions (تعريف المتغيرات) ---
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeSection, setActiveSection] = useState('dashboard');
  const [activeClientTab, setActiveClientTab] = useState('home');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const [appMode, setAppMode] = useState('client'); 
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [visitCount, setVisitCount] = useState(0);
const logActivity = async (action, details, itemData = null) => {
    if (!user) return;
    try {
        const now = new Date();
        await addDoc(collection(db, "activity_logs"), {
            adminId: user.id,
            adminName: user.name,
            action: action, // مثال: "إضافة عقار" أو "حذف موظف"
            details: details, // نص وصفي
            fullData: itemData ? JSON.parse(JSON.stringify(itemData)) : null, // نسخة كاملة من البيانات قبل/بعد التعديل
            timestamp: now.toISOString(),
            formattedDate: now.toLocaleDateString('ar-EG'),
            formattedTime: now.toLocaleTimeString('ar-EG', { hour: '2-digit', minute: '2-digit' })
        });
    } catch (e) { console.error("Activity Log Error:", e); }
};
  // 1. تعريف البيانات (نبدأ بمصفوفات فارغة أو القيم الافتراضية للتحميل لاحقاً من Firebase)
  const [users, setUsers] = useState([]); 
  const [settings, setSettings] = useState(INITIAL_SETTINGS);
  const [sections, setSections] = useState(INITIAL_SECTIONS);
  
  const [projects, setProjects] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [sales, setSales] = useState([]);
  const [reps, setReps] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [payrollHistory, setPayrollHistory] = useState([]);
  const [pendingUnits, setPendingUnits] = useState([]);
const [dailyRecords, setDailyRecords] = useState([]);
  const [mortgageRequests, setMortgageRequests] = useState([]);
const [clientFavorites, setClientFavorites] = useState([]);
const filterDataByBranch = (dataList) => {
    if (!user || user.role === 'admin') return dataList;
    const allowedBranches = user.assignedBranches || [];

    return dataList.filter(item => {
        // إذا كان العنصر موظف (Rep)
        if (item.branch && !item.repId) return allowedBranches.includes(item.branch);
        
        // إذا كان العنصر سجل حضور (Daily Record) نربطه بفرع الموظف من المصفوفة الأصلية
        if (item.repId) {
            // ملاحظة: نستخدم المصفوفة الأصلية المسماة reps المتاحة في النطاق الأعلى
            const ownerRep = reps.find(r => String(r.id) === String(item.repId));
            return ownerRep && allowedBranches.includes(ownerRep.branch);
        }

        // أي بيانات أخرى (مبيعات، عملاء، الخ)
        const itemBranch = item.branch || item.assignedBranch;
        return allowedBranches.includes(itemBranch || 'المعادي');
    });
};
const handlePostToFacebook = async (project) => {
    if (!window.confirm(`هل أنت متأكد من نشر العقار "${project.name}" على صفحة الفيسبوك؟`)) {
        return;
    }

    const WEBHOOK_URL = "https://hook.eu1.make.com/3riiwtqq543ibnu3knjbr1dhptdhlij8"; 
    const loadingToast = toast.loading('جاري التحضير للنشر على فيسبوك...');
    
    // تصحيح تنسيق رقم الموبايل لضمان عدم تداخله مع الرموز
    const formattedMobile = project.mobile ? project.mobile.toString().replace(/\s/g, '') : "";

    const postData = {
        projectName: project.name,
        mainImage: project.images && project.images.length > 0 ? project.images[0] : "",
        postText: `🏠 عقار جديد من HOMIX Real Estate

📌 العقار: ${project.name}
📍 الموقع: ${project.location}
💰 السعر: ${project.price?.toLocaleString()} ج.م
📏 المساحة: ${project.area} متر

📝 الوصف: ${project.description}

💵 متاح تمويل عقاري 🏦

📞 للتواصل (مكالمات أو واتساب):
${formattedMobile}

#عقارات #تسويق_عقاري #تمويل_عقاري #HOMIX _RealEstate`
    };

    try {
        const response = await fetch(WEBHOOK_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(postData)
        });

        if (response.ok) {
            toast.success('تم إرسال العقار بنجاح مع إضافة تمويل عقاري!', { id: loadingToast });
        } else {
            throw new Error('فشل الإرسال لـ Webhook');
        }
    } catch (error) {
        console.error("Error sending to Facebook:", error);
        toast.error('حدث خطأ أثناء محاولة النشر', { id: loadingToast });
    }
};
 // --- دالة التبديل في المفضلة ---

  const toggleFavorite = async (e, projectId) => {
    if (e) e.stopPropagation();
    
    if (!user) {
      toast('يجب تسجيل الدخول أولاً لإضافة العقار للمفضلة', { icon: '🔑' });
      setShowLoginModal(true);
      return;
    }

    const userRef = doc(db, "users", user.id);
    const isAlreadyFavorite = clientFavorites.includes(projectId);

    try {
      if (isAlreadyFavorite) {
        await updateDoc(userRef, { favorites: arrayRemove(projectId) });
        setClientFavorites(prev => prev.filter(id => id !== projectId));
        toast.success('تمت الإزالة من المفضلة');
      } else {
        await updateDoc(userRef, { favorites: arrayUnion(projectId) });
        setClientFavorites(prev => [...prev, projectId]);
        toast.success('تمت الإضافة للمفضلة', { icon: '⭐' });
      }
    } catch (error) {
      toast.error('حدث خطأ في تحديث المفضلة');
    }
  };
const [notifications, setNotifications] = useState([]);
const sendBrowserNotification = (title, body) => {
    // 🔔 السطر المسؤول عن تشغيل الصوت
    const audio = new Audio("/notification.mp3"); 
    audio.play().catch(e => console.log("الصوت يتطلب تفاعل مع الصفحة أولاً"));

    if ("Notification" in window && Notification.permission === "granted") {
      new Notification(title, {
        body: body,
        icon: "/logo.png",
        dir: "rtl"
      });
    }
  };

// 1. مراقبة طلبات الوحدات والتمويل لإنشاء إشعارات
useEffect(() => {
  if (!user || user.role === 'client') return;

  // مراقبة الوحدات الجديدة
  const unsubUnits = onSnapshot(collection(db, "pending_units"), (snapshot) => {
  snapshot.docChanges().forEach((change) => {
    if (change.type === "added") {
      const data = change.doc.data();
      // تأكد أنها لا تزال قيد المراجعة
      if (data.status === 'قيد المراجعة') {
        toast(`طلب عرض وحدة جديد: ${data.name}`, { icon: '🏠' });
        sendBrowserNotification("طلب عرض وحدة جديد 🏠", `المالك ${data.ownerName} عرض عقار في ${data.location}`);
        
        setNotifications(prev => [{
          id: change.doc.id,
          type: 'unit',
          title: 'طلب عرض وحدة جديد',
          body: `المالك ${data.ownerName} عرض عقار في ${data.location}`,
          time: 'الآن',
          read: false
        }, ...prev]);
      }
    }

    // 💡 إذا حُذفت الوحدة من قائمة الانتظار (تمت الموافقة عليها) احذف الإشعار فوراً
    if (change.type === "removed") {
      setNotifications(prev => prev.filter(n => n.id !== change.doc.id));
    }
  });
});

  // مراقبة طلبات التمويل الجديدة
  const unsubMortgage = onSnapshot(collection(db, "mortgage_requests"), (snapshot) => {
  snapshot.docChanges().forEach((change) => {
    if (change.type === "added") {
      const data = change.doc.data();
      
      // 💡 الحل هنا: لا تضف الإشعار إلا إذا كانت الحالة "لم يتم التواصل"
      if (data.followUpStatus === 'لم يتم التواصل') {
        toast(`طلب تمويل عقاري من: ${data.name}`, { icon: '💰' });
        sendBrowserNotification("طلب تمويل عقاري جديد 💰", `العميل ${data.name} يطلب تمويل بميزانية ${data.budget}`);
        
        setNotifications(prev => [{
          id: change.doc.id,
          type: 'mortgage',
          title: 'طلب تمويل جديد',
          body: `العميل ${data.name} يطلب تمويل لميزانية ${data.budget}`,
          time: 'الآن',
          read: false
        }, ...prev]);
      }
    }
    
    // 💡 إضافة ميزة الحذف التلقائي للإشعار إذا تم تغيير الحالة في السيرفر
    if (change.type === "modified") {
      const data = change.doc.data();
      if (data.followUpStatus !== 'لم يتم التواصل') {
        setNotifications(prev => prev.filter(n => n.id !== change.doc.id));
      }
    }
  });
});
// مراقبة حجز المواعيد الجديدة (المهام)
const unsubTasks = onSnapshot(collection(db, "tasks"), (snapshot) => {
  snapshot.docChanges().forEach((change) => {
    if (change.type === "added") {
      const data = change.doc.data();
      // إذا كانت المهمة تحتوي على كلمة "طلب معاينة"
      if (data.text && data.text.includes("طلب معاينة")) {
        toast(`موعد معاينة جديد: ${data.text.split('-')[1]}`, { icon: '📅' });
        sendBrowserNotification("حجز موعد جديد 📅", data.text);
        
        setNotifications(prev => [{
          id: change.doc.id,
          type: 'task',
          title: 'موعد معاينة جديد',
          body: data.text,
          time: 'الآن',
          read: false
        }, ...prev]);
      }
    }
  });
});

// ولا تنسَ إضافتها في الـ Clean-up function بالأسفل
return () => { unsubUnits(); unsubMortgage(); unsubTasks(); };
}, [user]);

const markAsRead = (id) => {
  setNotifications(prev => prev.map(n => n.id === id ? { ...n, read: true } : n));
};
// --- (1) useEffect: جلب البيانات من Firebase (Real-time Listener Setup) ---
// هذا الكود يستمع للتغييرات في Firebase Firestore في الوقت الحقيقي
useEffect(() => {
if ("Notification" in window && Notification.permission === "default") {
        Notification.requestPermission();
      }
    const unsubscribes = [];

    // 1. مراقبة حالة المستخدم وجلب بياناته (بما فيها المفضلة)
    const unsubscribeAuth = onAuthStateChanged(auth, async (firebaseUser) => {
        if (firebaseUser) {
            const userRef = doc(db, "users", firebaseUser.uid);
            const userSnap = await getDoc(userRef);
            
            if (userSnap.exists()) {
                const fetchedUser = { id: userSnap.id, ...userSnap.data() };
                setUser(fetchedUser);
                
                // جلب المفضلة من بيانات المستخدم في الفايربيز
                setClientFavorites(fetchedUser.favorites || []);
                
                setAppMode(fetchedUser.role === 'client' ? 'client' : 'admin'); 
            } else {
                // إذا لم يوجد في Firestore (مستخدم Auth بلا بيانات)
                setUser(null);
                auth.signOut();
            }
        } else {
            setUser(null);
            setClientFavorites([]); // مسح المفضلة عند تسجيل الخروج
        }
        setLoading(false);
    });
    unsubscribes.push(unsubscribeAuth);

    // 2. دالة مساعدة لإنشاء اشتراك Real-time (onSnapshot)
    const setupRealtimeListener = (collectionName, setStateFunc) => {
        const colRef = collection(db, collectionName);
        const unsubscribe = onSnapshot(colRef, (snapshot) => {
            const data = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setStateFunc(data);
        }, (error) => {
            console.error(`Error listening to ${collectionName}:`, error);
        });
        unsubscribes.push(unsubscribe);
    };
    // 1. إنشاء الاشتراكات لمجموعات البيانات الأساسية
    setupRealtimeListener('users', setUsers);
    setupRealtimeListener('projects', setProjects);
    setupRealtimeListener('customers', setCustomers);
    setupRealtimeListener('sales', setSales);
    setupRealtimeListener('reps', setReps);
    setupRealtimeListener('tasks', setTasks);
    setupRealtimeListener('transactions', setTransactions);
    setupRealtimeListener('pending_units', setPendingUnits);
setupRealtimeListener('attendance_records', setDailyRecords);
    setupRealtimeListener('mortgage_requests', setMortgageRequests);
    setupRealtimeListener('payroll_archive', setPayrollHistory);

    // 2. جلب الإعدادات والأقسام لمرة واحدة بعد الانتهاء من الاشتراكات
    const fetchSettingsAndFinishLoading = async () => {
        try {
            // جلب الإعدادات العامة
            const settingsDoc = await getDoc(doc(db, "app_config", "general_settings"));
            if (settingsDoc.exists()) setSettings(settingsDoc.data());

            // جلب الأقسام
            const sectionsDoc = await getDoc(doc(db, "app_config", "sections_data"));
            if (sectionsDoc.exists()) setSections(sectionsDoc.data().list);
            
            // جلب عداد الزيارات
            const counterDoc = await getDoc(doc(db, "website_stats", "global_counter"));
            if (counterDoc.exists()) {
                 setVisitCount(counterDoc.data().count);
            }

        } catch (error) {
            console.error("Error fetching settings:", error);
        } finally {
            setLoading(false);
        }
    };
    
    fetchSettingsAndFinishLoading();


    // 3. دالة التنظيف (Unsubscribe) - تُستدعى عند مغادرة المكون
    return () => {
        unsubscribes.forEach(unsub => unsub()); // إلغاء جميع الاشتراكات المفتوحة
    };

}, []); // مصفوفة الاعتماديات فارغة ليعمل مرة واحدة عند الـ Mount

 // تعمل مرة واحدة عند فتح الموقع
 
  // Event Listener for Tabs
  useEffect(() => {
    const handleTabChange = (e) => setActiveClientTab(e.detail);
    window.addEventListener('changeTab', handleTabChange);
    return () => window.removeEventListener('changeTab', handleTabChange);
  }, []);
useEffect(() => {
    const handleSectionChange = (e) => setActiveSection(e.detail);
    window.addEventListener('changeSection', handleSectionChange);
    return () => window.removeEventListener('changeSection', handleSectionChange);
  }, []);
  const getAllData = () => {
    return { settings, sections, users, projects, pendingUnits, mortgageRequests, customers, sales, reps, tasks, transactions, payrollHistory };
  };
// --- (2) useEffect: تحديث عداد الزيارات ---
useEffect(() => {
    const counterRef = doc(db, "website_stats", "global_counter");
    
    // دالة Transaction لضمان الزيادة الآمنة
    const incrementVisitorCount = async () => {
        try {
            const newCount = await runTransaction(db, async (transaction) => {
                const sfDoc = await transaction.get(counterRef);
                
                let currentCount = 0;
                if (sfDoc.exists()) {
                    currentCount = sfDoc.data().count;
                }
                
                const incrementedCount = currentCount + 1;
                
                // تحديث العداد
                transaction.set(counterRef, { count: incrementedCount });
                return incrementedCount;
            });

            // تحديث حالة React
            setVisitCount(newCount);

        } catch (error) {
            console.error("فشل في تحديث عداد الزيارات:", error);
            // جلب القيمة الحالية وعرضها فقط إذا فشل التحديث
            const docSnapshot = await getDoc(counterRef);
            if (docSnapshot.exists()) {
                 setVisitCount(docSnapshot.data().count);
            }
        }
    };

    incrementVisitorCount();
}, []); // مصفوفة الاعتماديات فارغة ليعمل مرة واحدة عند الـ Mount

  // --- (2) دالة تسجيل الدخول والتسجيل الجديد ---
  // --- (2) دالة تسجيل الدخول عبر جوجل المحدثة ---
  const handleGoogleLogin = async () => {
    setLoading(true);
    try {
        const provider = new GoogleAuthProvider();
        // إعدادات إضافية لضمان فتح النافذة بشكل صحيح
        provider.setCustomParameters({ prompt: 'select_account' });
        
        const result = await signInWithPopup(auth, provider);
        const googleUser = result.user;

        // التحقق من وجود المستخدم في Firestore
        const userRef = doc(db, "users", googleUser.uid); 
        const userSnap = await getDoc(userRef);

        let finalUser;

        if (userSnap.exists()) {
            finalUser = { id: userSnap.id, ...userSnap.data() };
        } else {
            // إنشاء ملف شخصي للعميل الجديد إذا لم يكن موجوداً
            const newUserRaw = {
                name: googleUser.displayName || 'عميل جديد',
                email: googleUser.email,
                phone: googleUser.phoneNumber || 'غير مسجل', 
                role: 'client',
                status: 'active',
                permissions: [],
                favorites: [],
                createdAt: new Date().toISOString()
            };
            
            await setDoc(userRef, newUserRaw);
            finalUser = { id: googleUser.uid, ...newUserRaw };
        }
        
        setUser(finalUser); 
        setClientFavorites(finalUser.favorites || []);
        setAppMode('client'); 
        setShowLoginModal(false);
        
        toast.success(`مرحباً بك، ${finalUser.name}`, { icon: '👋' });

    } catch (error) {
        console.error("Google Auth Error Details:", error.code, error.message);
        
        // عرض رسائل خطأ مفهومة
        if (error.code === 'auth/popup-closed-by-user') {
            toast.error("تم إغلاق نافذة تسجيل الدخول قبل إتمام العملية");
        } else if (error.code === 'auth/operation-not-allowed') {
            toast.error("تسجيل دخول جوجل غير مفعل في إعدادات Firebase");
        } else {
            toast.error("فشل تسجيل الدخول عبر جوجل: " + error.message);
        }
    } finally {
        setLoading(false);
    }
  };

// 💡 2. دالة الدخول اليدوية (للموظفين/المدراء فقط) - تعمل بـ Email و Password
const handleEmployeeLogin = async (identifier, passwordInput) => {
    if (!identifier || !passwordInput) {
      return toast.error('من فضلك أدخل البيانات المطلوبة');
    }

    const loginToast = toast.loading('جاري التحقق من البيانات...');
    try {
      const usersRef = collection(db, "users");
      const q = query(
        usersRef, 
        where("email", "==", identifier), 
        where("password", "==", passwordInput), 
        where("role", "in", ['admin', 'employee'])
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const foundUser = { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
        if (foundUser.status === 'active') {
          setUser(foundUser);
          setAppMode('admin');
          setShowLoginModal(false);
          toast.success(`مرحباً بك مجدداً، ${foundUser.name}`, { id: loginToast, icon: '👋' });
        } else {
          toast.error('الحساب محظور، تواصل مع الإدارة', { id: loginToast });
        }
      } else {
        toast.error('بيانات الدخول غير صحيحة', { id: loginToast });
      }
    } catch (error) {
      toast.error('خطأ في الاتصال بالسيرفر', { id: loginToast });
    }
  };
  // دالة التسجيل الجديد للعميل مع التحقق من التكرار والحفظ في Firebase
 // 💡 3. دالة تسجيل الخروج المُحدَّثة (مهمة لحذف الجلسة)
const handleLogout = () => {
    if(window.confirm('هل أنت متأكد من تسجيل الخروج؟')) {
        auth.signOut() // 💡 مهم جداً: حذف الجلسة من Firebase Auth
            .then(() => {
                setUser(null);
                setAppMode('client');
                setActiveClientTab('home'); 
            })
            .catch((error) => {
                console.error("Logout Error:", error);
                alert("فشل تسجيل الخروج.");
            });
    }
};
const getRandomRepId = () => {
    // 💡 نعتمد على قائمة المندوبين في الـ State
    if (reps.length === 0) {
        console.warn("No reps available, cannot assign rep.");
        return null;
    }
    const availableReps = reps.filter(r => r.status === 'نشط');
    if (availableReps.length === 0) {
        console.warn("No active reps available.");
        return null;
    }
    const randomIndex = Math.floor(Math.random() * availableReps.length);
    // نضمن إرجاع ID المندوب كنص String ليتوافق مع Firestore
    return String(availableReps[randomIndex].id); 
};
const handleSaveCustomer = async (data) => {
    // 1. معالجة الإضافة الجديدة
    if (!data.id) { 
        // 💡 1.1 تعيين المندوب العشوائي إذا لم يتم اختياره يدوياً
        if (!data.repId) { 
            data.repId = getRandomRepId();
        }
        
        // 💡 1.2 التأكد من أن repId هو نص قبل الحفظ
        data.repId = String(data.repId);
        
        // 💡 1.3 حفظ العميل الجديد في Firebase
        try {
            const docRef = await addDoc(collection(db, "customers"), { 
                ...data, 
                createdAt: new Date().toISOString(),
                repId: data.repId || null 
            });
            // تحديث الـ State مؤقتاً (onSnapshot ستقوم بالباقي)
            // ملاحظة: مع onSnapshot، هذا السطر ليس ضرورياً تماماً، لكنه لا يضر.
            setCustomers([...customers, { ...data, id: docRef.id }]); 
            alert('تم تسجيل العميل الجديد وربطه بمندوب.');
        } catch(e) {
            console.error("Error adding customer:", e);
            alert("فشل في إضافة العميل.");
        }
        
    } else {
        // 2. معالجة التعديل (فقط تحديث البيانات الحالية)
        try {
            data.repId = String(data.repId); 
            const customerRef = doc(db, "customers", String(data.id));
            await updateDoc(customerRef, data);
// تسجيل تحديث الإجراءات في السجل
            if (data.steps && data.steps.length > 0) {
                const lastStep = MORTGAGE_STEPS.find(s => s.id === data.steps[data.steps.length-1])?.label;
                logActivity("متابعة إجراءات", `تحديث إجراءات العميل (${data.name}) - آخر مرحلة: ${lastStep}`);
            }
            alert('تم تعديل بيانات العميل.');
            
        } catch(e) {
            console.error("Error updating customer:", e);
            alert("فشل في تعديل العميل.");
        }
    }
};    
 const handleAddUnitSubmit = async (unitData) => {
    // 💡 التحقق من وجود ملفات فعلية للرفع
    if (!unitData.rawFiles || unitData.rawFiles.length === 0) {
        alert("يرجى إرفاق صور العقار قبل الإرسال.");
        return false; // نرجع False للإشارة إلى فشل العملية
    }

    // عرض رسالة انتظار للمستخدم أثناء الرفع
    const loadingToast = toast.loading('جاري رفع الصور وحفظ البيانات...');

    try {
        const uploadedImageUrls = [];
        
        // 1. استخدام Promise.all مع map لضمان رفع جميع الصور بالتوازي وبشكل صحيح
        const uploadPromises = unitData.rawFiles.map(async (file) => {
            // إنشاء مسار فريد لكل ملف في Firebase Storage
            const storageRef = ref(storage, `project_units/${Date.now()}_${file.name}`);
            
            // رفع الملف الفعلي
            const snapshot = await uploadBytes(storageRef, file);
            
            // الحصول على الرابط الدائم (Download URL)
            const downloadURL = await getDownloadURL(snapshot.ref);
            
            // إضافة الرابط للمصفوفة النهائية
            return downloadURL;
        });

        // انتظار انتهاء جميع عمليات الرفع بنجاح
        const finalImageUrls = await Promise.all(uploadPromises);

        // 2. تجهيز كائن البيانات النهائي للحفظ في Firestore (pending_units)
        const newUnit = { 
            name: unitData.name, 
            location: unitData.location, 
            category: unitData.category, 
            price: Number(unitData.price), 
            area: Number(unitData.area),
            ownerName: unitData.ownerName, 
            ownerPhone: unitData.ownerPhone, 
            description: unitData.description,
            // استخدام روابط الـ Storage الدائمة بدلاً من الروابط المؤقتة
            images: finalImageUrls, 
            // ربط الطلب بالمعرف الخاص بالمستخدم الحالي
            userId: user ? user.id : 'guest',
            status: 'قيد المراجعة', // الحالة الافتراضية عند الإضافة من قبل العميل
            dateSubmitted: new Date().toISOString().split('T')[0],
            createdAt: new Date().toISOString() // تاريخ دقيق للترتيب الزمني
        };
        
        // 3. إضافة المستند إلى مجموعة (pending_units) في Firestore
        const docRef = await addDoc(collection(db, "pending_units"), newUnit);
        
        // 4. إغلاق رسالة التحميل وعرض رسالة نجاح
        toast.success("تم إرسال وحدتك للمراجعة بنجاح!", { id: loadingToast });
        alert("تم إرسال وحدتك للمراجعة بنجاح! سيقوم فريق الإدارة بمراجعة الطلب ونشره قريباً.");
        
        return true; // العودة بـ True لإغلاق النموذج أو مسح البيانات في المكون الرئيسي
        
    } catch (error) {
        console.error("خطأ أثناء رفع الصور أو حفظ الطلب:", error);
        toast.error("حدث خطأ أثناء الإرسال: " + error.message, { id: loadingToast });
        alert("حدث خطأ أثناء الإرسال. تأكد من اتصال الإنترنت وأن لديك صلاحية رفع الملفات.");
        return false;
    }
};
  // --- في دالة handleMortgageRequestSubmit ---
// في دالة RealEstateApp
const handleMortgageRequestSubmit = async (requestData) => {
    const loadingToast = toast.loading('جاري إرسال طلبك...');
    try {
      const newRequest = { 
        ...requestData, 
        followUpStatus: 'لم يتم التواصل',
        date: new Date().toISOString().split('T')[0],
        userId: user ? user.id : 'guest'
      };
      
      await addDoc(collection(db, "mortgage_requests"), newRequest);
      setMortgageRequests([{ ...newRequest, id: Date.now() }, ...mortgageRequests]);
      
      toast.success('تم إرسال طلب التمويل بنجاح، سنتواصل معك قريباً!', { id: loadingToast });
    } catch (error) {
      toast.error('عفواً، فشل إرسال الطلب', { id: loadingToast });
    }
  };
const handleSaveSettings = async (newSettings) => {
    try {
        const settingsRef = doc(db, "app_config", "general_settings");
        
        // التأكد من أن footerLinks موجودة ولا تضيع أثناء الحفظ
        const finalSettings = {
            ...settings, // الإعدادات القديمة
            ...newSettings, // الإعدادات الجديدة المعدلة
            footerLinks: newSettings.footerLinks || settings.footerLinks || INITIAL_SETTINGS.footerLinks
        };

        await setDoc(settingsRef, finalSettings, { merge: true });

        setSettings(finalSettings); 
        toast.success("تم حفظ إعدادات الموقع بنجاح");
    } catch (error) {
        console.error("Error saving settings:", error);
        toast.error("فشل حفظ الإعدادات");
    }
};  // --- (جديد) دالة معالجة طلب المعاينة ---
  const handleScheduleSubmit = async (requestData) => {
      try {
        const newTask = {
            // صياغة النص لتظهر واضحة في قائمة المهام
            text: `📅 موعد معاينة: ${requestData.projectName} | العميل: ${requestData.userName} | هاتف: ${requestData.userPhone} | الموعد: ${requestData.date} الساعة ${requestData.time}`,
            assignedTo: [], 
            status: 'جديد',
            date: new Date().toISOString().split('T')[0],
            type: 'معاينة'
        };
        await addDoc(collection(db, "tasks"), newTask);
        toast.success('تم تسجيل طلب المعاينة في قائمة المهام');
      } catch (error) {
        toast.error("فشل الحجز، حاول مرة أخرى");
      }
  };

  // --- بداية الـ Render ---
  if (loading) return <LoadingScreen />;
  
// (تحديث) تمرير handleRegister وقائمة المستخدمين users للمودال
  if (showLoginModal && !user) return (
    <LoginScreen 
        users={users} 
        onLogin={handleEmployeeLogin} // 💡 للموظفين فقط
        onRegister={() => alert('التسجيل اليدوي للعملاء غير متاح. يرجى استخدام جوجل للتسجيل.')} // 💡 تم تعديل الدالة لتعرض تنبيه فقط
        onCancel={() => setShowLoginModal(false)} 
        onGoogleLogin={handleGoogleLogin} // 💡 تمرير دالة جوجل الجديدة
    />
);
  const appStyle = {
    fontFamily: settings.fontType === 'serif' ? 'Times New Roman, serif' : 'Segoe UI, Tahoma, sans-serif',
    '--primary-color': settings.primaryColor,
  };

return (
    <div dir="rtl" className={`min-h-screen flex flex-col transition-colors duration-300 
      ${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-gray-50 text-gray-900'}`} style={appStyle}>
      
      {/* 💡 السطر المضاف لتفعيل تنسيقات الموبايل والـ Snap Scroll */}
      <GlobalStyles /> 

      <Toaster 
        position="top-center" 
        reverseOrder={false} 
        toastOptions={{
          style: {
            borderRadius: '12px',
            background: darkMode ? '#1f2937' : '#ffffff',
            color: darkMode ? '#ffffff' : '#1f2937',
            fontFamily: 'inherit',
            fontWeight: 'bold',
            direction: 'rtl'
          }
        }}
      />

      <Header 
        user={user} 
        onLogout={handleLogout} 
        onLoginClick={() => setShowLoginModal(true)}
        onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
        darkMode={darkMode} 
        onToggleDarkMode={() => setDarkMode(!darkMode)}
        appMode={appMode} 
        setAppMode={setAppMode}
        settings={settings}
        visitCount={visitCount}
        notifications={notifications}
        onMarkAsRead={markAsRead}
        onClearAllNotifications={() => setNotifications([])} // خاصية مضافة للمنطق
        onDeleteNotification={(id) => setNotifications(prev => prev.filter(n => n.id !== id))}
        activeTab={appMode === 'admin' ? activeSection : activeClientTab}
      />      

      {/* المحتوى الرئيسي للموقع */}
      <div className="flex-1 flex overflow-hidden relative">
        {appMode === 'admin' && user ? (
          /* 🛠️ وضع الإدارة: ترتيب جانبي (Sidebar + Main) */
          /* تم إضافة w-full لضمان ملء المساحة العرضية بالكامل */
          <div className="flex flex-1 w-full overflow-hidden">
            <Sidebar 
                isOpen={isSidebarOpen} 
                activeSection={activeSection} 
                onSectionChange={setActiveSection} 
                onClose={() => setIsSidebarOpen(false)} 
                darkMode={darkMode} 
                settings={settings}
                pendingCount={pendingUnits.length}
requestCount={mortgageRequests.filter(req => req.followUpStatus === 'لم يتم التواصل').length}                user={user}
            />
            
            {/* الجزء الخاص بعرض محتوى القوائم في الإدارة - تم إضافة flex-1 و min-w-0 لإصلاح العرض الجانبي */}
            <main className="flex-1 flex flex-col min-w-0 overflow-y-auto bg-gray-50 dark:bg-gray-900/50 p-4 md:p-6 pb-24">
              {/* max-w-full تضمن عدم تقيد الجداول بعرض ضيق */}
              <div className="w-full max-w-full mx-auto">
                {activeSection === 'dashboard' && (
  <Dashboard 
    projects={projects} 
    pendingUnits={pendingUnits} 
    mortgageRequests={mortgageRequests} 
    customers={filterDataByBranch(customers)} // 👈 تصفية العملاء
    transactions={filterDataByBranch(transactions)} // 👈 تصفية المالية
    sales={filterDataByBranch(sales)} // 👈 تصفية المبيعات
    darkMode={darkMode} 
  />
)}
                {activeSection === 'pending-units' && <PendingUnitsManager pendingUnits={pendingUnits} setPendingUnits={setPendingUnits} projects={projects} setProjects={setProjects} darkMode={darkMode} customers={customers} setCustomers={setCustomers} />}
               
{activeSection === 'mortgage-requests' && (
  <MortgageRequestsManager 
    mortgageRequests={mortgageRequests} 
    setMortgageRequests={setMortgageRequests} 
    reps={reps} // 👈 هذه أهم نقطة لظهور قائمة الأسماء
    setProjects={setProjects} 
    darkMode={darkMode} 
    logActivity={logActivity} 
  />
)}                {activeSection === 'deal-closing' && (
  <DealClosingManager 
    customers={customers} 
    setCustomers={setCustomers} 
    reps={reps} 
    sales={sales} 
    setSales={setSales} 
    transactions={transactions} 
    setTransactions={setTransactions} 
    darkMode={darkMode} 
    logActivity={logActivity} 
  />
)}
                {activeSection === 'projects' && (
  <ProjectsManager 
    projects={projects} 
    setProjects={setProjects} 
    darkMode={darkMode} 
    logActivity={logActivity} 
  />
)}
                {activeSection === 'customers' && (
  <CustomersManager 
    customers={filterDataByBranch(customers)} // 👈 عملاء فرعه فقط
    setCustomers={setCustomers} 
    reps={filterDataByBranch(reps)}           // 👈 المناديب المتاحين من فرعه فقط
    sales={filterDataByBranch(sales)} 
    setSales={setSales} 
    transactions={filterDataByBranch(transactions)} 
    setTransactions={setTransactions} 
    darkMode={darkMode} 
    onSaveCustomer={handleSaveCustomer} 
    logActivity={logActivity} 
  />
)}
                {activeSection === 'sales' && (
  <SalesManager 
    sales={filterDataByBranch(sales)}      // 👈 عقود فرعه فقط
    setSales={setSales} 
    projects={projects}                    // العقارات تبقى عامة (غالباً)
    customers={filterDataByBranch(customers)} // 👈 عملاء فرعه فقط
    reps={filterDataByBranch(reps)}           // 👈 مناديب فرعه فقط
    darkMode={darkMode} 
    logActivity={logActivity} 
  />
)}
                {activeSection === 'team' && (
  <TeamManager 
    reps={filterDataByBranch(reps)} 
    setReps={setReps} 
    tasks={tasks} 
    setTasks={setTasks} 
    sales={filterDataByBranch(sales)} 
    payrollHistory={payrollHistory} 
    setPayrollHistory={setPayrollHistory} 
    setTransactions={setTransactions} 
    transactions={filterDataByBranch(transactions)} 
    darkMode={darkMode}
    filterDataByBranch={filterDataByBranch}
    user={user}
    dailyRecords={filterDataByBranch(dailyRecords)} // 👈 مرر المتغير هنا
  />
)}
                {activeSection === 'accounting' && (
  <AccountingManager 
    transactions={filterDataByBranch(transactions)} // 👈 معاملات فرعه فقط
    setTransactions={setTransactions} 
    sales={filterDataByBranch(sales)}               // 👈 مبيعات فرعه فقط
    reps={filterDataByBranch(reps)}                // 👈 مناديب فرعه فقط
    darkMode={darkMode} 
    logActivity={logActivity}
    user={user} 
  />
)}
                {activeSection === 'reports' && (
                  <div className="space-y-10 animate-fade-in w-full">
                      <div className="flex flex-col md:flex-row justify-between items-center gap-4 no-print">
                        <div>
                          <h2 className="text-3xl font-black flex items-center gap-3 text-gray-800 dark:text-white">
                              <PieChart className="text-purple-600 w-8 h-8" /> مركز الاستخبارات المالية
                          </h2>
                          <p className="text-sm text-gray-500 mr-11">تحليل بيانات الفروع والمناديب وتدفقات السيولة</p>
                        </div>
                        <div className="flex gap-2">
                          <button onClick={() => window.print()} className="bg-gray-800 text-white px-5 py-2.5 rounded-xl font-bold text-sm flex items-center gap-2 hover:bg-black transition shadow-lg">
                              <Download size={18} /> استخراج التقرير
                          </button>
                        </div>
                      </div>

                      {/* 1. قسم تحليل الفروع المخصص للمحترفين */}
                      <section className="space-y-4">
                        <h3 className="font-bold text-lg flex items-center gap-2 mr-2 text-gray-700 dark:text-gray-300">
                          <Landmark className="text-blue-600" size={20} /> تحليل الموقف المالي لكل فرع
                        </h3>
                        <BranchFinancialPro 
                          transactions={transactions} 
                          sales={sales} 
                          darkMode={darkMode} 
                        />
                      </section>

                      {/* 2. قسم تحليل المناديب وبطل الشهر */}
                      <section className="space-y-4">
                        <h3 className="font-bold text-lg flex items-center gap-2 mr-2 text-gray-700 dark:text-gray-300">
                          <TrendingUp className="text-green-600" size={20} /> أداء الفريق والمجموعات
                        </h3>
                        <DetailedTeamAnalytics 
                            transactions={transactions} 
                            sales={sales} 
                            reps={reps} 
                            darkMode={darkMode} 
                        />
                      </section>

                      {/* 3. الرسوم البيانية للتدفق النقدي */}
                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                          <div className={`p-8 rounded-[2.5rem] border shadow-sm ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'}`}>
                              <h3 className="font-bold text-xl mb-6 flex items-center gap-2 text-blue-600">
                                 <Activity size={24} /> منحنى التدفق النقدي العام
                              </h3>
                              <FinanceBarChart 
                                  income={transactions.filter(t => t.type === 'income').reduce((acc, t) => acc + (Number(t.amount) || 0), 0)} 
                                  expense={transactions.filter(t => t.type === 'expense').reduce((acc, t) => acc + (Number(t.amount) || 0), 0)} 
                                  darkMode={darkMode} 
                              />
                          </div>
                          
                          {/* ملخص إضافي */}
                          <div className={`p-2`}>
                            <FinancialAnalytics 
                                transactions={transactions} 
                                sales={sales} 
                                reps={reps} 
                                darkMode={darkMode} 
                            />
                          </div>
                      </div>
                  </div>
                )}
{activeSection === 'logs' && hasPermission(user, PERMISSIONS.VIEW_LOGS) && (
  <ActivityLogsManager darkMode={darkMode} />
)}
                {activeSection === 'settings' && (
                  <SettingsManager 
                    settings={settings} 
                    setSettings={setSettings} 
                    sections={sections} 
                    setSections={setSections} 
                    users={users} 
                    setUsers={setUsers} 
                    darkMode={darkMode} 
                    getAllData={getAllData}
                    onSaveSettings={handleSaveSettings}
                  />
                )}
              </div>
            </main>
          </div>
        ) : (
          /* 🏠 وضع العميل: شاشة كاملة عمودية (Content + Footer) */
          <div className="flex-1 flex flex-col w-full overflow-y-auto bg-white dark:bg-gray-900">
            <div className="flex-1">
              <ClientView 
                projects={projects} 
                reps={reps}
                onPostToFacebook={handlePostToFacebook} 
                settings={{
                    ...settings,
                    onLogout: handleLogout,
                    onScheduleSubmit: handleScheduleSubmit
                }} 
                sections={sections} 
                darkMode={darkMode} 
                activeTab={activeClientTab} 
                onAddUnitSubmit={handleAddUnitSubmit} 
                onMortgageRequestSubmit={handleMortgageRequestSubmit}
                clientFavorites={clientFavorites}
                toggleFavorite={toggleFavorite}
                user={user} 
                pendingUnits={pendingUnits} 
                mortgageRequests={mortgageRequests} 
              />
            </div>
            
            {/* استدعاء الفوتر المتقدم ليظهر أسفل محتوى العميل */}
            <AdvancedFooter settings={settings} darkMode={darkMode} />
          </div>
        )}
      </div>

      {/* الزر العائم للتواصل يظهر فقط في وضع العميل */}
      {appMode === 'client' && <FloatingContactButtons settings={settings} />}
    </div>
  );
};

export default RealEstateApp;